import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: { input: any; output: any; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: any; output: any; }
  /** A datetime and timezone string in ISO 8601 format `Y-m-dTH:i:sO`, e.g. `2020-04-20T13:53:12+02:00`. */
  DateTimeTz: { input: any; output: any; }
  /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
  Upload: { input: any; output: any; }
  /** 年月: YYYYMM */
  Year: { input: any; output: any; }
  /** 年月: YYYYMM */
  YearMonth: { input: any; output: any; }
};

export type ActiveCreatorsInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

/** 所属 */
export type Affiliation = {
  __typename?: 'Affiliation';
  /** 所属に登録されているクリエイター数(ACTIVEのみ) */
  active_creators_count?: Maybe<Scalars['Int']['output']>;
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** 所属に登録されているクリエイター数(LEAVE以外) */
  creators_count?: Maybe<Scalars['Int']['output']>;
  /** 所属ID */
  id: Scalars['ID']['output'];
  /** 所属の名前 */
  name: Scalars['String']['output'];
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Affiliation items. */
export type AffiliationPaginator = {
  __typename?: 'AffiliationPaginator';
  /** A list of Affiliation items. */
  data: Array<Affiliation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** 所属毎の月別売上 */
export type AffiliationSaleThisMonth = {
  __typename?: 'AffiliationSaleThisMonth';
  affiliation?: Maybe<Affiliation>;
  sale_this_month?: Maybe<SalesPerMonth>;
};

/** 所属毎の月別売上 */
export type AffiliationSalesPerMonth = {
  __typename?: 'AffiliationSalesPerMonth';
  affiliation?: Maybe<Affiliation>;
  sales_per_month: Array<SalesPerMonth>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

/** 注文(ユーザ側には参照させない) SQL集計結果用 */
export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  /** 納品日 */
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  /** 注文商品ID */
  id: Scalars['ID']['output'];
  /** 動画の長さ */
  movie_seconds?: Maybe<Scalars['Int']['output']>;
  /** 注文ID */
  order_id: Scalars['ID']['output'];
  /** 支払日 */
  paid_at: Scalars['DateTime']['output'];
  /** 注文した商品 */
  product: Product;
  /** 商品名 */
  product_name: Scalars['String']['output'];
  /** 商品の種類 */
  product_type: ProductType;
  /** 注文商品ステータス */
  status: OrderStatus;
  /** 注文したユーザー */
  user: User;
  /** 購入ユーザー名 */
  user_name: Scalars['String']['output'];
};

export type BusinessResendCreatorAccountUpdateInput = {
  email: Scalars['String']['input'];
};

/** ビジネス毎の月別売上 */
export type BusinessSalesPerMonth = {
  __typename?: 'BusinessSalesPerMonth';
  sales_per_month: Array<SalesPerMonth>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

/** ビジネスユーザー */
export type BusinessUser = {
  __typename?: 'BusinessUser';
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** ビジネスユーザーのメールアドレス */
  email: Scalars['String']['output'];
  /** ビジネスユーザーID */
  id: Scalars['ID']['output'];
  /** ビジネスユーザーの名前 */
  name: Scalars['String']['output'];
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
};

/** Business user account status */
export enum BusinessUserAccountStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Leave */
  Leave = 'LEAVE',
  /** Suspend */
  Suspend = 'SUSPEND'
}

/** クリエイター */
export type Creator = {
  __typename?: 'Creator';
  /** 所属 */
  affiliation?: Maybe<Affiliation>;
  /** 所属ID */
  affiliation_id?: Maybe<Scalars['ID']['output']>;
  /** ビジネスID */
  business_id: Scalars['ID']['output'];
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** クリエイターのメールアドレス */
  email: Scalars['String']['output'];
  /** お気に入り人数 */
  favorite_users_count: Scalars['Int']['output'];
  /** クリエイターのアイコンURL */
  icon_url: Scalars['String']['output'];
  /** クリエイターID */
  id: Scalars['ID']['output'];
  /** クリエイターのInstagramユーザー名 */
  instagram_username: Scalars['String']['output'];
  /** クリエイターをお気に入り済みか */
  is_favorite?: Maybe<Scalars['Boolean']['output']>;
  /** クリエイターのKindle著者URL */
  kindle_author_url: Scalars['String']['output'];
  /** クリエイターの退会日 */
  left_at?: Maybe<Scalars['DateTime']['output']>;
  /** クリエイターの名前 */
  name: Scalars['String']['output'];
  /** クリエイターのプロフィール */
  profile: Scalars['String']['output'];
  /** クリエイターのステータス */
  status: CreatorAccountStatus;
  /** クリエイターのステータス名 */
  status_name: Scalars['String']['output'];
  /** クリエイターのTwitterユーザー名 */
  twitter_username: Scalars['String']['output'];
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
  /** クリエイターのYouTubeチャンネルURL */
  youtube_channel_url: Scalars['String']['output'];
};

/** Creator account status */
export enum CreatorAccountStatus {
  /** 有効 */
  Active = 'ACTIVE',
  /** 退会 */
  Leave = 'LEAVE',
  /** 登録依頼中 */
  Request = 'REQUEST',
  /** 停止 */
  Suspend = 'SUSPEND'
}

/** Creator category */
export enum CreatorCategory {
  /** 女優 */
  Actress = 'ACTRESS',
  /** アイドル */
  Idol = 'IDOL',
  /** メイド */
  Maid = 'MAID',
  /** モデル */
  Model = 'MODEL',
  /** グラビア */
  PinupModel = 'PINUP_MODEL',
  /** 動画配信（ライバー、ユーチューバー） */
  Streamer = 'STREAMER'
}

/** クリエイターマイページ */
export type CreatorMypage = {
  __typename?: 'CreatorMypage';
  /** クリエイター情報 */
  creator: Creator;
  /** 非表示の商品 */
  disabled_products?: Maybe<Array<Maybe<Product>>>;
  /** 公開中の商品 */
  published_products?: Maybe<Array<Maybe<Product>>>;
  /** 公開日時指定商品 */
  reserved_products?: Maybe<Array<Maybe<Product>>>;
  /** 今月の売上 */
  sales?: Maybe<SalesPerMonth>;
};

/** A paginated list of Creator items. */
export type CreatorPaginator = {
  __typename?: 'CreatorPaginator';
  /** A list of Creator items. */
  data: Array<Creator>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** ユーザー購入ランキング */
export type CreatorPurchaseUserRanking = {
  __typename?: 'CreatorPurchaseUserRanking';
  /** 購入金額 */
  amount: Scalars['Int']['output'];
  /** 購入枚数 */
  purchase_count: Scalars['Int']['output'];
  /** ユーザーのTwitterユーザーネーム */
  twitter_username?: Maybe<Scalars['String']['output']>;
  /** ユーザーID */
  user_id: Scalars['Int']['output'];
  /** ユーザーの名前 */
  user_name: Scalars['String']['output'];
};

/** クリエイターランキング */
export type CreatorRanking = {
  __typename?: 'CreatorRanking';
  /** クリエイター */
  creator: Creator;
  /** ランキング */
  rank: Scalars['Int']['output'];
};

export type CreatorRankingInput = {
  limit: Scalars['Int']['input'];
};

/** Creator reminder delivery type */
export enum CreatorReminderDeliveryType {
  /** Limit 1day ago */
  Limit_1DayAgo = 'LIMIT_1DAY_AGO',
  /** Limit 1hour ago */
  Limit_1HourAgo = 'LIMIT_1HOUR_AGO',
  /** Limit after */
  LimitAfter = 'LIMIT_AFTER'
}

/** クリエイター毎の月別売上 */
export type CreatorSalesPerMonth = {
  __typename?: 'CreatorSalesPerMonth';
  sales_per_month: Array<SalesPerMonth>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

export type CreatorSalesPerMonthInYearInput = {
  /** YYYY 未指定の場合は直近12ヶ月のデータを取得 */
  year?: InputMaybe<Scalars['Year']['input']>;
};

export type CurrentCreatorUpdateAccountInput = {
  email: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['Upload']['input']>;
  instagram_username?: InputMaybe<Scalars['String']['input']>;
  kindle_author_url?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  twitter_username?: InputMaybe<Scalars['String']['input']>;
  youtube_channel_url?: InputMaybe<Scalars['String']['input']>;
};

/** 納品済み商品 */
export type DeliveredProduct = {
  __typename?: 'DeliveredProduct';
  /** 登録日 */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** 納品時刻 */
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  /** 作成済み商品のサムネイルのパス */
  delivered_product_thumbnail_url?: Maybe<Scalars['String']['output']>;
  /** 作成済み商品の保存パス */
  delivered_product_url?: Maybe<Scalars['String']['output']>;
  /** 納品済み商品ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** 注文済み商品ID */
  ordered_product_id?: Maybe<Scalars['ID']['output']>;
  /** ダウンロードのパス */
  temporary_download_url?: Maybe<Scalars['String']['output']>;
  /** 更新日 */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DeliveryMovieProductInput = {
  delivery_movie_path: Scalars['String']['input'];
  ordered_product_id: Scalars['ID']['input'];
};

export type DeliveryPhotoProductInput = {
  delivery_photo_file: Scalars['Upload']['input'];
  ordered_product_id: Scalars['ID']['input'];
};

export type EditAffiliationInput = {
  affiliation_name: Scalars['String']['input'];
};

/** Exception category */
export enum ExceptionCategory {
  /** System */
  System = 'SYSTEM',
  /** User */
  User = 'USER'
}

export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorInput = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  /** 全所属対象。has_all_affiliationが有効な場合、affiliation_idとcreator_idの指定は無視されます */
  has_all_affiliation: Scalars['Boolean']['input'];
  year_month?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type GenerateTemporaryUrlForFilteredMonthlySalesInput = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  /** 全所属対象。has_all_affiliationが有効な場合、affiliation_idとcreator_idの指定は無視されます */
  has_all_affiliation: Scalars['Boolean']['input'];
  year_month?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type GenerateTemporaryUrlForMonthlySalesByCreatorInput = {
  year_month?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type GenerateTemporaryUrlForMonthlySalesInput = {
  year_month: Scalars['YearMonth']['input'];
};

/** Kawaii collection model */
export enum KawaiiCollectionModel {
  /** Aichi */
  Aichi = 'AICHI',
  /** Kansai */
  Kansai = 'KANSAI',
  /** Kyushu */
  Kyushu = 'KYUSHU',
  /** Sapporo */
  Sapporo = 'SAPPORO',
  /** Tokyo */
  Tokyo = 'TOKYO'
}

/** ログイン情報 */
export type LoginData = {
  __typename?: 'LoginData';
  token?: Maybe<Scalars['String']['output']>;
  ttl?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Media convert job status */
export enum MediaConvertJobStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Complete */
  Complete = 'COMPLETE',
  /** Error */
  Error = 'ERROR',
  /** Init */
  Init = 'INIT',
  /** Progressing */
  Progressing = 'PROGRESSING',
  /** Submitted */
  Submitted = 'SUBMITTED'
}

/** 動画アップロードに必要な情報 */
export type MovieProductUpload = {
  __typename?: 'MovieProductUpload';
  /** 動画アップロードするパス */
  upload_file_path?: Maybe<Scalars['String']['output']>;
  /** 動画アップロードするURL */
  upload_url?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** [ビジネス]クリエイターのメール変更を再送するミューテーション */
  BusinessResendCreatorAccountUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** [クリエイター]ライブトークのルームに参加した時のミューテーション */
  CreatorDeliveryLiveTalkProduct: Scalars['Boolean']['output'];
  /** [クリエイター]動画の商品を納品をするミューテーション */
  CreatorDeliveryMovieProduct: Scalars['Boolean']['output'];
  /** [クリエイター]クリエイターが商品を納品をするミューテーション */
  CreatorDeliveryPhotoProduct: Scalars['Boolean']['output'];
  /** [クリエイター]商品を非表示にするミューテーション */
  CreatorDisableProduct?: Maybe<Scalars['Boolean']['output']>;
  /** [クリエイター]商品を表示にするミューテーション */
  CreatorDisplayProduct?: Maybe<Scalars['Boolean']['output']>;
  /** [クリエイター]公開中の商品を販売終了にするミューテーション */
  CreatorFinishProduct: Scalars['Boolean']['output'];
  /** [ゲスト]クリエイターのパスワードをリセットするミューテーション */
  CreatorPasswordReset: Scalars['Boolean']['output'];
  /** [クリエイター]ライブトークの商品登録をするミューテーション */
  CreatorRegisterLiveTalkProduct: Scalars['Boolean']['output'];
  /** [クリエイター]動画の商品登録をするミューテーション */
  CreatorRegisterMovieProduct: Scalars['Boolean']['output'];
  /** [クリエイター]写真の商品登録をするミューテーション */
  CreatorRegisterPhotoProduct: Scalars['Boolean']['output'];
  /** [クリエイター]クリエイターのパスワードを更新するミューテーション */
  CreatorUpdatePassword?: Maybe<Scalars['Boolean']['output']>;
  /** [クリエイター]現在ログインしているクリエイターを更新する */
  CurrentCreatorUpdateAccount?: Maybe<UpdatedCreator>;
  /** [ビジネス]仮登録中のクリエイターのアカウント削除するミューテーション */
  DeleteCreatorAccount?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]ビジネスユーザーがクリエイターに代わりライブトークのルームに参加した時のミューテーション */
  DeliveryLiveTalkProductByBusinessUser: Scalars['Boolean']['output'];
  /** [ビジネス]ビジネスユーザーがクリエイターに代わり動画の商品を納品をするミューテーション */
  DeliveryMovieProductByBusinessUser: Scalars['Boolean']['output'];
  /** [ビジネス]ビジネスユーザーがクリエイターに代わり写真の商品を納品をするミューテーション */
  DeliveryPhotoProductByBusinessUser: Scalars['Boolean']['output'];
  /** [ビジネス]商品を非表示にするミューテーション */
  DisableProduct?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]商品を表示にするミューテーション */
  DisplayProduct?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]所属を更新するミューテーション */
  EditAffiliation?: Maybe<Affiliation>;
  /** [ユーザー]クリエイターお気に入り登録するミューテーション */
  FavoriteCreator?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]商品を販売終了にするミューテーション */
  FinishProduct?: Maybe<Scalars['Boolean']['output']>;
  /** [ゲスト]ビジネスユーザーとしてログインするミューテーション */
  LoginBusinessUser?: Maybe<LoginData>;
  /** [ゲスト]クリエイターとしてログインするミューテーション */
  LoginCreator?: Maybe<LoginData>;
  /** [ゲスト]一般ユーザーとしてログインするミューテーション */
  LoginUser?: Maybe<LoginData>;
  /** [ビジネス]ログアウトするミューテーション */
  LogoutBusinessUser?: Maybe<Scalars['Boolean']['output']>;
  /** [クリエイター]ログアウトするミューテーション */
  LogoutCreator?: Maybe<Scalars['Boolean']['output']>;
  /** [ユーザー]ログアウトするミューテーション */
  LogoutUser?: Maybe<Scalars['Boolean']['output']>;
  /** [ゲスト]ビジネスユーザーのパスワードをリセットするミューテーション */
  PasswordResetBusinessUser?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]新規所属登録ミューテーション */
  RegisterAffiliation?: Maybe<Affiliation>;
  /** [ビジネス]ビジネスユーザーがクリエイターに代わりライブトークの商品登録をするミューテーション */
  RegisterLiveTalkProductByBusinessUser: Scalars['Boolean']['output'];
  /** [ビジネス]ビジネスユーザーがクリエイターに代わり写真の商品登録をするミューテーション */
  RegisterMovieProductByBusinessUser: Scalars['Boolean']['output'];
  /** [ビジネス]新規クリエイター登録ミューテーション */
  RegisterNewCreator?: Maybe<Creator>;
  /** [ビジネス]ビジネスユーザーがクリエイターに代わり写真の商品登録をするミューテーション */
  RegisterPhotoProductByBusinessUser: Scalars['Boolean']['output'];
  /** [ビジネス]アカウント登録メールをクリエイターへ再送するミューテーション */
  ResendCreatorAccountRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]メールアドレス更新時の認証メールを再送するミューテーション */
  ResendEmailForVerifyingUpdatedBusinessUserEmail?: Maybe<Scalars['Boolean']['output']>;
  /** [ユーザー]アカウント登録メールをユーザーへ再送するミューテーション */
  ResendUserAccountRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** [ユーザー]クリエイターお気に入り登録を解除するミューテーション */
  UnfavoriteCreator?: Maybe<Scalars['Boolean']['output']>;
  /** [ビジネス]アカウント情報を更新するミューテーション */
  UpdateBusinessUserAccount: UpdateAccount;
  /** [ゲスト]ビジネスユーザーのメールアドレス変更時の認証ミューテーション */
  UpdateBusinessUserEmailByToken: BusinessUser;
  /** [ビジネス]クリエイターのアカウント情報編集ミューテーション */
  UpdateCreatorAccount?: Maybe<UpdatedCreator>;
  /** [ゲスト]クリエイターのアカウント情報登録ミューテーション */
  UpdateCreatorAccountByToken: Creator;
  /** [ゲスト]クリエイターのメールアドレス変更時の認証ミューテーション */
  UpdateCreatorEmailByToken: Creator;
  /** [ゲスト]ビジネスユーザーのパスワードを更新するミューテーション */
  UpdatePasswordBusinessUser?: Maybe<Scalars['Boolean']['output']>;
  /** [ユーザー]アカウント情報編集ミューテーション */
  UpdateUserAccount: UpdateAccount;
  /** [ゲスト]ユーザーのメールアドレス変更時の認証ミューテーション */
  UpdateUserEmailByToken: User;
  /** [ゲスト]ユーザーのパスワードをリセットするミューテーション */
  UserPasswordReset: Scalars['Boolean']['output'];
  /** [ユーザー]商品を購入するミューテーション */
  UserPurchaseProduct: PurchaseProduct;
  /** [ゲスト]新規ユーザー登録ミューテーション */
  UserRegisterAccount?: Maybe<User>;
  /** [ユーザー]ライブトークをリクエストするミューテーション */
  UserRequestLiveTalk: Scalars['Boolean']['output'];
  /** [ユーザー]動画をリクエストするミューテーション */
  UserRequestMovie: Scalars['Boolean']['output'];
  /** [ユーザー]写真をリクエストするミューテーション */
  UserRequestPhoto: Scalars['Boolean']['output'];
  /** [ユーザー]ユーザーのパスワードを更新するミューテーション */
  UserUpdatePassword?: Maybe<Scalars['Boolean']['output']>;
  /** [ゲスト]ユーザーの初回登録時の認証ミューテーション */
  UserVerifyAccount?: Maybe<LoginData>;
};


export type MutationBusinessResendCreatorAccountUpdateArgs = {
  creator_id: Scalars['ID']['input'];
  input?: InputMaybe<BusinessResendCreatorAccountUpdateInput>;
};


export type MutationCreatorDeliveryLiveTalkProductArgs = {
  ordered_product_id: Scalars['ID']['input'];
};


export type MutationCreatorDeliveryMovieProductArgs = {
  input: DeliveryMovieProductInput;
};


export type MutationCreatorDeliveryPhotoProductArgs = {
  input: DeliveryPhotoProductInput;
};


export type MutationCreatorDisableProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationCreatorDisplayProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationCreatorFinishProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationCreatorPasswordResetArgs = {
  input: PasswordResetInput;
};


export type MutationCreatorRegisterLiveTalkProductArgs = {
  input: RegisterLiveTalkProductInput;
};


export type MutationCreatorRegisterMovieProductArgs = {
  input: RegisterMovieProductInput;
};


export type MutationCreatorRegisterPhotoProductArgs = {
  input: RegisterPhotoProductInput;
};


export type MutationCreatorUpdatePasswordArgs = {
  creator_id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
};


export type MutationCurrentCreatorUpdateAccountArgs = {
  creator_id: Scalars['ID']['input'];
  input: CurrentCreatorUpdateAccountInput;
};


export type MutationDeleteCreatorAccountArgs = {
  creator_id: Scalars['ID']['input'];
};


export type MutationDeliveryLiveTalkProductByBusinessUserArgs = {
  ordered_product_id: Scalars['ID']['input'];
};


export type MutationDeliveryMovieProductByBusinessUserArgs = {
  input: DeliveryMovieProductInput;
};


export type MutationDeliveryPhotoProductByBusinessUserArgs = {
  input: DeliveryPhotoProductInput;
};


export type MutationDisableProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationDisplayProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationEditAffiliationArgs = {
  affiliation_id: Scalars['ID']['input'];
  input: EditAffiliationInput;
};


export type MutationFavoriteCreatorArgs = {
  creator_id: Scalars['ID']['input'];
};


export type MutationFinishProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationLoginBusinessUserArgs = {
  input: LoginInput;
};


export type MutationLoginCreatorArgs = {
  input: LoginInput;
};


export type MutationLoginUserArgs = {
  input: LoginInput;
};


export type MutationPasswordResetBusinessUserArgs = {
  input: PasswordResetInput;
};


export type MutationRegisterAffiliationArgs = {
  input: RegisterAffiliationInput;
};


export type MutationRegisterLiveTalkProductByBusinessUserArgs = {
  creator_id: Scalars['ID']['input'];
  input: RegisterLiveTalkProductInput;
};


export type MutationRegisterMovieProductByBusinessUserArgs = {
  creator_id: Scalars['ID']['input'];
  input: RegisterMovieProductInput;
};


export type MutationRegisterNewCreatorArgs = {
  input: RegisterNewCreatorInput;
};


export type MutationRegisterPhotoProductByBusinessUserArgs = {
  creator_id: Scalars['ID']['input'];
  input: RegisterPhotoProductInput;
};


export type MutationResendCreatorAccountRegistrationArgs = {
  creator_id: Scalars['ID']['input'];
};


export type MutationResendEmailForVerifyingUpdatedBusinessUserEmailArgs = {
  input: ResendEmailForVerifyingUpdatedBusinessUserEmailInput;
};


export type MutationResendUserAccountRegistrationArgs = {
  input: ResendUserAccountRegistrationInput;
  user_id: Scalars['ID']['input'];
};


export type MutationUnfavoriteCreatorArgs = {
  creator_id: Scalars['ID']['input'];
};


export type MutationUpdateBusinessUserAccountArgs = {
  input: UpdateBusinessUserAccountInput;
};


export type MutationUpdateBusinessUserEmailByTokenArgs = {
  input: UpdateEmailByTokenInput;
};


export type MutationUpdateCreatorAccountArgs = {
  creator_id: Scalars['ID']['input'];
  input: UpdateCreatorAccountInput;
};


export type MutationUpdateCreatorAccountByTokenArgs = {
  input: UpdateCreatorAccountByTokenInput;
};


export type MutationUpdateCreatorEmailByTokenArgs = {
  input: UpdateEmailByTokenInput;
};


export type MutationUpdatePasswordBusinessUserArgs = {
  business_user_id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
};


export type MutationUpdateUserAccountArgs = {
  input: UpdateUserAccountInput;
};


export type MutationUpdateUserEmailByTokenArgs = {
  input: UpdateEmailByTokenInput;
};


export type MutationUserPasswordResetArgs = {
  input: PasswordResetInput;
};


export type MutationUserPurchaseProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationUserRegisterAccountArgs = {
  input: UserRegisterAccountInput;
};


export type MutationUserRequestLiveTalkArgs = {
  input: RequestLiveTalkInput;
};


export type MutationUserRequestMovieArgs = {
  input: RequestMovieInput;
};


export type MutationUserRequestPhotoArgs = {
  input: RequestPhotoInput;
};


export type MutationUserUpdatePasswordArgs = {
  input: UpdatePasswordInput;
  user_id: Scalars['ID']['input'];
};


export type MutationUserVerifyAccountArgs = {
  input: UserVerifyAccountInput;
  user_id: Scalars['ID']['input'];
};

/** 注文(ユーザ側には参照させない) Eloquent用 */
export type Order = {
  __typename?: 'Order';
  /** 納品日 */
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  /** 注文ID */
  id: Scalars['ID']['output'];
  /** 動画の長さ */
  movie_seconds?: Maybe<Scalars['Int']['output']>;
  /** 支払日 */
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  /** 注文した商品 */
  product: Product;
  /** 注文商品ステータス */
  status: Scalars['String']['output'];
  /** 注文したユーザー */
  user: User;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Order status */
export enum OrderStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Init */
  Init = 'INIT',
  /** Invalid */
  Invalid = 'INVALID',
  /** Paid */
  Paid = 'PAID'
}

/** 注文済み商品 */
export type OrderedProduct = {
  __typename?: 'OrderedProduct';
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** クリエイター */
  creator: Creator;
  /** 注文済み商品のクリエイターID */
  creator_id: Scalars['ID']['output'];
  /** 納品日時 */
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  /** 納期期限 */
  delivery_limit_date: Scalars['DateTime']['output'];
  /** 注文済み商品ID */
  id: Scalars['ID']['output'];
  /** 納品済みか */
  is_delivered: Scalars['Boolean']['output'];
  /** 作業中か */
  is_processing: Scalars['Boolean']['output'];
  /** 納品催促メール1日前をお送信済みか */
  is_sent_reminder_delivery_1day_ago_mail?: Maybe<Scalars['Int']['output']>;
  /** 納品催促メール1時間前を送信済みか */
  is_sent_reminder_delivery_1hour_ago_mail?: Maybe<Scalars['Int']['output']>;
  /** 納品催促メール納期期限切れを送信済みか */
  is_sent_reminder_delivery_after_mail?: Maybe<Scalars['Int']['output']>;
  /** 未納品か */
  is_undelivered: Scalars['Boolean']['output'];
  /** 納品済み商品 */
  latest_delivered_product?: Maybe<DeliveredProduct>;
  /** 注文済みライブトーク商品ステータス */
  live_talk_status?: Maybe<OrderedProductLiveTalkStatus>;
  /** 注文 */
  order: Order;
  /** 注文済み商品の注文ID */
  order_id: Scalars['ID']['output'];
  /** 商品 */
  product: Product;
  /** 注文済み商品の商品ID */
  product_id: Scalars['ID']['output'];
  /** 注文済み商品のステータス */
  status: OrderedProductStatus;
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
};

/** Ordered product live talk status */
export enum OrderedProductLiveTalkStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Talked */
  Talked = 'TALKED',
  /** Talking */
  Talking = 'TALKING',
  /** Un talked */
  UnTalked = 'UN_TALKED',
  /** Waiting */
  Waiting = 'WAITING'
}

/** A paginated list of OrderedProduct items. */
export type OrderedProductPaginator = {
  __typename?: 'OrderedProductPaginator';
  /** A list of OrderedProduct items. */
  data: Array<OrderedProduct>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Ordered product status */
export enum OrderedProductStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Delivered */
  Delivered = 'DELIVERED',
  /** Processing */
  Processing = 'PROCESSING',
  /** Undelivered */
  Undelivered = 'UNDELIVERED'
}

/** 注文したユーザー */
export type OrderedUser = {
  __typename?: 'OrderedUser';
  last_paid_at?: Maybe<Scalars['DateTime']['output']>;
  number_of_purchases: Scalars['Int']['output'];
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
};

/** A paginated list of OrderedUser items. */
export type OrderedUserPaginator = {
  __typename?: 'OrderedUserPaginator';
  /** A list of OrderedUser items. */
  data: Array<OrderedUser>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Ordered users sort */
export enum OrderedUsersSort {
  /** Last paid at asc */
  LastPaidAtAsc = 'LAST_PAID_AT_ASC',
  /** Last paid at desc */
  LastPaidAtDesc = 'LAST_PAID_AT_DESC',
  /** Number of purchases asc */
  NumberOfPurchasesAsc = 'NUMBER_OF_PURCHASES_ASC',
  /** Number of purchases desc */
  NumberOfPurchasesDesc = 'NUMBER_OF_PURCHASES_DESC'
}

export type PagedCreatorSalesPerMonthBreakdownInput = {
  /** YYYYMM 未指定の場合は当月のデータを取得 */
  year_month?: InputMaybe<Scalars['YearMonth']['input']>;
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

/** Paidy */
export type Paidy = {
  __typename?: 'Paidy';
  /** ペイロード */
  payload: PaidyPayload;
  /** ペイロード(JSONエンコード済み) */
  payload_json: Scalars['String']['output'];
  /** 公開キー */
  public_key: Scalars['String']['output'];
};

/** PaidyBuyer */
export type PaidyBuyer = {
  __typename?: 'PaidyBuyer';
  email?: Maybe<Scalars['String']['output']>;
};

/** PaidyBuyerData */
export type PaidyBuyerData = {
  __typename?: 'PaidyBuyerData';
  age: Scalars['Int']['output'];
  last_order_amount: Scalars['Int']['output'];
  last_order_at: Scalars['Int']['output'];
  ltv: Scalars['Int']['output'];
  order_count: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
};

/** PaidyOrder */
export type PaidyOrder = {
  __typename?: 'PaidyOrder';
  items: Array<PaidyOrderItem>;
  order_ref?: Maybe<Scalars['String']['output']>;
};

/** PaidyOrderItem */
export type PaidyOrderItem = {
  __typename?: 'PaidyOrderItem';
  id?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  unit_price: Scalars['Int']['output'];
};

/** PaidyPayload */
export type PaidyPayload = {
  __typename?: 'PaidyPayload';
  /** 金額 */
  amount: Scalars['Int']['output'];
  /** 買い手 */
  buyer?: Maybe<PaidyBuyer>;
  /** 買い手情報 */
  buyer_data: PaidyBuyerData;
  /** 通貨 */
  currency: Scalars['String']['output'];
  /** 注文情報 */
  order: PaidyOrder;
  /** 店舗名 */
  store_name: Scalars['String']['output'];
};

export type PasswordResetInput = {
  email: Scalars['String']['input'];
};

/** Payment method */
export enum PaymentMethod {
  /** Paidy */
  Paidy = 'PAIDY',
  /** Robot payment */
  RobotPayment = 'ROBOT_PAYMENT',
  /** Stripe */
  Stripe = 'STRIPE'
}

/** 非表示も含めた商品 */
export type Product = {
  __typename?: 'Product';
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** クリエイター */
  creator?: Maybe<Creator>;
  /** 商品のクリエイターID */
  creator_id: Scalars['ID']['output'];
  /** 削除日 */
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** 商品ID */
  id: Scalars['ID']['output'];
  /** 商品タイプがライブトークか */
  is_live_talk: Scalars['Boolean']['output'];
  /** 商品タイプが動画か */
  is_movie: Scalars['Boolean']['output'];
  /** 商品タイプが写真か */
  is_photo: Scalars['Boolean']['output'];
  /** ライブトーク商品 */
  live_talk?: Maybe<ProductLiveTalk>;
  /** 動画の長さ */
  movie_seconds?: Maybe<Scalars['Int']['output']>;
  /** 商品名 */
  name: Scalars['String']['output'];
  /** 商品の価格 */
  price: Scalars['Int']['output'];
  /** 商品の種類 */
  product_type: ProductType;
  /** 商品の種類名 */
  product_type_name: Scalars['String']['output'];
  /** 公開日 */
  released_at: Scalars['DateTime']['output'];
  /** 商品の残り在庫数 */
  remaining_stock: Scalars['Int']['output'];
  /** 商品が売り切れたか */
  sold_outed: Scalars['Int']['output'];
  /** 商品の特別価格 */
  special_price?: Maybe<Scalars['Int']['output']>;
  /** 商品のステータス */
  status: ProductStatus;
  /** 商品の在庫数 */
  stock: Scalars['Int']['output'];
  /** 商品のサムネイル画像URL */
  thumbnail_image: Scalars['String']['output'];
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
};

/** Product label by admin */
export enum ProductLabelByAdmin {
  /** Hidden from products on sale */
  HiddenFromProductsOnSale = 'HIDDEN_FROM_PRODUCTS_ON_SALE'
}

/** ライブトーク商品 */
export type ProductLiveTalk = {
  __typename?: 'ProductLiveTalk';
  /** 商品ID */
  product_id: Scalars['ID']['output'];
  /** トーク開始時間 */
  started_at: Scalars['DateTime']['output'];
  /** トーク時間(分) */
  talk_minutes: Scalars['Int']['output'];
};

/** Product movie length */
export enum ProductMovieLength {
  /** Fifty */
  Fifty = 'FIFTY',
  /** Five */
  Five = 'FIVE',
  /** Fourty */
  Fourty = 'FOURTY',
  /** Sixty */
  Sixty = 'SIXTY',
  /** Ten */
  Ten = 'TEN',
  /** Thirty */
  Thirty = 'THIRTY',
  /** Twenty */
  Twenty = 'TWENTY'
}

/** A paginated list of Product items. */
export type ProductPaginator = {
  __typename?: 'ProductPaginator';
  /** A list of Product items. */
  data: Array<Product>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Product status */
export enum ProductStatus {
  /** Disable */
  Disable = 'DISABLE',
  /** Draft */
  Draft = 'DRAFT',
  /** End */
  End = 'END',
  /** Reserve */
  Reserve = 'RESERVE',
  /** Sale */
  Sale = 'SALE'
}

/** Product type */
export enum ProductType {
  /** ライブトーク */
  LiveTalk = 'LIVE_TALK',
  /** 動画 */
  Movie = 'MOVIE',
  /** 写真 */
  Photo = 'PHOTO'
}

/** 注文済み商品 */
export type PublishedOrderedProduct = {
  __typename?: 'PublishedOrderedProduct';
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** クリエイター */
  creator: Creator;
  /** 注文済み商品のクリエイターID */
  creator_id: Scalars['ID']['output'];
  /** 納期期限 */
  delivery_limit_date: Scalars['DateTime']['output'];
  /** 注文済み商品ID */
  id: Scalars['ID']['output'];
  /** 納品済みか */
  is_delivered: Scalars['Boolean']['output'];
  /** 作業中か */
  is_processing: Scalars['Boolean']['output'];
  /** 納品催促メール1日前をお送信済みか */
  is_sent_reminder_delivery_1day_ago_mail?: Maybe<Scalars['Int']['output']>;
  /** 納品催促メール1時間前を送信済みか */
  is_sent_reminder_delivery_1hour_ago_mail?: Maybe<Scalars['Int']['output']>;
  /** 納品催促メール納期期限切れを送信済みか */
  is_sent_reminder_delivery_after_mail?: Maybe<Scalars['Int']['output']>;
  /** 未納品か */
  is_undelivered: Scalars['Boolean']['output'];
  /** 納品済み商品 */
  latest_delivered_product?: Maybe<DeliveredProduct>;
  /** 注文済みライブトーク商品ステータス */
  live_talk_status?: Maybe<OrderedProductLiveTalkStatus>;
  /** 注文 */
  order: Order;
  /** 注文済み商品の注文ID */
  order_id: Scalars['ID']['output'];
  /** 商品 */
  product: PublishedProduct;
  /** 注文済み商品の商品ID */
  product_id: Scalars['ID']['output'];
  /** 注文済み商品のステータス */
  status: OrderedProductStatus;
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of PublishedOrderedProduct items. */
export type PublishedOrderedProductPaginator = {
  __typename?: 'PublishedOrderedProductPaginator';
  /** A list of PublishedOrderedProduct items. */
  data: Array<PublishedOrderedProduct>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** 公開用の商品 */
export type PublishedProduct = {
  __typename?: 'PublishedProduct';
  /** クリエイター */
  creator?: Maybe<Creator>;
  /** 商品のクリエイターID */
  creator_id: Scalars['ID']['output'];
  /** 商品ID */
  id: Scalars['ID']['output'];
  /** 商品タイプがライブトークか */
  is_live_talk: Scalars['Boolean']['output'];
  /** 商品タイプが動画か */
  is_movie: Scalars['Boolean']['output'];
  /** 商品タイプが写真か */
  is_photo: Scalars['Boolean']['output'];
  /** ライブトーク商品 */
  live_talk?: Maybe<ProductLiveTalk>;
  /** 動画の長さ */
  movie_seconds?: Maybe<Scalars['Int']['output']>;
  /** 商品名 */
  name: Scalars['String']['output'];
  /** 商品の価格 */
  price: Scalars['Int']['output'];
  /** 商品の種類 */
  product_type: ProductType;
  /** 商品の種類名 */
  product_type_name: Scalars['String']['output'];
  /** 公開日 */
  released_at: Scalars['DateTime']['output'];
  /** 商品の残り在庫数 */
  remaining_stock: Scalars['Int']['output'];
  /** 商品が売り切れたか */
  sold_outed: Scalars['Int']['output'];
  /** 商品の特別価格 */
  special_price?: Maybe<Scalars['Int']['output']>;
  /** 商品のステータス */
  status: ProductStatus;
  /** 商品の在庫数 */
  stock: Scalars['Int']['output'];
  /** 商品のサムネイル画像URL */
  thumbnail_image: Scalars['String']['output'];
};

/** A paginated list of PublishedProduct items. */
export type PublishedProductPaginator = {
  __typename?: 'PublishedProductPaginator';
  /** A list of PublishedProduct items. */
  data: Array<PublishedProduct>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** 購入注文[ユーザー用] */
export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  /** 注文ID */
  id: Scalars['ID']['output'];
  /** 購入完了期限 */
  paid_limit: Scalars['DateTime']['output'];
  /** 価格 */
  price: Scalars['Int']['output'];
  /** 注文した商品 */
  product: PublishedProduct;
};

/** 購入商品[ユーザー用] */
export type PurchaseProduct = {
  __typename?: 'PurchaseProduct';
  /** 注文有効時間 */
  available_order_minutes: Scalars['Int']['output'];
  /** 注文 */
  order: PurchaseOrder;
  /** Paidy */
  paidy: Paidy;
  /** Robot Payment */
  robot_payment: RobotPayment;
};

export type Query = {
  __typename?: 'Query';
  /** [ゲスト]アクティブなクリエイターをID指定して取得するクエリー */
  ActiveCreator: Creator;
  /** [ビジネス]所属内のアクティブなクリエイター一覧を取得するクエリー */
  ActiveCreatorsInAffiliation: Array<Creator>;
  /** [ビジネス]クリエイターリストクエリー */
  ActiveCreatorsInBusiness: Array<Creator>;
  /** [ビジネス]IDを指定して所属を取得するクエリー */
  AffiliationInBusiness: Affiliation;
  /** [ビジネス]所属毎の今月の売上一覧クエリー */
  AffiliationSaleThisMonth: AffiliationSaleThisMonth;
  /** [ビジネス]所属毎の月別売上一覧クエリー */
  AffiliationSalesPerMonth: AffiliationSalesPerMonth;
  /** [ビジネス]ビジネス内の所属を全て取得するクエリー */
  AffiliationsInBusiness: Array<Affiliation>;
  /** [ビジネス]チャットルームのビデオトークンの取得 */
  BusinessCreateVideoChatRoomToken: Scalars['String']['output'];
  /** [ビジネス]クリエーターマイページクエリー */
  BusinessCreatorMypage: CreatorMypage;
  BusinessOrderedProduct?: Maybe<OrderedProduct>;
  /** [ビジネス]商品詳細を取得するクエリー */
  BusinessProduct: Product;
  /** [ビジネス]指定クリエイターの公開商品一覧クエリー */
  BusinessPublishedProducts: Array<Maybe<Product>>;
  /** [ビジネス]ビジネス内の月別売上一覧クエリー */
  BusinessSalesPerMonth: BusinessSalesPerMonth;
  /** [ビジネス]今月の売上クエリー */
  BusinessSalesThisMonth?: Maybe<SalesPerMonth>;
  /** [ビジネス]指定クリエイターの未納品注文一覧クエリー */
  BusinessUndeliveredOrderedProducts: Array<OrderedProduct>;
  /** [クリエイター]チャットルームのビデオトークンの取得 */
  CreatorCreateVideoChatRoomToken: Scalars['String']['output'];
  /** [ビジネス]クリエイタークエリー */
  CreatorInBusiness: Creator;
  /** [クリエイター]動画納品用のアップロードの一時URLを取得するクエリー */
  CreatorMovieDeliveryProductUploadUrl: MovieProductUpload;
  CreatorOrderedProduct?: Maybe<OrderedProduct>;
  /** [クリエイター]商品詳細を取得するクエリー */
  CreatorProduct: Product;
  /** [クリエイター]自分の公開商品一覧クエリー */
  CreatorPublishedProducts: Array<Maybe<Product>>;
  /** [クリエイター]指定したクリエイターのユーザー購入ランキングを取得するクエリー */
  CreatorPurchaseUserRanking: Array<CreatorPurchaseUserRanking>;
  /** [ゲスト]日次販売数クリエイターランキングを取得するクエリー */
  CreatorRankingOfDailySalesCount: Array<CreatorRanking>;
  /** [ゲスト]月次販売数クリエイターランキングを取得するクエリー */
  CreatorRankingOfMonthlySalesCount: Array<CreatorRanking>;
  /** [ゲスト]週次販売数クリエイターランキングを取得するクエリー */
  CreatorRankingOfWeeklySalesCount: Array<CreatorRanking>;
  /** [ビジネス]指定したクリエイターの今月の売上を取得するクエリー */
  CreatorSaleThisMonth?: Maybe<SalesPerMonth>;
  /** [ビジネス]クリエイター毎の月別売上一覧クエリー */
  CreatorSalesPerMonth: CreatorSalesPerMonth;
  /** [クリエイター]年間の月別売上一覧 */
  CreatorSalesPerMonthInYear: Array<SalesPerMonth>;
  /** [クリエイター]指定クリエイターの未納品注文一覧クエリー */
  CreatorUndeliveredOrderedProducts: Array<OrderedProduct>;
  /** [ビジネス]所属内のクリエイター一覧を取得するクエリー */
  CreatorsInAffiliation: Array<Creator>;
  /** [ビジネス]ログイン中のビジネスユーザーを取得するクエリー */
  CurrentBusinessUser?: Maybe<BusinessUser>;
  /** [クリエイター]ログイン中のクリエイターを取得するクエリー */
  CurrentCreator?: Maybe<Creator>;
  /** [ユーザー]ログイン中の一般ユーザーを取得するクエリー */
  CurrentUser?: Maybe<User>;
  /** [ユーザー]お気に入り済みのクリエイターページネーションを取得するクエリー */
  FavoriteCreators: CreatorPaginator;
  /** [ビジネス]フィルターした月次売上の一時URLを生成 */
  GenerateTemporaryUrlForFilteredMonthlySales: Scalars['String']['output'];
  /** [ビジネス]フィルターしたクリエイター毎の月次売上の一時URLを生成 */
  GenerateTemporaryUrlForFilteredMonthlySalesByCreator: Scalars['String']['output'];
  /** [ビジネス]月次売上の一時URLを生成 */
  GenerateTemporaryUrlForMonthlySales: Scalars['String']['output'];
  /** [ビジネス]クリエイター毎の月次売上の一時URLを生成 */
  GenerateTemporaryUrlForMonthlySalesByCreator: Scalars['String']['output'];
  /** [ゲスト]商品登録時のライブトークの長さの設定可能な範囲を取得するクエリー */
  LiveTalkMinutesRange: Array<Scalars['Int']['output']>;
  /** [ビジネス]動画納品用のアップロードの一時URLを取得するクエリー */
  MovieDeliveryProductUploadUrl: MovieProductUpload;
  /** [ゲスト]商品登録時の動画の長さの設定可能な範囲を取得するクエリー */
  MovieSecondsRange: Array<Scalars['Int']['output']>;
  /** [ゲスト]アクティブなクリエイターを検索するクエリー */
  PagedActiveCreators: CreatorPaginator;
  /** [ビジネス]ビジネス内の所属を全て取得するクエリー(ペジネーション付き) */
  PagedAffiliationsInBusiness: AffiliationPaginator;
  /** [ビジネス]ユーザー毎注文済み商品一覧クエリー(ページネーション付き) */
  PagedBusinessDeliveredOrderedProductPerUser: OrderedProductPaginator;
  /** [ビジネス]納品済み注文一覧 */
  PagedBusinessDeliveredOrderedProducts: OrderedProductPaginator;
  PagedBusinessDisabledProducts: ProductPaginator;
  /** [ビジネス]購入者一覧 */
  PagedBusinessOrderedUsers: OrderedUserPaginator;
  /** [ビジネス]指定クリエイターの公開商品一覧クエリー(ページネーション付き) */
  PagedBusinessPublishedProducts: ProductPaginator;
  PagedBusinessReservedProducts: ProductPaginator;
  /** [ビジネス]ユーザー毎納品済み商品一覧クエリー(ページネーション付き) */
  PagedBusinessUndeliveredOrderedProductPerUser: OrderedProductPaginator;
  /** [クリエイター]ユーザー毎注文済み商品一覧クエリー(ページネーション付き) */
  PagedCreatorDeliveredOrderedProductPerUser: OrderedProductPaginator;
  /** [クリエイター]納品済み注文一覧 */
  PagedCreatorDeliveredOrderedProducts: OrderedProductPaginator;
  PagedCreatorDisabledProducts: ProductPaginator;
  /** [クリエイター]購入者一覧 */
  PagedCreatorOrderedUsers: OrderedUserPaginator;
  /** [クリエイター]公開商品一覧クエリー(ページネーション付き) */
  PagedCreatorPublishedProducts: ProductPaginator;
  PagedCreatorReservedProducts: ProductPaginator;
  /** [クリエイター]月別売上内訳 */
  PagedCreatorSalesPerMonthBreakdown: SalesBreakdownPaginator;
  /** [クリエイター]ユーザー毎納品済み商品一覧クエリー(ページネーション付き) */
  PagedCreatorUndeliveredOrderedProductPerUser: OrderedProductPaginator;
  /** [ビジネス]クリエイターリストクエリー */
  PagedCreatorsInBusiness: CreatorPaginator;
  /** [ゲスト]販売中商品を取得するクエリー */
  PagedProductsOnSale: PublishedProductPaginator;
  /** [ゲスト]公開商品を取得するクエリー */
  PagedPublishedProducts: PublishedProductPaginator;
  /** [ビジネス]注文別売上一覧クエリー */
  PagedSalesPerOrder: SalesPerOrderPaginator;
  /** [ユーザー]お気に入りクリエイター一覧クエリー */
  PagedUserActiveCreatorsFavorited: CreatorPaginator;
  /** [ユーザ]お気に入りクリエイターの新着商品クエリー */
  PagedUserFavoritedCreatorLatestProducts: PublishedProductPaginator;
  /** [ユーザー]指定クリエイターの公開商品一覧クエリー(ページネーション付き) */
  PagedUserPublishedProducts: PublishedProductPaginator;
  /** [ユーザー]購入履歴商品一覧クエリー */
  PagedUserPurchasedProducts: PublishedOrderedProductPaginator;
  /** [ゲスト]商品登録時の価格の設定可能な範囲を取得するクエリー */
  PriceRange: Array<Scalars['Int']['output']>;
  /** [ゲスト]公開商品を取得するクエリー */
  PublishedProduct: PublishedProduct;
  /** [ゲスト]このクリエイターを見ている方へのおすすめを取得するクエリー */
  RecommendedCreators: Array<Creator>;
  /** [ゲスト]アクティブなクリエイターをID指定して取得するクエリー */
  RequestCreator: RequestCreator;
  /** [ビジネス]所属別売上一覧クエリー */
  SalesPerAffiliation: SalesPerAffiliation;
  /** [ビジネス]所属毎、月毎のクリエイター別売上一覧クエリー */
  SalesPerCreator: SalesPerCreatorGroup;
  /** [ユーザ]チャットルームのビデオトークンの取得 */
  UserCreateVideoChatRoomToken: Scalars['String']['output'];
  /** [ユーザー]商品詳細を取得するクエリー */
  UserPublishedProduct: PublishedProduct;
  /** [ユーザー]購入商品を取得するクエリ */
  UserPurchasedProduct: PublishedOrderedProduct;
  /** [ビジネス]ビジネスユーザーのトークンの有効性を判定するクエリー */
  ValidateBusinessUserToken: Scalars['Boolean']['output'];
  /** [クリエイター]クリエイターのトークンの有効性を判定するクエリー */
  ValidateCreatorToken: Scalars['Boolean']['output'];
  /** [ユーザー]ユーザーのトークンの有効性を判定するクエリー */
  ValidateUserToken: Scalars['Boolean']['output'];
};


export type QueryActiveCreatorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActiveCreatorsInAffiliationArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAffiliationInBusinessArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAffiliationSaleThisMonthArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAffiliationSalesPerMonthArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBusinessCreateVideoChatRoomTokenArgs = {
  creator_id: Scalars['ID']['input'];
  product_id: Scalars['ID']['input'];
};


export type QueryBusinessCreatorMypageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessOrderedProductArgs = {
  ordered_product_id: Scalars['ID']['input'];
};


export type QueryBusinessProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryBusinessPublishedProductsArgs = {
  creator_id: Scalars['ID']['input'];
};


export type QueryBusinessUndeliveredOrderedProductsArgs = {
  creator_id: Scalars['ID']['input'];
};


export type QueryCreatorCreateVideoChatRoomTokenArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryCreatorInBusinessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreatorMovieDeliveryProductUploadUrlArgs = {
  ordered_product_id: Scalars['ID']['input'];
};


export type QueryCreatorOrderedProductArgs = {
  ordered_product_id: Scalars['ID']['input'];
};


export type QueryCreatorProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryCreatorRankingOfDailySalesCountArgs = {
  input: CreatorRankingInput;
};


export type QueryCreatorRankingOfMonthlySalesCountArgs = {
  input: CreatorRankingInput;
};


export type QueryCreatorRankingOfWeeklySalesCountArgs = {
  input: CreatorRankingInput;
};


export type QueryCreatorSaleThisMonthArgs = {
  creator_id: Scalars['ID']['input'];
};


export type QueryCreatorSalesPerMonthArgs = {
  creator_id: Scalars['ID']['input'];
};


export type QueryCreatorSalesPerMonthInYearArgs = {
  input: CreatorSalesPerMonthInYearInput;
};


export type QueryCreatorsInAffiliationArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFavoriteCreatorsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenerateTemporaryUrlForFilteredMonthlySalesArgs = {
  input: GenerateTemporaryUrlForFilteredMonthlySalesInput;
};


export type QueryGenerateTemporaryUrlForFilteredMonthlySalesByCreatorArgs = {
  input: GenerateTemporaryUrlForFilteredMonthlySalesByCreatorInput;
};


export type QueryGenerateTemporaryUrlForMonthlySalesArgs = {
  input: GenerateTemporaryUrlForMonthlySalesInput;
};


export type QueryGenerateTemporaryUrlForMonthlySalesByCreatorArgs = {
  input: GenerateTemporaryUrlForMonthlySalesByCreatorInput;
};


export type QueryMovieDeliveryProductUploadUrlArgs = {
  ordered_product_id: Scalars['ID']['input'];
};


export type QueryPagedActiveCreatorsArgs = {
  first: Scalars['Int']['input'];
  input: ActiveCreatorsInput;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedAffiliationsInBusinessArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedBusinessDeliveredOrderedProductPerUserArgs = {
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPagedBusinessDeliveredOrderedProductsArgs = {
  creator_id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedBusinessDisabledProductsArgs = {
  creator_id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedBusinessOrderedUsersArgs = {
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPagedBusinessPublishedProductsArgs = {
  creator_id: Scalars['ID']['input'];
  exclude_product_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedBusinessReservedProductsArgs = {
  creator_id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedBusinessUndeliveredOrderedProductPerUserArgs = {
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPagedCreatorDeliveredOrderedProductPerUserArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPagedCreatorDeliveredOrderedProductsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedCreatorDisabledProductsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedCreatorOrderedUsersArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPagedCreatorPublishedProductsArgs = {
  exclude_product_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedCreatorReservedProductsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedCreatorSalesPerMonthBreakdownArgs = {
  first: Scalars['Int']['input'];
  input: PagedCreatorSalesPerMonthBreakdownInput;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedCreatorUndeliveredOrderedProductPerUserArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPagedCreatorsInBusinessArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedProductsOnSaleArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedPublishedProductsArgs = {
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  exclude_product_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedSalesPerOrderArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  has_all_affiliation?: InputMaybe<Scalars['Boolean']['input']>;
  input: SalesInput;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedUserActiveCreatorsFavoritedArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedUserFavoritedCreatorLatestProductsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedUserPublishedProductsArgs = {
  creator_id: Scalars['ID']['input'];
  exclude_product_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagedUserPurchasedProductsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublishedProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryRecommendedCreatorsArgs = {
  input: RecommendedCreatorsInput;
};


export type QueryRequestCreatorArgs = {
  creator_id: Scalars['ID']['input'];
  input: RequestCreatorInput;
};


export type QuerySalesPerAffiliationArgs = {
  input: SalesInput;
};


export type QuerySalesPerCreatorArgs = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  input: SalesInput;
};


export type QueryUserCreateVideoChatRoomTokenArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryUserPublishedProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryUserPurchasedProductArgs = {
  ordered_product_id: Scalars['ID']['input'];
};

export type RecommendedCreatorsInput = {
  creator_id: Scalars['ID']['input'];
};

export type RegisterAffiliationInput = {
  name: Scalars['String']['input'];
};

export type RegisterLiveTalkProductInput = {
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  released_at?: InputMaybe<Scalars['DateTime']['input']>;
  start_at: Scalars['DateTime']['input'];
  talk_minutes: Scalars['Int']['input'];
  thumbnail_image: Scalars['Upload']['input'];
};

export type RegisterMovieProductInput = {
  movie_seconds: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  released_at?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnail_image: Scalars['Upload']['input'];
};

export type RegisterNewCreatorInput = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
};

export type RegisterPhotoProductInput = {
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  released_at?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnail_image: Scalars['Upload']['input'];
};

/** 登録依頼中のクリエイター */
export type RequestCreator = {
  __typename?: 'RequestCreator';
  /** 所属 */
  affiliation?: Maybe<Affiliation>;
  /** 所属ID */
  affiliation_id?: Maybe<Scalars['ID']['output']>;
  /** ビジネスID */
  business_id: Scalars['ID']['output'];
  /** クリエイターのメールアドレス */
  email: Scalars['String']['output'];
  /** クリエイターID */
  id: Scalars['ID']['output'];
  /** クリエイターのステータス */
  status: CreatorAccountStatus;
  /** クリエイターのステータス名 */
  status_name: Scalars['String']['output'];
};

export type RequestCreatorInput = {
  expires: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
};

export type RequestLiveTalkInput = {
  creator_id: Scalars['ID']['input'];
  is_casual_clothes: Scalars['Boolean']['input'];
  is_other: Scalars['Boolean']['input'];
  is_pajamas: Scalars['Boolean']['input'];
  other_text?: InputMaybe<Scalars['String']['input']>;
  requested_dates: Scalars['String']['input'];
};

export type RequestMovieInput = {
  creator_id: Scalars['ID']['input'];
  is_casual_clothes: Scalars['Boolean']['input'];
  is_good_morning_message: Scalars['Boolean']['input'];
  is_good_night_message: Scalars['Boolean']['input'];
  is_other: Scalars['Boolean']['input'];
  is_pajamas: Scalars['Boolean']['input'];
  is_say_you_like_me: Scalars['Boolean']['input'];
  other_text?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPhotoInput = {
  creator_id: Scalars['ID']['input'];
  is_casual_clothes: Scalars['Boolean']['input'];
  is_newly_taken: Scalars['Boolean']['input'];
  is_other: Scalars['Boolean']['input'];
  is_pajamas: Scalars['Boolean']['input'];
  other_text?: InputMaybe<Scalars['String']['input']>;
};

export type ResendEmailForVerifyingUpdatedBusinessUserEmailInput = {
  email: Scalars['String']['input'];
};

export type ResendUserAccountRegistrationInput = {
  email: Scalars['String']['input'];
};

/** RobotPayment */
export type RobotPayment = {
  __typename?: 'RobotPayment';
  /** クレジットカード決済画面URL */
  credit_card_link: Scalars['String']['output'];
  /** 購入者Eメール */
  email: Scalars['String']['output'];
  /** ジョブタイプ */
  job_type: Scalars['String']['output'];
  /** 店舗オーダー番号 */
  order_id: Scalars['String']['output'];
  /** 商品金額 */
  price: Scalars['Int']['output'];
  /** 商品番号 */
  product_id: Scalars['String']['output'];
  /** 商品名 */
  product_name: Scalars['String']['output'];
  /** 送料 */
  shipping_fee: Scalars['Int']['output'];
  /** 店舗ID */
  store_id: Scalars['String']['output'];
  /** 税額 */
  tax: Scalars['Int']['output'];
};

/** Robot payment result code */
export enum RobotPaymentResultCode {
  /** Failure */
  Failure = 'FAILURE',
  /** Success */
  Success = 'SUCCESS'
}

/** 売上内訳 */
export type SalesBreakdown = {
  __typename?: 'SalesBreakdown';
  /** 納品日 */
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  /** 秒数 */
  movie_seconds?: Maybe<Scalars['Int']['output']>;
  /** 注文ID */
  order_id: Scalars['ID']['output'];
  /** 購入日 */
  paid_at: Scalars['DateTime']['output'];
  /** 購入商品 */
  product_name: Scalars['String']['output'];
  /** 形式 */
  product_type: ProductType;
  /** 形式名 */
  product_type_name: Scalars['String']['output'];
  /** 商品の価格 */
  sales: Scalars['Int']['output'];
  /** トーク開始時間 */
  started_at?: Maybe<Scalars['DateTime']['output']>;
  /** トーク時間(分) */
  talk_minutes?: Maybe<Scalars['Int']['output']>;
  /** 購入者名 */
  user_name: Scalars['String']['output'];
};

/** A paginated list of SalesBreakdown items. */
export type SalesBreakdownPaginator = {
  __typename?: 'SalesBreakdownPaginator';
  /** A list of SalesBreakdown items. */
  data: Array<SalesBreakdown>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SalesInput = {
  year_month: Scalars['YearMonth']['input'];
};

/** 所属別売上 */
export type SalesPerAffiliation = {
  __typename?: 'SalesPerAffiliation';
  sales_per_month: Array<SalesPerMonthAffiliation>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

/** 所属毎、月毎のクリエイター別売上 */
export type SalesPerCreator = {
  __typename?: 'SalesPerCreator';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
};

export type SalesPerCreatorGroup = {
  __typename?: 'SalesPerCreatorGroup';
  affiliation?: Maybe<Affiliation>;
  sales_per_creator: Array<SalesPerCreator>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

/** 月別売上 */
export type SalesPerMonth = {
  __typename?: 'SalesPerMonth';
  /** 販売件数 */
  count: Scalars['Int']['output'];
  /** 納品売上 */
  delivered_sales?: Maybe<Scalars['Int']['output']>;
  /** 年月 YYYYMM */
  month: Scalars['String']['output'];
  /** 売上 */
  sales: Scalars['Int']['output'];
};

/** 所属の月別売上 */
export type SalesPerMonthAffiliation = {
  __typename?: 'SalesPerMonthAffiliation';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
};

/** 注文別売上 */
export type SalesPerOrder = {
  __typename?: 'SalesPerOrder';
  /** 所属名 */
  affiliation_name?: Maybe<Scalars['String']['output']>;
  /** クリエイター名 */
  creator_name: Scalars['String']['output'];
  /** 納品日時 */
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  /** 動画の長さ */
  movie_seconds?: Maybe<Scalars['Int']['output']>;
  /** 注文ID */
  order_id: Scalars['ID']['output'];
  /** 決済日時 */
  paid_at: Scalars['DateTime']['output'];
  /** 購入商品 */
  product_name: Scalars['String']['output'];
  /** 商品形式 */
  product_type: ProductType;
  /** 商品形式名 */
  product_type_name: Scalars['String']['output'];
  /** 商品の価格 */
  sales: Scalars['Int']['output'];
  /** トーク開始時間 */
  started_at?: Maybe<Scalars['DateTime']['output']>;
  /** トーク時間(分) */
  talk_minutes?: Maybe<Scalars['Int']['output']>;
  /** 購入者名 */
  user_name: Scalars['String']['output'];
};

/** 注文別売上の月別売上 */
export type SalesPerOrderMonth = {
  __typename?: 'SalesPerOrderMonth';
  sales_per_month: Array<SalesPerOrder>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of SalesPerOrder items. */
export type SalesPerOrderPaginator = {
  __typename?: 'SalesPerOrderPaginator';
  /** A list of SalesPerOrder items. */
  data: Array<SalesPerOrder>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/** Stripe */
export type Stripe = {
  __typename?: 'Stripe';
  /** セッション */
  checkout_session: StripeCheckoutSession;
  /** チェックアウトURL */
  checkout_url: Scalars['String']['output'];
  /** 公開キー */
  public_key: Scalars['String']['output'];
};

/** StripeCheckoutSession */
export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  allow_promotion_codes?: Maybe<Scalars['Boolean']['output']>;
  amount_subtotal?: Maybe<Scalars['Int']['output']>;
  amount_total?: Maybe<Scalars['Int']['output']>;
  billing_address_collection?: Maybe<Scalars['String']['output']>;
  cancel_url: Scalars['String']['output'];
  client_reference_id?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  payment_method_types: Array<Scalars['String']['output']>;
  payment_status: Scalars['String']['output'];
  submit_type?: Maybe<Scalars['String']['output']>;
  success_url: Scalars['String']['output'];
};

/** Tool tables */
export enum ToolTables {
  /** 管理ユーザ */
  AdminUsers = 'ADMIN_USERS',
  /** 所属 */
  Affiliations = 'AFFILIATIONS',
  /** ビジネスパートナー */
  Businesses = 'BUSINESSES',
  /** ビジネスユーザ */
  BusinessUsers = 'BUSINESS_USERS',
  /** クリエイター属性 */
  CategoryCreators = 'CATEGORY_CREATORS',
  /** クリエイター */
  Creators = 'CREATORS',
  /** クリエイターメモ */
  CreatorMemos = 'CREATOR_MEMOS',
  /** クリエイター向け納品リマインダー送信履歴 */
  CreatorReminderDeliveries = 'CREATOR_REMINDER_DELIVERIES',
  /** 納品済み商品 */
  DeliveredProducts = 'DELIVERED_PRODUCTS',
  /** 失敗したジョブ */
  FailedJobs = 'FAILED_JOBS',
  /** ライブトークリクエスト */
  LiveTalkRequests = 'LIVE_TALK_REQUESTS',
  /** マイグレーション */
  Migrations = 'MIGRATIONS',
  /** 動画リクエスト */
  MovieRequests = 'MOVIE_REQUESTS',
  /** 注文済み商品 */
  OrderedProducts = 'ORDERED_PRODUCTS',
  /** 注文 */
  Orders = 'ORDERS',
  /** Paidyレシート */
  PaidyReceipts = 'PAIDY_RECEIPTS',
  /** パスワードリセット状態 */
  PasswordResets = 'PASSWORD_RESETS',
  /** 課金履歴 */
  PaymentLogs = 'PAYMENT_LOGS',
  /** 写真リクエスト */
  PhotoRequests = 'PHOTO_REQUESTS',
  /** 商品 */
  Products = 'PRODUCTS',
  /** ライブトーク商品 */
  ProductLiveTalks = 'PRODUCT_LIVE_TALKS',
  /** RobotPaymentレシート */
  RobotPaymentReceipts = 'ROBOT_PAYMENT_RECEIPTS',
  /** Stripeレシート */
  StripeReceipts = 'STRIPE_RECEIPTS',
  /** ユーザー */
  Users = 'USERS',
  /** ユーザがお気に入りしているクリエイター */
  UserFavoriteCreators = 'USER_FAVORITE_CREATORS',
  /** ユーザが通知をONにしているクリエイター */
  UserNoticeCreators = 'USER_NOTICE_CREATORS'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

/** Twitter fetch task status */
export enum TwitterFetchTaskStatus {
  /** Completed */
  Completed = 'COMPLETED',
  /** In progress */
  InProgress = 'IN_PROGRESS'
}

/** アカウント更新データ */
export type UpdateAccount = {
  __typename?: 'UpdateAccount';
  /** 変更依頼したメールアドレス */
  change_request_email?: Maybe<Scalars['String']['output']>;
  /** メールアドレスに変更があるか */
  is_change_request_email: Scalars['Boolean']['output'];
};

export type UpdateBusinessUserAccountInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCreatorAccountByTokenInput = {
  creator_id: Scalars['ID']['input'];
  expires: Scalars['Int']['input'];
  icon: Scalars['Upload']['input'];
  instagram_username?: InputMaybe<Scalars['String']['input']>;
  kindle_author_url?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
  twitter_username?: InputMaybe<Scalars['String']['input']>;
  youtube_channel_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreatorAccountInput = {
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['Upload']['input']>;
  instagram_username?: InputMaybe<Scalars['String']['input']>;
  kindle_author_url?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  twitter_username?: InputMaybe<Scalars['String']['input']>;
  youtube_channel_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailByTokenInput = {
  email: Scalars['String']['input'];
  expires: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};

export type UpdatePasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UpdateUserAccountInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  twitter_username?: InputMaybe<Scalars['String']['input']>;
};

/** 更新クリエイター */
export type UpdatedCreator = {
  __typename?: 'UpdatedCreator';
  /** 変更後のメールアドレス */
  change_request_email?: Maybe<Scalars['String']['output']>;
  /** クリエイター情報 */
  creator: Creator;
  /** メールアドレス更新リクエストがあるか */
  is_change_request_email?: Maybe<Scalars['Boolean']['output']>;
};

/** 一般ユーザー */
export type User = {
  __typename?: 'User';
  /** 登録日 */
  created_at: Scalars['DateTime']['output'];
  /** ユーザーのメールアドレス */
  email: Scalars['String']['output'];
  /** ユーザーID */
  id: Scalars['ID']['output'];
  /** ユーザーの名前 */
  name: Scalars['String']['output'];
  /** ユーザーのステータス */
  status: UserAccountStatus;
  /** ユーザーのTwitterユーザー名 */
  twitter_username?: Maybe<Scalars['String']['output']>;
  /** 更新日 */
  updated_at: Scalars['DateTime']['output'];
};

/** User account status */
export enum UserAccountStatus {
  /** 有効 */
  Active = 'ACTIVE',
  /** 登録中 */
  Init = 'INIT',
  /** 退会 */
  Leave = 'LEAVE',
  /** 停止 */
  Suspend = 'SUSPEND'
}

export type UserRegisterAccountInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  twitter_username?: InputMaybe<Scalars['String']['input']>;
};

export type UserVerifyAccountInput = {
  email: Scalars['String']['input'];
  expires: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
};

export type BusinessResendCreatorAccountUpdateMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: BusinessResendCreatorAccountUpdateInput;
}>;


export type BusinessResendCreatorAccountUpdateMutation = { __typename?: 'Mutation', BusinessResendCreatorAccountUpdate?: boolean | null };

export type CreatorDeliveryLiveTalkProductMutationVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type CreatorDeliveryLiveTalkProductMutation = { __typename?: 'Mutation', CreatorDeliveryLiveTalkProduct: boolean };

export type CreatorDeliveryMovieProductMutationVariables = Exact<{
  input: DeliveryMovieProductInput;
}>;


export type CreatorDeliveryMovieProductMutation = { __typename?: 'Mutation', CreatorDeliveryMovieProduct: boolean };

export type CreatorDeliveryPhotoProductMutationVariables = Exact<{
  input: DeliveryPhotoProductInput;
}>;


export type CreatorDeliveryPhotoProductMutation = { __typename?: 'Mutation', CreatorDeliveryPhotoProduct: boolean };

export type CreatorDisableProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type CreatorDisableProductMutation = { __typename?: 'Mutation', CreatorDisableProduct?: boolean | null };

export type CreatorDisplayProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type CreatorDisplayProductMutation = { __typename?: 'Mutation', CreatorDisplayProduct?: boolean | null };

export type CreatorFinishProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type CreatorFinishProductMutation = { __typename?: 'Mutation', CreatorFinishProduct: boolean };

export type CreatorPasswordResetMutationVariables = Exact<{
  input: PasswordResetInput;
}>;


export type CreatorPasswordResetMutation = { __typename?: 'Mutation', CreatorPasswordReset: boolean };

export type CreatorRegisterLiveTalkProductMutationVariables = Exact<{
  input: RegisterLiveTalkProductInput;
}>;


export type CreatorRegisterLiveTalkProductMutation = { __typename?: 'Mutation', CreatorRegisterLiveTalkProduct: boolean };

export type CreatorRegisterMovieProductMutationVariables = Exact<{
  input: RegisterMovieProductInput;
}>;


export type CreatorRegisterMovieProductMutation = { __typename?: 'Mutation', CreatorRegisterMovieProduct: boolean };

export type CreatorRegisterPhotoProductMutationVariables = Exact<{
  input: RegisterPhotoProductInput;
}>;


export type CreatorRegisterPhotoProductMutation = { __typename?: 'Mutation', CreatorRegisterPhotoProduct: boolean };

export type CreatorUpdatePasswordMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
}>;


export type CreatorUpdatePasswordMutation = { __typename?: 'Mutation', CreatorUpdatePassword?: boolean | null };

export type CurrentCreatorUpdateAccountMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: CurrentCreatorUpdateAccountInput;
}>;


export type CurrentCreatorUpdateAccountMutation = { __typename?: 'Mutation', CurrentCreatorUpdateAccount?: { __typename?: 'UpdatedCreator', is_change_request_email?: boolean | null, change_request_email?: string | null, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string } } | null };

export type DeleteCreatorAccountMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type DeleteCreatorAccountMutation = { __typename?: 'Mutation', DeleteCreatorAccount?: boolean | null };

export type DeliveryLiveTalkProductByBusinessUserMutationVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type DeliveryLiveTalkProductByBusinessUserMutation = { __typename?: 'Mutation', DeliveryLiveTalkProductByBusinessUser: boolean };

export type DeliveryMovieProductByBusinessUserMutationVariables = Exact<{
  input: DeliveryMovieProductInput;
}>;


export type DeliveryMovieProductByBusinessUserMutation = { __typename?: 'Mutation', DeliveryMovieProductByBusinessUser: boolean };

export type DeliveryPhotoProductByBusinessUserMutationVariables = Exact<{
  input: DeliveryPhotoProductInput;
}>;


export type DeliveryPhotoProductByBusinessUserMutation = { __typename?: 'Mutation', DeliveryPhotoProductByBusinessUser: boolean };

export type DisableProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type DisableProductMutation = { __typename?: 'Mutation', DisableProduct?: boolean | null };

export type DisplayProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type DisplayProductMutation = { __typename?: 'Mutation', DisplayProduct?: boolean | null };

export type EditAffiliationMutationVariables = Exact<{
  affiliation_id: Scalars['ID']['input'];
  input: EditAffiliationInput;
}>;


export type EditAffiliationMutation = { __typename?: 'Mutation', EditAffiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null };

export type FavoriteCreatorMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type FavoriteCreatorMutation = { __typename?: 'Mutation', FavoriteCreator?: boolean | null };

export type FinishProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type FinishProductMutation = { __typename?: 'Mutation', FinishProduct?: boolean | null };

export type LoginBusinessUserMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginBusinessUserMutation = { __typename?: 'Mutation', LoginBusinessUser?: { __typename?: 'LoginData', token?: string | null, type?: string | null, ttl?: number | null } | null };

export type LoginCreatorMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginCreatorMutation = { __typename?: 'Mutation', LoginCreator?: { __typename?: 'LoginData', token?: string | null, type?: string | null, ttl?: number | null } | null };

export type LoginUserMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginUserMutation = { __typename?: 'Mutation', LoginUser?: { __typename?: 'LoginData', token?: string | null, type?: string | null, ttl?: number | null } | null };

export type LogoutBusinessUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutBusinessUserMutation = { __typename?: 'Mutation', LogoutBusinessUser?: boolean | null };

export type LogoutCreatorMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutCreatorMutation = { __typename?: 'Mutation', LogoutCreator?: boolean | null };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'Mutation', LogoutUser?: boolean | null };

export type PasswordResetBusinessUserMutationVariables = Exact<{
  input: PasswordResetInput;
}>;


export type PasswordResetBusinessUserMutation = { __typename?: 'Mutation', PasswordResetBusinessUser?: boolean | null };

export type RegisterAffiliationMutationVariables = Exact<{
  input: RegisterAffiliationInput;
}>;


export type RegisterAffiliationMutation = { __typename?: 'Mutation', RegisterAffiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null };

export type RegisterLiveTalkProductByBusinessUserMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: RegisterLiveTalkProductInput;
}>;


export type RegisterLiveTalkProductByBusinessUserMutation = { __typename?: 'Mutation', RegisterLiveTalkProductByBusinessUser: boolean };

export type RegisterMovieProductByBusinessUserMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: RegisterMovieProductInput;
}>;


export type RegisterMovieProductByBusinessUserMutation = { __typename?: 'Mutation', RegisterMovieProductByBusinessUser: boolean };

export type RegisterNewCreatorMutationVariables = Exact<{
  input: RegisterNewCreatorInput;
}>;


export type RegisterNewCreatorMutation = { __typename?: 'Mutation', RegisterNewCreator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null };

export type RegisterPhotoProductByBusinessUserMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: RegisterPhotoProductInput;
}>;


export type RegisterPhotoProductByBusinessUserMutation = { __typename?: 'Mutation', RegisterPhotoProductByBusinessUser: boolean };

export type ResendCreatorAccountRegistrationMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type ResendCreatorAccountRegistrationMutation = { __typename?: 'Mutation', ResendCreatorAccountRegistration?: boolean | null };

export type ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationVariables = Exact<{
  input: ResendEmailForVerifyingUpdatedBusinessUserEmailInput;
}>;


export type ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation = { __typename?: 'Mutation', ResendEmailForVerifyingUpdatedBusinessUserEmail?: boolean | null };

export type ResendUserAccountRegistrationMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  input: ResendUserAccountRegistrationInput;
}>;


export type ResendUserAccountRegistrationMutation = { __typename?: 'Mutation', ResendUserAccountRegistration?: boolean | null };

export type UnfavoriteCreatorMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type UnfavoriteCreatorMutation = { __typename?: 'Mutation', UnfavoriteCreator?: boolean | null };

export type UpdateBusinessUserAccountMutationVariables = Exact<{
  input: UpdateBusinessUserAccountInput;
}>;


export type UpdateBusinessUserAccountMutation = { __typename?: 'Mutation', UpdateBusinessUserAccount: { __typename?: 'UpdateAccount', is_change_request_email: boolean, change_request_email?: string | null } };

export type UpdateBusinessUserEmailByTokenMutationVariables = Exact<{
  input: UpdateEmailByTokenInput;
}>;


export type UpdateBusinessUserEmailByTokenMutation = { __typename?: 'Mutation', UpdateBusinessUserEmailByToken: { __typename?: 'BusinessUser', id: string, name: string, email: string, created_at: any, updated_at: any } };

export type UpdateCreatorAccountMutationVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: UpdateCreatorAccountInput;
}>;


export type UpdateCreatorAccountMutation = { __typename?: 'Mutation', UpdateCreatorAccount?: { __typename?: 'UpdatedCreator', is_change_request_email?: boolean | null, change_request_email?: string | null, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string } } | null };

export type UpdateCreatorAccountByTokenMutationVariables = Exact<{
  input: UpdateCreatorAccountByTokenInput;
}>;


export type UpdateCreatorAccountByTokenMutation = { __typename?: 'Mutation', UpdateCreatorAccountByToken: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } };

export type UpdateCreatorEmailByTokenMutationVariables = Exact<{
  input: UpdateEmailByTokenInput;
}>;


export type UpdateCreatorEmailByTokenMutation = { __typename?: 'Mutation', UpdateCreatorEmailByToken: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, favorite_users_count: number } };

export type UpdatePasswordBusinessUserMutationVariables = Exact<{
  business_user_id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordBusinessUserMutation = { __typename?: 'Mutation', UpdatePasswordBusinessUser?: boolean | null };

export type UpdateUserAccountMutationVariables = Exact<{
  input: UpdateUserAccountInput;
}>;


export type UpdateUserAccountMutation = { __typename?: 'Mutation', UpdateUserAccount: { __typename?: 'UpdateAccount', is_change_request_email: boolean, change_request_email?: string | null } };

export type UpdateUserEmailByTokenMutationVariables = Exact<{
  input: UpdateEmailByTokenInput;
}>;


export type UpdateUserEmailByTokenMutation = { __typename?: 'Mutation', UpdateUserEmailByToken: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any } };

export type UserPasswordResetMutationVariables = Exact<{
  input: PasswordResetInput;
}>;


export type UserPasswordResetMutation = { __typename?: 'Mutation', UserPasswordReset: boolean };

export type UserPurchaseProductMutationVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type UserPurchaseProductMutation = { __typename?: 'Mutation', UserPurchaseProduct: { __typename?: 'PurchaseProduct', order: { __typename?: 'PurchaseOrder', id: string, price: number, paid_limit: any, product: { __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, paidy: { __typename?: 'Paidy', payload_json: string, public_key: string, payload: { __typename?: 'PaidyPayload', amount: number, currency: string, store_name: string, buyer?: { __typename?: 'PaidyBuyer', email?: string | null } | null, buyer_data: { __typename?: 'PaidyBuyerData', user_id?: string | null, age: number, order_count: number, ltv: number, last_order_amount: number, last_order_at: number }, order: { __typename?: 'PaidyOrder', order_ref?: string | null, items: Array<{ __typename?: 'PaidyOrderItem', id?: number | null, quantity: number, title: string, unit_price: number }> } } }, robot_payment: { __typename?: 'RobotPayment', credit_card_link: string, store_id: string, price: number, tax: number, shipping_fee: number, job_type: string, order_id: string, email: string, product_name: string, product_id: string } } };

export type UserRegisterAccountMutationVariables = Exact<{
  input: UserRegisterAccountInput;
}>;


export type UserRegisterAccountMutation = { __typename?: 'Mutation', UserRegisterAccount?: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any } | null };

export type UserRequestLiveTalkMutationVariables = Exact<{
  input: RequestLiveTalkInput;
}>;


export type UserRequestLiveTalkMutation = { __typename?: 'Mutation', UserRequestLiveTalk: boolean };

export type UserRequestMovieMutationVariables = Exact<{
  input: RequestMovieInput;
}>;


export type UserRequestMovieMutation = { __typename?: 'Mutation', UserRequestMovie: boolean };

export type UserRequestPhotoMutationVariables = Exact<{
  input: RequestPhotoInput;
}>;


export type UserRequestPhotoMutation = { __typename?: 'Mutation', UserRequestPhoto: boolean };

export type UserUpdatePasswordMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
}>;


export type UserUpdatePasswordMutation = { __typename?: 'Mutation', UserUpdatePassword?: boolean | null };

export type UserVerifyAccountMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  input: UserVerifyAccountInput;
}>;


export type UserVerifyAccountMutation = { __typename?: 'Mutation', UserVerifyAccount?: { __typename?: 'LoginData', token?: string | null, type?: string | null, ttl?: number | null } | null };

export type ActiveCreatorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActiveCreatorQuery = { __typename?: 'Query', ActiveCreator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } };

export type ActiveCreatorsInAffiliationQueryVariables = Exact<{
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ActiveCreatorsInAffiliationQuery = { __typename?: 'Query', ActiveCreatorsInAffiliation: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }> };

export type ActiveCreatorsInBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCreatorsInBusinessQuery = { __typename?: 'Query', ActiveCreatorsInBusiness: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }> };

export type AffiliationInBusinessQueryVariables = Exact<{
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AffiliationInBusinessQuery = { __typename?: 'Query', AffiliationInBusiness: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } };

export type AffiliationSaleThisMonthQueryVariables = Exact<{
  affiliation_id: Scalars['ID']['input'];
}>;


export type AffiliationSaleThisMonthQuery = { __typename?: 'Query', AffiliationSaleThisMonth: { __typename?: 'AffiliationSaleThisMonth', affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null, sale_this_month?: { __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null } | null } };

export type AffiliationSalesPerMonthQueryVariables = Exact<{
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AffiliationSalesPerMonthQuery = { __typename?: 'Query', AffiliationSalesPerMonth: { __typename?: 'AffiliationSalesPerMonth', affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null, sales_per_month: Array<{ __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null }> } };

export type AffiliationsInBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type AffiliationsInBusinessQuery = { __typename?: 'Query', AffiliationsInBusiness: Array<{ __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any }> };

export type BusinessCreateVideoChatRoomTokenQueryVariables = Exact<{
  product_id: Scalars['ID']['input'];
  creator_id: Scalars['ID']['input'];
}>;


export type BusinessCreateVideoChatRoomTokenQuery = { __typename?: 'Query', BusinessCreateVideoChatRoomToken: string };

export type BusinessCreatorMypageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BusinessCreatorMypageQuery = { __typename?: 'Query', BusinessCreatorMypage: { __typename?: 'CreatorMypage', creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, sales?: { __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null } | null, published_products?: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null } | null> | null, reserved_products?: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null } | null> | null, disabled_products?: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null } | null> | null } };

export type BusinessOrderedProductQueryVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type BusinessOrderedProductQuery = { __typename?: 'Query', BusinessOrderedProduct?: { __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null } | null };

export type BusinessProductQueryVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type BusinessProductQuery = { __typename?: 'Query', BusinessProduct: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } };

export type BusinessSalesPerMonthQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessSalesPerMonthQuery = { __typename?: 'Query', BusinessSalesPerMonth: { __typename?: 'BusinessSalesPerMonth', total_sales?: number | null, sales_per_month: Array<{ __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null }> } };

export type BusinessSalesThisMonthQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessSalesThisMonthQuery = { __typename?: 'Query', BusinessSalesThisMonth?: { __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null } | null };

export type BusinessUndeliveredOrderedProductsQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type BusinessUndeliveredOrderedProductsQuery = { __typename?: 'Query', BusinessUndeliveredOrderedProducts: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }> };

export type UserCreateVideoChatRoomTokenQueryVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type UserCreateVideoChatRoomTokenQuery = { __typename?: 'Query', UserCreateVideoChatRoomToken: string };

export type CreatorInBusinessQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreatorInBusinessQuery = { __typename?: 'Query', CreatorInBusiness: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } };

export type CreatorMovieDeliveryProductUploadUrlQueryVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type CreatorMovieDeliveryProductUploadUrlQuery = { __typename?: 'Query', CreatorMovieDeliveryProductUploadUrl: { __typename?: 'MovieProductUpload', upload_url?: string | null, upload_file_path?: string | null } };

export type CreatorOrderedProductQueryVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type CreatorOrderedProductQuery = { __typename?: 'Query', CreatorOrderedProduct?: { __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null } | null };

export type CreatorProductQueryVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type CreatorProductQuery = { __typename?: 'Query', CreatorProduct: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } };

export type CreatorPurchaseUserRankingQueryVariables = Exact<{ [key: string]: never; }>;


export type CreatorPurchaseUserRankingQuery = { __typename?: 'Query', CreatorPurchaseUserRanking: Array<{ __typename?: 'CreatorPurchaseUserRanking', user_id: number, user_name: string, twitter_username?: string | null, amount: number, purchase_count: number }> };

export type CreatorRankingOfDailySalesCountQueryVariables = Exact<{
  input: CreatorRankingInput;
}>;


export type CreatorRankingOfDailySalesCountQuery = { __typename?: 'Query', CreatorRankingOfDailySalesCount: Array<{ __typename?: 'CreatorRanking', rank: number, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } }> };

export type CreatorRankingOfMonthlySalesCountQueryVariables = Exact<{
  input: CreatorRankingInput;
}>;


export type CreatorRankingOfMonthlySalesCountQuery = { __typename?: 'Query', CreatorRankingOfMonthlySalesCount: Array<{ __typename?: 'CreatorRanking', rank: number, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } }> };

export type CreatorRankingOfWeeklySalesCountQueryVariables = Exact<{
  input: CreatorRankingInput;
}>;


export type CreatorRankingOfWeeklySalesCountQuery = { __typename?: 'Query', CreatorRankingOfWeeklySalesCount: Array<{ __typename?: 'CreatorRanking', rank: number, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } }> };

export type CreatorSaleThisMonthQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type CreatorSaleThisMonthQuery = { __typename?: 'Query', CreatorSaleThisMonth?: { __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null } | null };

export type CreatorSalesPerMonthQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
}>;


export type CreatorSalesPerMonthQuery = { __typename?: 'Query', CreatorSalesPerMonth: { __typename?: 'CreatorSalesPerMonth', total_sales?: number | null, sales_per_month: Array<{ __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null }> } };

export type CreatorSalesPerMonthInYearQueryVariables = Exact<{
  input: CreatorSalesPerMonthInYearInput;
}>;


export type CreatorSalesPerMonthInYearQuery = { __typename?: 'Query', CreatorSalesPerMonthInYear: Array<{ __typename?: 'SalesPerMonth', month: string, count: number, sales: number, delivered_sales?: number | null }> };

export type CreatorUndeliveredOrderedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreatorUndeliveredOrderedProductsQuery = { __typename?: 'Query', CreatorUndeliveredOrderedProducts: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }> };

export type CreatorsInAffiliationQueryVariables = Exact<{
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreatorsInAffiliationQuery = { __typename?: 'Query', CreatorsInAffiliation: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }> };

export type CurrentBusinessUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBusinessUserQuery = { __typename?: 'Query', CurrentBusinessUser?: { __typename?: 'BusinessUser', id: string, name: string, email: string, created_at: any, updated_at: any } | null };

export type CurrentCreatorQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCreatorQuery = { __typename?: 'Query', CurrentCreator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', CurrentUser?: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any } | null };

export type GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables = Exact<{
  input: GenerateTemporaryUrlForFilteredMonthlySalesInput;
}>;


export type GenerateTemporaryUrlForFilteredMonthlySalesQuery = { __typename?: 'Query', GenerateTemporaryUrlForFilteredMonthlySales: string };

export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables = Exact<{
  input: GenerateTemporaryUrlForFilteredMonthlySalesByCreatorInput;
}>;


export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery = { __typename?: 'Query', GenerateTemporaryUrlForFilteredMonthlySalesByCreator: string };

export type MovieDeliveryProductUploadUrlQueryVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type MovieDeliveryProductUploadUrlQuery = { __typename?: 'Query', MovieDeliveryProductUploadUrl: { __typename?: 'MovieProductUpload', upload_url?: string | null, upload_file_path?: string | null } };

export type PagedActiveCreatorsQueryVariables = Exact<{
  input: ActiveCreatorsInput;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedActiveCreatorsQuery = { __typename?: 'Query', PagedActiveCreators: { __typename?: 'CreatorPaginator', data: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PagedAffiliationsInBusinessQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedAffiliationsInBusinessQuery = { __typename?: 'Query', PagedAffiliationsInBusiness: { __typename?: 'AffiliationPaginator', data: Array<{ __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessDeliveredOrderedProductPerUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  user_id: Scalars['ID']['input'];
  creator_id: Scalars['ID']['input'];
}>;


export type PagedBusinessDeliveredOrderedProductPerUserQuery = { __typename?: 'Query', PagedBusinessDeliveredOrderedProductPerUser: { __typename?: 'OrderedProductPaginator', data: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessDeliveredOrderedProductsQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedBusinessDeliveredOrderedProductsQuery = { __typename?: 'Query', PagedBusinessDeliveredOrderedProducts: { __typename?: 'OrderedProductPaginator', data: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessDisabledProductsQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedBusinessDisabledProductsQuery = { __typename?: 'Query', PagedBusinessDisabledProducts: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessOrderedUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  creator_id: Scalars['ID']['input'];
}>;


export type PagedBusinessOrderedUsersQuery = { __typename?: 'Query', PagedBusinessOrderedUsers: { __typename?: 'OrderedUserPaginator', data: Array<{ __typename?: 'OrderedUser', user_id: string, user_name: string, last_paid_at?: any | null, number_of_purchases: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessPublishedProductsQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  exclude_product_id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedBusinessPublishedProductsQuery = { __typename?: 'Query', PagedBusinessPublishedProducts: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessReservedProductsQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedBusinessReservedProductsQuery = { __typename?: 'Query', PagedBusinessReservedProducts: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedBusinessUndeliveredOrderedProductPerUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  user_id: Scalars['ID']['input'];
  creator_id: Scalars['ID']['input'];
}>;


export type PagedBusinessUndeliveredOrderedProductPerUserQuery = { __typename?: 'Query', PagedBusinessUndeliveredOrderedProductPerUser: { __typename?: 'OrderedProductPaginator', data: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorDeliveredOrderedProductPerUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  user_id: Scalars['ID']['input'];
}>;


export type PagedCreatorDeliveredOrderedProductPerUserQuery = { __typename?: 'Query', PagedCreatorDeliveredOrderedProductPerUser: { __typename?: 'OrderedProductPaginator', data: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorDeliveredOrderedProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedCreatorDeliveredOrderedProductsQuery = { __typename?: 'Query', PagedCreatorDeliveredOrderedProducts: { __typename?: 'OrderedProductPaginator', data: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivered_at?: any | null, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorDisabledProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedCreatorDisabledProductsQuery = { __typename?: 'Query', PagedCreatorDisabledProducts: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorOrderedUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type PagedCreatorOrderedUsersQuery = { __typename?: 'Query', PagedCreatorOrderedUsers: { __typename?: 'OrderedUserPaginator', data: Array<{ __typename?: 'OrderedUser', user_id: string, user_name: string, last_paid_at?: any | null, number_of_purchases: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorPublishedProductsQueryVariables = Exact<{
  exclude_product_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedCreatorPublishedProductsQuery = { __typename?: 'Query', PagedCreatorPublishedProducts: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorReservedProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedCreatorReservedProductsQuery = { __typename?: 'Query', PagedCreatorReservedProducts: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorSalesPerMonthBreakdownQueryVariables = Exact<{
  input: PagedCreatorSalesPerMonthBreakdownInput;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedCreatorSalesPerMonthBreakdownQuery = { __typename?: 'Query', PagedCreatorSalesPerMonthBreakdown: { __typename?: 'SalesBreakdownPaginator', data: Array<{ __typename?: 'SalesBreakdown', delivered_at?: any | null, paid_at: any, user_name: string, product_name: string, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, started_at?: any | null, talk_minutes?: number | null, order_id: string, sales: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PagedCreatorUndeliveredOrderedProductPerUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  user_id: Scalars['ID']['input'];
}>;


export type PagedCreatorUndeliveredOrderedProductPerUserQuery = { __typename?: 'Query', PagedCreatorUndeliveredOrderedProductPerUser: { __typename?: 'OrderedProductPaginator', data: Array<{ __typename?: 'OrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedCreatorsInBusinessQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedCreatorsInBusinessQuery = { __typename?: 'Query', PagedCreatorsInBusiness: { __typename?: 'CreatorPaginator', data: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PagedProductsOnSaleQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedProductsOnSaleQuery = { __typename?: 'Query', PagedProductsOnSale: { __typename?: 'PublishedProductPaginator', data: Array<{ __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedPublishedProductsQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  exclude_product_id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedPublishedProductsQuery = { __typename?: 'Query', PagedPublishedProducts: { __typename?: 'PublishedProductPaginator', data: Array<{ __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedSalesPerOrderQueryVariables = Exact<{
  has_all_affiliation?: InputMaybe<Scalars['Boolean']['input']>;
  affiliation_id?: InputMaybe<Scalars['ID']['input']>;
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  input: SalesInput;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedSalesPerOrderQuery = { __typename?: 'Query', PagedSalesPerOrder: { __typename?: 'SalesPerOrderPaginator', data: Array<{ __typename?: 'SalesPerOrder', delivered_at?: any | null, paid_at: any, user_name: string, product_name: string, creator_name: string, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, started_at?: any | null, talk_minutes?: number | null, order_id: string, sales: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PagedUserActiveCreatorsFavoritedQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagedUserActiveCreatorsFavoritedQuery = { __typename?: 'Query', PagedUserActiveCreatorsFavorited: { __typename?: 'CreatorPaginator', data: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PagedUserFavoritedCreatorLatestProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedUserFavoritedCreatorLatestProductsQuery = { __typename?: 'Query', PagedUserFavoritedCreatorLatestProducts: { __typename?: 'PublishedProductPaginator', data: Array<{ __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PagedUserPurchasedProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
}>;


export type PagedUserPurchasedProductsQuery = { __typename?: 'Query', PagedUserPurchasedProducts: { __typename?: 'PublishedOrderedProductPaginator', data: Array<{ __typename?: 'PublishedOrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, total: number, perPage: number } } };

export type PublishedProductQueryVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type PublishedProductQuery = { __typename?: 'Query', PublishedProduct: { __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } };

export type RecommendedCreatorsQueryVariables = Exact<{
  input: RecommendedCreatorsInput;
}>;


export type RecommendedCreatorsQuery = { __typename?: 'Query', RecommendedCreators: Array<{ __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }> };

export type RequestCreatorQueryVariables = Exact<{
  creator_id: Scalars['ID']['input'];
  input: RequestCreatorInput;
}>;


export type RequestCreatorQuery = { __typename?: 'Query', RequestCreator: { __typename?: 'RequestCreator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, email: string, status_name: string, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } };

export type CreatorCreateVideoChatRoomTokenQueryVariables = Exact<{
  product_id: Scalars['ID']['input'];
}>;


export type CreatorCreateVideoChatRoomTokenQuery = { __typename?: 'Query', CreatorCreateVideoChatRoomToken: string };

export type UserPurchasedProductQueryVariables = Exact<{
  ordered_product_id: Scalars['ID']['input'];
}>;


export type UserPurchasedProductQuery = { __typename?: 'Query', UserPurchasedProduct: { __typename?: 'PublishedOrderedProduct', id: string, status: OrderedProductStatus, live_talk_status?: OrderedProductLiveTalkStatus | null, creator_id: string, order_id: string, product_id: string, is_sent_reminder_delivery_1day_ago_mail?: number | null, is_sent_reminder_delivery_1hour_ago_mail?: number | null, is_sent_reminder_delivery_after_mail?: number | null, created_at: any, updated_at: any, delivery_limit_date: any, is_delivered: boolean, is_processing: boolean, is_undelivered: boolean, creator: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null }, order: { __typename?: 'Order', id: string, delivered_at?: any | null, paid_at?: any | null, movie_seconds?: number | null, status: string, user: { __typename?: 'User', id: string, status: UserAccountStatus, name: string, email: string, twitter_username?: string | null, created_at: any, updated_at: any }, product: { __typename?: 'Product', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, created_at: any, updated_at: any, deleted_at?: any | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null } }, product: { __typename?: 'PublishedProduct', id: string, name: string, creator_id: string, status: ProductStatus, price: number, special_price?: number | null, stock: number, remaining_stock: number, sold_outed: number, thumbnail_image: string, released_at: any, product_type: ProductType, product_type_name: string, movie_seconds?: number | null, is_movie: boolean, is_photo: boolean, is_live_talk: boolean, creator?: { __typename?: 'Creator', id: string, business_id: string, affiliation_id?: string | null, status: CreatorAccountStatus, icon_url: string, name: string, email: string, profile: string, twitter_username: string, instagram_username: string, youtube_channel_url: string, kindle_author_url: string, left_at?: any | null, created_at: any, updated_at: any, status_name: string, is_favorite?: boolean | null, favorite_users_count: number, affiliation?: { __typename?: 'Affiliation', id: string, name: string, creators_count?: number | null, created_at: any, updated_at: any } | null } | null, live_talk?: { __typename?: 'ProductLiveTalk', product_id: string, started_at: any, talk_minutes: number } | null }, latest_delivered_product?: { __typename?: 'DeliveredProduct', id?: string | null, ordered_product_id?: string | null, delivered_product_url?: string | null, delivered_product_thumbnail_url?: string | null, temporary_download_url?: string | null, delivered_at?: any | null, created_at?: any | null, updated_at?: any | null } | null } };

export type ValidateBusinessUserTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateBusinessUserTokenQuery = { __typename?: 'Query', ValidateBusinessUserToken: boolean };

export type ValidateCreatorTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateCreatorTokenQuery = { __typename?: 'Query', ValidateCreatorToken: boolean };

export type ValidateUserTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateUserTokenQuery = { __typename?: 'Query', ValidateUserToken: boolean };


export const BusinessResendCreatorAccountUpdateDocument = gql`
    mutation BusinessResendCreatorAccountUpdate($creator_id: ID!, $input: BusinessResendCreatorAccountUpdateInput!) {
  BusinessResendCreatorAccountUpdate(creator_id: $creator_id, input: $input)
}
    `;
export type BusinessResendCreatorAccountUpdateMutationFn = Apollo.MutationFunction<BusinessResendCreatorAccountUpdateMutation, BusinessResendCreatorAccountUpdateMutationVariables>;

/**
 * __useBusinessResendCreatorAccountUpdateMutation__
 *
 * To run a mutation, you first call `useBusinessResendCreatorAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessResendCreatorAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessResendCreatorAccountUpdateMutation, { data, loading, error }] = useBusinessResendCreatorAccountUpdateMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessResendCreatorAccountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessResendCreatorAccountUpdateMutation, BusinessResendCreatorAccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessResendCreatorAccountUpdateMutation, BusinessResendCreatorAccountUpdateMutationVariables>(BusinessResendCreatorAccountUpdateDocument, options);
      }
export type BusinessResendCreatorAccountUpdateMutationHookResult = ReturnType<typeof useBusinessResendCreatorAccountUpdateMutation>;
export type BusinessResendCreatorAccountUpdateMutationResult = Apollo.MutationResult<BusinessResendCreatorAccountUpdateMutation>;
export type BusinessResendCreatorAccountUpdateMutationOptions = Apollo.BaseMutationOptions<BusinessResendCreatorAccountUpdateMutation, BusinessResendCreatorAccountUpdateMutationVariables>;
export const CreatorDeliveryLiveTalkProductDocument = gql`
    mutation CreatorDeliveryLiveTalkProduct($ordered_product_id: ID!) {
  CreatorDeliveryLiveTalkProduct(ordered_product_id: $ordered_product_id)
}
    `;
export type CreatorDeliveryLiveTalkProductMutationFn = Apollo.MutationFunction<CreatorDeliveryLiveTalkProductMutation, CreatorDeliveryLiveTalkProductMutationVariables>;

/**
 * __useCreatorDeliveryLiveTalkProductMutation__
 *
 * To run a mutation, you first call `useCreatorDeliveryLiveTalkProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorDeliveryLiveTalkProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorDeliveryLiveTalkProductMutation, { data, loading, error }] = useCreatorDeliveryLiveTalkProductMutation({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useCreatorDeliveryLiveTalkProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorDeliveryLiveTalkProductMutation, CreatorDeliveryLiveTalkProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorDeliveryLiveTalkProductMutation, CreatorDeliveryLiveTalkProductMutationVariables>(CreatorDeliveryLiveTalkProductDocument, options);
      }
export type CreatorDeliveryLiveTalkProductMutationHookResult = ReturnType<typeof useCreatorDeliveryLiveTalkProductMutation>;
export type CreatorDeliveryLiveTalkProductMutationResult = Apollo.MutationResult<CreatorDeliveryLiveTalkProductMutation>;
export type CreatorDeliveryLiveTalkProductMutationOptions = Apollo.BaseMutationOptions<CreatorDeliveryLiveTalkProductMutation, CreatorDeliveryLiveTalkProductMutationVariables>;
export const CreatorDeliveryMovieProductDocument = gql`
    mutation CreatorDeliveryMovieProduct($input: DeliveryMovieProductInput!) {
  CreatorDeliveryMovieProduct(input: $input)
}
    `;
export type CreatorDeliveryMovieProductMutationFn = Apollo.MutationFunction<CreatorDeliveryMovieProductMutation, CreatorDeliveryMovieProductMutationVariables>;

/**
 * __useCreatorDeliveryMovieProductMutation__
 *
 * To run a mutation, you first call `useCreatorDeliveryMovieProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorDeliveryMovieProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorDeliveryMovieProductMutation, { data, loading, error }] = useCreatorDeliveryMovieProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorDeliveryMovieProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorDeliveryMovieProductMutation, CreatorDeliveryMovieProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorDeliveryMovieProductMutation, CreatorDeliveryMovieProductMutationVariables>(CreatorDeliveryMovieProductDocument, options);
      }
export type CreatorDeliveryMovieProductMutationHookResult = ReturnType<typeof useCreatorDeliveryMovieProductMutation>;
export type CreatorDeliveryMovieProductMutationResult = Apollo.MutationResult<CreatorDeliveryMovieProductMutation>;
export type CreatorDeliveryMovieProductMutationOptions = Apollo.BaseMutationOptions<CreatorDeliveryMovieProductMutation, CreatorDeliveryMovieProductMutationVariables>;
export const CreatorDeliveryPhotoProductDocument = gql`
    mutation CreatorDeliveryPhotoProduct($input: DeliveryPhotoProductInput!) {
  CreatorDeliveryPhotoProduct(input: $input)
}
    `;
export type CreatorDeliveryPhotoProductMutationFn = Apollo.MutationFunction<CreatorDeliveryPhotoProductMutation, CreatorDeliveryPhotoProductMutationVariables>;

/**
 * __useCreatorDeliveryPhotoProductMutation__
 *
 * To run a mutation, you first call `useCreatorDeliveryPhotoProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorDeliveryPhotoProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorDeliveryPhotoProductMutation, { data, loading, error }] = useCreatorDeliveryPhotoProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorDeliveryPhotoProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorDeliveryPhotoProductMutation, CreatorDeliveryPhotoProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorDeliveryPhotoProductMutation, CreatorDeliveryPhotoProductMutationVariables>(CreatorDeliveryPhotoProductDocument, options);
      }
export type CreatorDeliveryPhotoProductMutationHookResult = ReturnType<typeof useCreatorDeliveryPhotoProductMutation>;
export type CreatorDeliveryPhotoProductMutationResult = Apollo.MutationResult<CreatorDeliveryPhotoProductMutation>;
export type CreatorDeliveryPhotoProductMutationOptions = Apollo.BaseMutationOptions<CreatorDeliveryPhotoProductMutation, CreatorDeliveryPhotoProductMutationVariables>;
export const CreatorDisableProductDocument = gql`
    mutation CreatorDisableProduct($product_id: ID!) {
  CreatorDisableProduct(product_id: $product_id)
}
    `;
export type CreatorDisableProductMutationFn = Apollo.MutationFunction<CreatorDisableProductMutation, CreatorDisableProductMutationVariables>;

/**
 * __useCreatorDisableProductMutation__
 *
 * To run a mutation, you first call `useCreatorDisableProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorDisableProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorDisableProductMutation, { data, loading, error }] = useCreatorDisableProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useCreatorDisableProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorDisableProductMutation, CreatorDisableProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorDisableProductMutation, CreatorDisableProductMutationVariables>(CreatorDisableProductDocument, options);
      }
export type CreatorDisableProductMutationHookResult = ReturnType<typeof useCreatorDisableProductMutation>;
export type CreatorDisableProductMutationResult = Apollo.MutationResult<CreatorDisableProductMutation>;
export type CreatorDisableProductMutationOptions = Apollo.BaseMutationOptions<CreatorDisableProductMutation, CreatorDisableProductMutationVariables>;
export const CreatorDisplayProductDocument = gql`
    mutation CreatorDisplayProduct($product_id: ID!) {
  CreatorDisplayProduct(product_id: $product_id)
}
    `;
export type CreatorDisplayProductMutationFn = Apollo.MutationFunction<CreatorDisplayProductMutation, CreatorDisplayProductMutationVariables>;

/**
 * __useCreatorDisplayProductMutation__
 *
 * To run a mutation, you first call `useCreatorDisplayProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorDisplayProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorDisplayProductMutation, { data, loading, error }] = useCreatorDisplayProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useCreatorDisplayProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorDisplayProductMutation, CreatorDisplayProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorDisplayProductMutation, CreatorDisplayProductMutationVariables>(CreatorDisplayProductDocument, options);
      }
export type CreatorDisplayProductMutationHookResult = ReturnType<typeof useCreatorDisplayProductMutation>;
export type CreatorDisplayProductMutationResult = Apollo.MutationResult<CreatorDisplayProductMutation>;
export type CreatorDisplayProductMutationOptions = Apollo.BaseMutationOptions<CreatorDisplayProductMutation, CreatorDisplayProductMutationVariables>;
export const CreatorFinishProductDocument = gql`
    mutation CreatorFinishProduct($product_id: ID!) {
  CreatorFinishProduct(product_id: $product_id)
}
    `;
export type CreatorFinishProductMutationFn = Apollo.MutationFunction<CreatorFinishProductMutation, CreatorFinishProductMutationVariables>;

/**
 * __useCreatorFinishProductMutation__
 *
 * To run a mutation, you first call `useCreatorFinishProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorFinishProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorFinishProductMutation, { data, loading, error }] = useCreatorFinishProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useCreatorFinishProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorFinishProductMutation, CreatorFinishProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorFinishProductMutation, CreatorFinishProductMutationVariables>(CreatorFinishProductDocument, options);
      }
export type CreatorFinishProductMutationHookResult = ReturnType<typeof useCreatorFinishProductMutation>;
export type CreatorFinishProductMutationResult = Apollo.MutationResult<CreatorFinishProductMutation>;
export type CreatorFinishProductMutationOptions = Apollo.BaseMutationOptions<CreatorFinishProductMutation, CreatorFinishProductMutationVariables>;
export const CreatorPasswordResetDocument = gql`
    mutation CreatorPasswordReset($input: PasswordResetInput!) {
  CreatorPasswordReset(input: $input)
}
    `;
export type CreatorPasswordResetMutationFn = Apollo.MutationFunction<CreatorPasswordResetMutation, CreatorPasswordResetMutationVariables>;

/**
 * __useCreatorPasswordResetMutation__
 *
 * To run a mutation, you first call `useCreatorPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorPasswordResetMutation, { data, loading, error }] = useCreatorPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<CreatorPasswordResetMutation, CreatorPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorPasswordResetMutation, CreatorPasswordResetMutationVariables>(CreatorPasswordResetDocument, options);
      }
export type CreatorPasswordResetMutationHookResult = ReturnType<typeof useCreatorPasswordResetMutation>;
export type CreatorPasswordResetMutationResult = Apollo.MutationResult<CreatorPasswordResetMutation>;
export type CreatorPasswordResetMutationOptions = Apollo.BaseMutationOptions<CreatorPasswordResetMutation, CreatorPasswordResetMutationVariables>;
export const CreatorRegisterLiveTalkProductDocument = gql`
    mutation CreatorRegisterLiveTalkProduct($input: RegisterLiveTalkProductInput!) {
  CreatorRegisterLiveTalkProduct(input: $input)
}
    `;
export type CreatorRegisterLiveTalkProductMutationFn = Apollo.MutationFunction<CreatorRegisterLiveTalkProductMutation, CreatorRegisterLiveTalkProductMutationVariables>;

/**
 * __useCreatorRegisterLiveTalkProductMutation__
 *
 * To run a mutation, you first call `useCreatorRegisterLiveTalkProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorRegisterLiveTalkProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorRegisterLiveTalkProductMutation, { data, loading, error }] = useCreatorRegisterLiveTalkProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorRegisterLiveTalkProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorRegisterLiveTalkProductMutation, CreatorRegisterLiveTalkProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorRegisterLiveTalkProductMutation, CreatorRegisterLiveTalkProductMutationVariables>(CreatorRegisterLiveTalkProductDocument, options);
      }
export type CreatorRegisterLiveTalkProductMutationHookResult = ReturnType<typeof useCreatorRegisterLiveTalkProductMutation>;
export type CreatorRegisterLiveTalkProductMutationResult = Apollo.MutationResult<CreatorRegisterLiveTalkProductMutation>;
export type CreatorRegisterLiveTalkProductMutationOptions = Apollo.BaseMutationOptions<CreatorRegisterLiveTalkProductMutation, CreatorRegisterLiveTalkProductMutationVariables>;
export const CreatorRegisterMovieProductDocument = gql`
    mutation CreatorRegisterMovieProduct($input: RegisterMovieProductInput!) {
  CreatorRegisterMovieProduct(input: $input)
}
    `;
export type CreatorRegisterMovieProductMutationFn = Apollo.MutationFunction<CreatorRegisterMovieProductMutation, CreatorRegisterMovieProductMutationVariables>;

/**
 * __useCreatorRegisterMovieProductMutation__
 *
 * To run a mutation, you first call `useCreatorRegisterMovieProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorRegisterMovieProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorRegisterMovieProductMutation, { data, loading, error }] = useCreatorRegisterMovieProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorRegisterMovieProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorRegisterMovieProductMutation, CreatorRegisterMovieProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorRegisterMovieProductMutation, CreatorRegisterMovieProductMutationVariables>(CreatorRegisterMovieProductDocument, options);
      }
export type CreatorRegisterMovieProductMutationHookResult = ReturnType<typeof useCreatorRegisterMovieProductMutation>;
export type CreatorRegisterMovieProductMutationResult = Apollo.MutationResult<CreatorRegisterMovieProductMutation>;
export type CreatorRegisterMovieProductMutationOptions = Apollo.BaseMutationOptions<CreatorRegisterMovieProductMutation, CreatorRegisterMovieProductMutationVariables>;
export const CreatorRegisterPhotoProductDocument = gql`
    mutation CreatorRegisterPhotoProduct($input: RegisterPhotoProductInput!) {
  CreatorRegisterPhotoProduct(input: $input)
}
    `;
export type CreatorRegisterPhotoProductMutationFn = Apollo.MutationFunction<CreatorRegisterPhotoProductMutation, CreatorRegisterPhotoProductMutationVariables>;

/**
 * __useCreatorRegisterPhotoProductMutation__
 *
 * To run a mutation, you first call `useCreatorRegisterPhotoProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorRegisterPhotoProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorRegisterPhotoProductMutation, { data, loading, error }] = useCreatorRegisterPhotoProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorRegisterPhotoProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatorRegisterPhotoProductMutation, CreatorRegisterPhotoProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorRegisterPhotoProductMutation, CreatorRegisterPhotoProductMutationVariables>(CreatorRegisterPhotoProductDocument, options);
      }
export type CreatorRegisterPhotoProductMutationHookResult = ReturnType<typeof useCreatorRegisterPhotoProductMutation>;
export type CreatorRegisterPhotoProductMutationResult = Apollo.MutationResult<CreatorRegisterPhotoProductMutation>;
export type CreatorRegisterPhotoProductMutationOptions = Apollo.BaseMutationOptions<CreatorRegisterPhotoProductMutation, CreatorRegisterPhotoProductMutationVariables>;
export const CreatorUpdatePasswordDocument = gql`
    mutation CreatorUpdatePassword($creator_id: ID!, $input: UpdatePasswordInput!) {
  CreatorUpdatePassword(creator_id: $creator_id, input: $input)
}
    `;
export type CreatorUpdatePasswordMutationFn = Apollo.MutationFunction<CreatorUpdatePasswordMutation, CreatorUpdatePasswordMutationVariables>;

/**
 * __useCreatorUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useCreatorUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatorUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatorUpdatePasswordMutation, { data, loading, error }] = useCreatorUpdatePasswordMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<CreatorUpdatePasswordMutation, CreatorUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatorUpdatePasswordMutation, CreatorUpdatePasswordMutationVariables>(CreatorUpdatePasswordDocument, options);
      }
export type CreatorUpdatePasswordMutationHookResult = ReturnType<typeof useCreatorUpdatePasswordMutation>;
export type CreatorUpdatePasswordMutationResult = Apollo.MutationResult<CreatorUpdatePasswordMutation>;
export type CreatorUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<CreatorUpdatePasswordMutation, CreatorUpdatePasswordMutationVariables>;
export const CurrentCreatorUpdateAccountDocument = gql`
    mutation CurrentCreatorUpdateAccount($creator_id: ID!, $input: CurrentCreatorUpdateAccountInput!) {
  CurrentCreatorUpdateAccount(creator_id: $creator_id, input: $input) {
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
    }
    is_change_request_email
    change_request_email
  }
}
    `;
export type CurrentCreatorUpdateAccountMutationFn = Apollo.MutationFunction<CurrentCreatorUpdateAccountMutation, CurrentCreatorUpdateAccountMutationVariables>;

/**
 * __useCurrentCreatorUpdateAccountMutation__
 *
 * To run a mutation, you first call `useCurrentCreatorUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrentCreatorUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currentCreatorUpdateAccountMutation, { data, loading, error }] = useCurrentCreatorUpdateAccountMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCurrentCreatorUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CurrentCreatorUpdateAccountMutation, CurrentCreatorUpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CurrentCreatorUpdateAccountMutation, CurrentCreatorUpdateAccountMutationVariables>(CurrentCreatorUpdateAccountDocument, options);
      }
export type CurrentCreatorUpdateAccountMutationHookResult = ReturnType<typeof useCurrentCreatorUpdateAccountMutation>;
export type CurrentCreatorUpdateAccountMutationResult = Apollo.MutationResult<CurrentCreatorUpdateAccountMutation>;
export type CurrentCreatorUpdateAccountMutationOptions = Apollo.BaseMutationOptions<CurrentCreatorUpdateAccountMutation, CurrentCreatorUpdateAccountMutationVariables>;
export const DeleteCreatorAccountDocument = gql`
    mutation DeleteCreatorAccount($creator_id: ID!) {
  DeleteCreatorAccount(creator_id: $creator_id)
}
    `;
export type DeleteCreatorAccountMutationFn = Apollo.MutationFunction<DeleteCreatorAccountMutation, DeleteCreatorAccountMutationVariables>;

/**
 * __useDeleteCreatorAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCreatorAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreatorAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreatorAccountMutation, { data, loading, error }] = useDeleteCreatorAccountMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useDeleteCreatorAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreatorAccountMutation, DeleteCreatorAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreatorAccountMutation, DeleteCreatorAccountMutationVariables>(DeleteCreatorAccountDocument, options);
      }
export type DeleteCreatorAccountMutationHookResult = ReturnType<typeof useDeleteCreatorAccountMutation>;
export type DeleteCreatorAccountMutationResult = Apollo.MutationResult<DeleteCreatorAccountMutation>;
export type DeleteCreatorAccountMutationOptions = Apollo.BaseMutationOptions<DeleteCreatorAccountMutation, DeleteCreatorAccountMutationVariables>;
export const DeliveryLiveTalkProductByBusinessUserDocument = gql`
    mutation DeliveryLiveTalkProductByBusinessUser($ordered_product_id: ID!) {
  DeliveryLiveTalkProductByBusinessUser(ordered_product_id: $ordered_product_id)
}
    `;
export type DeliveryLiveTalkProductByBusinessUserMutationFn = Apollo.MutationFunction<DeliveryLiveTalkProductByBusinessUserMutation, DeliveryLiveTalkProductByBusinessUserMutationVariables>;

/**
 * __useDeliveryLiveTalkProductByBusinessUserMutation__
 *
 * To run a mutation, you first call `useDeliveryLiveTalkProductByBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliveryLiveTalkProductByBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliveryLiveTalkProductByBusinessUserMutation, { data, loading, error }] = useDeliveryLiveTalkProductByBusinessUserMutation({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useDeliveryLiveTalkProductByBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<DeliveryLiveTalkProductByBusinessUserMutation, DeliveryLiveTalkProductByBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliveryLiveTalkProductByBusinessUserMutation, DeliveryLiveTalkProductByBusinessUserMutationVariables>(DeliveryLiveTalkProductByBusinessUserDocument, options);
      }
export type DeliveryLiveTalkProductByBusinessUserMutationHookResult = ReturnType<typeof useDeliveryLiveTalkProductByBusinessUserMutation>;
export type DeliveryLiveTalkProductByBusinessUserMutationResult = Apollo.MutationResult<DeliveryLiveTalkProductByBusinessUserMutation>;
export type DeliveryLiveTalkProductByBusinessUserMutationOptions = Apollo.BaseMutationOptions<DeliveryLiveTalkProductByBusinessUserMutation, DeliveryLiveTalkProductByBusinessUserMutationVariables>;
export const DeliveryMovieProductByBusinessUserDocument = gql`
    mutation DeliveryMovieProductByBusinessUser($input: DeliveryMovieProductInput!) {
  DeliveryMovieProductByBusinessUser(input: $input)
}
    `;
export type DeliveryMovieProductByBusinessUserMutationFn = Apollo.MutationFunction<DeliveryMovieProductByBusinessUserMutation, DeliveryMovieProductByBusinessUserMutationVariables>;

/**
 * __useDeliveryMovieProductByBusinessUserMutation__
 *
 * To run a mutation, you first call `useDeliveryMovieProductByBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliveryMovieProductByBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliveryMovieProductByBusinessUserMutation, { data, loading, error }] = useDeliveryMovieProductByBusinessUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliveryMovieProductByBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<DeliveryMovieProductByBusinessUserMutation, DeliveryMovieProductByBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliveryMovieProductByBusinessUserMutation, DeliveryMovieProductByBusinessUserMutationVariables>(DeliveryMovieProductByBusinessUserDocument, options);
      }
export type DeliveryMovieProductByBusinessUserMutationHookResult = ReturnType<typeof useDeliveryMovieProductByBusinessUserMutation>;
export type DeliveryMovieProductByBusinessUserMutationResult = Apollo.MutationResult<DeliveryMovieProductByBusinessUserMutation>;
export type DeliveryMovieProductByBusinessUserMutationOptions = Apollo.BaseMutationOptions<DeliveryMovieProductByBusinessUserMutation, DeliveryMovieProductByBusinessUserMutationVariables>;
export const DeliveryPhotoProductByBusinessUserDocument = gql`
    mutation DeliveryPhotoProductByBusinessUser($input: DeliveryPhotoProductInput!) {
  DeliveryPhotoProductByBusinessUser(input: $input)
}
    `;
export type DeliveryPhotoProductByBusinessUserMutationFn = Apollo.MutationFunction<DeliveryPhotoProductByBusinessUserMutation, DeliveryPhotoProductByBusinessUserMutationVariables>;

/**
 * __useDeliveryPhotoProductByBusinessUserMutation__
 *
 * To run a mutation, you first call `useDeliveryPhotoProductByBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliveryPhotoProductByBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliveryPhotoProductByBusinessUserMutation, { data, loading, error }] = useDeliveryPhotoProductByBusinessUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliveryPhotoProductByBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<DeliveryPhotoProductByBusinessUserMutation, DeliveryPhotoProductByBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliveryPhotoProductByBusinessUserMutation, DeliveryPhotoProductByBusinessUserMutationVariables>(DeliveryPhotoProductByBusinessUserDocument, options);
      }
export type DeliveryPhotoProductByBusinessUserMutationHookResult = ReturnType<typeof useDeliveryPhotoProductByBusinessUserMutation>;
export type DeliveryPhotoProductByBusinessUserMutationResult = Apollo.MutationResult<DeliveryPhotoProductByBusinessUserMutation>;
export type DeliveryPhotoProductByBusinessUserMutationOptions = Apollo.BaseMutationOptions<DeliveryPhotoProductByBusinessUserMutation, DeliveryPhotoProductByBusinessUserMutationVariables>;
export const DisableProductDocument = gql`
    mutation DisableProduct($product_id: ID!) {
  DisableProduct(product_id: $product_id)
}
    `;
export type DisableProductMutationFn = Apollo.MutationFunction<DisableProductMutation, DisableProductMutationVariables>;

/**
 * __useDisableProductMutation__
 *
 * To run a mutation, you first call `useDisableProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableProductMutation, { data, loading, error }] = useDisableProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useDisableProductMutation(baseOptions?: Apollo.MutationHookOptions<DisableProductMutation, DisableProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableProductMutation, DisableProductMutationVariables>(DisableProductDocument, options);
      }
export type DisableProductMutationHookResult = ReturnType<typeof useDisableProductMutation>;
export type DisableProductMutationResult = Apollo.MutationResult<DisableProductMutation>;
export type DisableProductMutationOptions = Apollo.BaseMutationOptions<DisableProductMutation, DisableProductMutationVariables>;
export const DisplayProductDocument = gql`
    mutation DisplayProduct($product_id: ID!) {
  DisplayProduct(product_id: $product_id)
}
    `;
export type DisplayProductMutationFn = Apollo.MutationFunction<DisplayProductMutation, DisplayProductMutationVariables>;

/**
 * __useDisplayProductMutation__
 *
 * To run a mutation, you first call `useDisplayProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplayProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displayProductMutation, { data, loading, error }] = useDisplayProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useDisplayProductMutation(baseOptions?: Apollo.MutationHookOptions<DisplayProductMutation, DisplayProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisplayProductMutation, DisplayProductMutationVariables>(DisplayProductDocument, options);
      }
export type DisplayProductMutationHookResult = ReturnType<typeof useDisplayProductMutation>;
export type DisplayProductMutationResult = Apollo.MutationResult<DisplayProductMutation>;
export type DisplayProductMutationOptions = Apollo.BaseMutationOptions<DisplayProductMutation, DisplayProductMutationVariables>;
export const EditAffiliationDocument = gql`
    mutation EditAffiliation($affiliation_id: ID!, $input: EditAffiliationInput!) {
  EditAffiliation(affiliation_id: $affiliation_id, input: $input) {
    id
    name
    creators_count
    created_at
    updated_at
  }
}
    `;
export type EditAffiliationMutationFn = Apollo.MutationFunction<EditAffiliationMutation, EditAffiliationMutationVariables>;

/**
 * __useEditAffiliationMutation__
 *
 * To run a mutation, you first call `useEditAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAffiliationMutation, { data, loading, error }] = useEditAffiliationMutation({
 *   variables: {
 *      affiliation_id: // value for 'affiliation_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<EditAffiliationMutation, EditAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAffiliationMutation, EditAffiliationMutationVariables>(EditAffiliationDocument, options);
      }
export type EditAffiliationMutationHookResult = ReturnType<typeof useEditAffiliationMutation>;
export type EditAffiliationMutationResult = Apollo.MutationResult<EditAffiliationMutation>;
export type EditAffiliationMutationOptions = Apollo.BaseMutationOptions<EditAffiliationMutation, EditAffiliationMutationVariables>;
export const FavoriteCreatorDocument = gql`
    mutation FavoriteCreator($creator_id: ID!) {
  FavoriteCreator(creator_id: $creator_id)
}
    `;
export type FavoriteCreatorMutationFn = Apollo.MutationFunction<FavoriteCreatorMutation, FavoriteCreatorMutationVariables>;

/**
 * __useFavoriteCreatorMutation__
 *
 * To run a mutation, you first call `useFavoriteCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriteCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriteCreatorMutation, { data, loading, error }] = useFavoriteCreatorMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useFavoriteCreatorMutation(baseOptions?: Apollo.MutationHookOptions<FavoriteCreatorMutation, FavoriteCreatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavoriteCreatorMutation, FavoriteCreatorMutationVariables>(FavoriteCreatorDocument, options);
      }
export type FavoriteCreatorMutationHookResult = ReturnType<typeof useFavoriteCreatorMutation>;
export type FavoriteCreatorMutationResult = Apollo.MutationResult<FavoriteCreatorMutation>;
export type FavoriteCreatorMutationOptions = Apollo.BaseMutationOptions<FavoriteCreatorMutation, FavoriteCreatorMutationVariables>;
export const FinishProductDocument = gql`
    mutation FinishProduct($product_id: ID!) {
  FinishProduct(product_id: $product_id)
}
    `;
export type FinishProductMutationFn = Apollo.MutationFunction<FinishProductMutation, FinishProductMutationVariables>;

/**
 * __useFinishProductMutation__
 *
 * To run a mutation, you first call `useFinishProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishProductMutation, { data, loading, error }] = useFinishProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useFinishProductMutation(baseOptions?: Apollo.MutationHookOptions<FinishProductMutation, FinishProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishProductMutation, FinishProductMutationVariables>(FinishProductDocument, options);
      }
export type FinishProductMutationHookResult = ReturnType<typeof useFinishProductMutation>;
export type FinishProductMutationResult = Apollo.MutationResult<FinishProductMutation>;
export type FinishProductMutationOptions = Apollo.BaseMutationOptions<FinishProductMutation, FinishProductMutationVariables>;
export const LoginBusinessUserDocument = gql`
    mutation LoginBusinessUser($input: LoginInput!) {
  LoginBusinessUser(input: $input) {
    token
    type
    ttl
  }
}
    `;
export type LoginBusinessUserMutationFn = Apollo.MutationFunction<LoginBusinessUserMutation, LoginBusinessUserMutationVariables>;

/**
 * __useLoginBusinessUserMutation__
 *
 * To run a mutation, you first call `useLoginBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginBusinessUserMutation, { data, loading, error }] = useLoginBusinessUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginBusinessUserMutation, LoginBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginBusinessUserMutation, LoginBusinessUserMutationVariables>(LoginBusinessUserDocument, options);
      }
export type LoginBusinessUserMutationHookResult = ReturnType<typeof useLoginBusinessUserMutation>;
export type LoginBusinessUserMutationResult = Apollo.MutationResult<LoginBusinessUserMutation>;
export type LoginBusinessUserMutationOptions = Apollo.BaseMutationOptions<LoginBusinessUserMutation, LoginBusinessUserMutationVariables>;
export const LoginCreatorDocument = gql`
    mutation LoginCreator($input: LoginInput!) {
  LoginCreator(input: $input) {
    token
    type
    ttl
  }
}
    `;
export type LoginCreatorMutationFn = Apollo.MutationFunction<LoginCreatorMutation, LoginCreatorMutationVariables>;

/**
 * __useLoginCreatorMutation__
 *
 * To run a mutation, you first call `useLoginCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginCreatorMutation, { data, loading, error }] = useLoginCreatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginCreatorMutation(baseOptions?: Apollo.MutationHookOptions<LoginCreatorMutation, LoginCreatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginCreatorMutation, LoginCreatorMutationVariables>(LoginCreatorDocument, options);
      }
export type LoginCreatorMutationHookResult = ReturnType<typeof useLoginCreatorMutation>;
export type LoginCreatorMutationResult = Apollo.MutationResult<LoginCreatorMutation>;
export type LoginCreatorMutationOptions = Apollo.BaseMutationOptions<LoginCreatorMutation, LoginCreatorMutationVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($input: LoginInput!) {
  LoginUser(input: $input) {
    token
    type
    ttl
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const LogoutBusinessUserDocument = gql`
    mutation LogoutBusinessUser {
  LogoutBusinessUser
}
    `;
export type LogoutBusinessUserMutationFn = Apollo.MutationFunction<LogoutBusinessUserMutation, LogoutBusinessUserMutationVariables>;

/**
 * __useLogoutBusinessUserMutation__
 *
 * To run a mutation, you first call `useLogoutBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutBusinessUserMutation, { data, loading, error }] = useLogoutBusinessUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutBusinessUserMutation, LogoutBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutBusinessUserMutation, LogoutBusinessUserMutationVariables>(LogoutBusinessUserDocument, options);
      }
export type LogoutBusinessUserMutationHookResult = ReturnType<typeof useLogoutBusinessUserMutation>;
export type LogoutBusinessUserMutationResult = Apollo.MutationResult<LogoutBusinessUserMutation>;
export type LogoutBusinessUserMutationOptions = Apollo.BaseMutationOptions<LogoutBusinessUserMutation, LogoutBusinessUserMutationVariables>;
export const LogoutCreatorDocument = gql`
    mutation LogoutCreator {
  LogoutCreator
}
    `;
export type LogoutCreatorMutationFn = Apollo.MutationFunction<LogoutCreatorMutation, LogoutCreatorMutationVariables>;

/**
 * __useLogoutCreatorMutation__
 *
 * To run a mutation, you first call `useLogoutCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutCreatorMutation, { data, loading, error }] = useLogoutCreatorMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutCreatorMutation(baseOptions?: Apollo.MutationHookOptions<LogoutCreatorMutation, LogoutCreatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutCreatorMutation, LogoutCreatorMutationVariables>(LogoutCreatorDocument, options);
      }
export type LogoutCreatorMutationHookResult = ReturnType<typeof useLogoutCreatorMutation>;
export type LogoutCreatorMutationResult = Apollo.MutationResult<LogoutCreatorMutation>;
export type LogoutCreatorMutationOptions = Apollo.BaseMutationOptions<LogoutCreatorMutation, LogoutCreatorMutationVariables>;
export const LogoutUserDocument = gql`
    mutation LogoutUser {
  LogoutUser
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const PasswordResetBusinessUserDocument = gql`
    mutation PasswordResetBusinessUser($input: PasswordResetInput!) {
  PasswordResetBusinessUser(input: $input)
}
    `;
export type PasswordResetBusinessUserMutationFn = Apollo.MutationFunction<PasswordResetBusinessUserMutation, PasswordResetBusinessUserMutationVariables>;

/**
 * __usePasswordResetBusinessUserMutation__
 *
 * To run a mutation, you first call `usePasswordResetBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetBusinessUserMutation, { data, loading, error }] = usePasswordResetBusinessUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetBusinessUserMutation, PasswordResetBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetBusinessUserMutation, PasswordResetBusinessUserMutationVariables>(PasswordResetBusinessUserDocument, options);
      }
export type PasswordResetBusinessUserMutationHookResult = ReturnType<typeof usePasswordResetBusinessUserMutation>;
export type PasswordResetBusinessUserMutationResult = Apollo.MutationResult<PasswordResetBusinessUserMutation>;
export type PasswordResetBusinessUserMutationOptions = Apollo.BaseMutationOptions<PasswordResetBusinessUserMutation, PasswordResetBusinessUserMutationVariables>;
export const RegisterAffiliationDocument = gql`
    mutation RegisterAffiliation($input: RegisterAffiliationInput!) {
  RegisterAffiliation(input: $input) {
    id
    name
    creators_count
    created_at
    updated_at
  }
}
    `;
export type RegisterAffiliationMutationFn = Apollo.MutationFunction<RegisterAffiliationMutation, RegisterAffiliationMutationVariables>;

/**
 * __useRegisterAffiliationMutation__
 *
 * To run a mutation, you first call `useRegisterAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAffiliationMutation, { data, loading, error }] = useRegisterAffiliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAffiliationMutation, RegisterAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAffiliationMutation, RegisterAffiliationMutationVariables>(RegisterAffiliationDocument, options);
      }
export type RegisterAffiliationMutationHookResult = ReturnType<typeof useRegisterAffiliationMutation>;
export type RegisterAffiliationMutationResult = Apollo.MutationResult<RegisterAffiliationMutation>;
export type RegisterAffiliationMutationOptions = Apollo.BaseMutationOptions<RegisterAffiliationMutation, RegisterAffiliationMutationVariables>;
export const RegisterLiveTalkProductByBusinessUserDocument = gql`
    mutation RegisterLiveTalkProductByBusinessUser($creator_id: ID!, $input: RegisterLiveTalkProductInput!) {
  RegisterLiveTalkProductByBusinessUser(creator_id: $creator_id, input: $input)
}
    `;
export type RegisterLiveTalkProductByBusinessUserMutationFn = Apollo.MutationFunction<RegisterLiveTalkProductByBusinessUserMutation, RegisterLiveTalkProductByBusinessUserMutationVariables>;

/**
 * __useRegisterLiveTalkProductByBusinessUserMutation__
 *
 * To run a mutation, you first call `useRegisterLiveTalkProductByBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLiveTalkProductByBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLiveTalkProductByBusinessUserMutation, { data, loading, error }] = useRegisterLiveTalkProductByBusinessUserMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterLiveTalkProductByBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterLiveTalkProductByBusinessUserMutation, RegisterLiveTalkProductByBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterLiveTalkProductByBusinessUserMutation, RegisterLiveTalkProductByBusinessUserMutationVariables>(RegisterLiveTalkProductByBusinessUserDocument, options);
      }
export type RegisterLiveTalkProductByBusinessUserMutationHookResult = ReturnType<typeof useRegisterLiveTalkProductByBusinessUserMutation>;
export type RegisterLiveTalkProductByBusinessUserMutationResult = Apollo.MutationResult<RegisterLiveTalkProductByBusinessUserMutation>;
export type RegisterLiveTalkProductByBusinessUserMutationOptions = Apollo.BaseMutationOptions<RegisterLiveTalkProductByBusinessUserMutation, RegisterLiveTalkProductByBusinessUserMutationVariables>;
export const RegisterMovieProductByBusinessUserDocument = gql`
    mutation RegisterMovieProductByBusinessUser($creator_id: ID!, $input: RegisterMovieProductInput!) {
  RegisterMovieProductByBusinessUser(creator_id: $creator_id, input: $input)
}
    `;
export type RegisterMovieProductByBusinessUserMutationFn = Apollo.MutationFunction<RegisterMovieProductByBusinessUserMutation, RegisterMovieProductByBusinessUserMutationVariables>;

/**
 * __useRegisterMovieProductByBusinessUserMutation__
 *
 * To run a mutation, you first call `useRegisterMovieProductByBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMovieProductByBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMovieProductByBusinessUserMutation, { data, loading, error }] = useRegisterMovieProductByBusinessUserMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMovieProductByBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMovieProductByBusinessUserMutation, RegisterMovieProductByBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMovieProductByBusinessUserMutation, RegisterMovieProductByBusinessUserMutationVariables>(RegisterMovieProductByBusinessUserDocument, options);
      }
export type RegisterMovieProductByBusinessUserMutationHookResult = ReturnType<typeof useRegisterMovieProductByBusinessUserMutation>;
export type RegisterMovieProductByBusinessUserMutationResult = Apollo.MutationResult<RegisterMovieProductByBusinessUserMutation>;
export type RegisterMovieProductByBusinessUserMutationOptions = Apollo.BaseMutationOptions<RegisterMovieProductByBusinessUserMutation, RegisterMovieProductByBusinessUserMutationVariables>;
export const RegisterNewCreatorDocument = gql`
    mutation RegisterNewCreator($input: RegisterNewCreatorInput!) {
  RegisterNewCreator(input: $input) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
  }
}
    `;
export type RegisterNewCreatorMutationFn = Apollo.MutationFunction<RegisterNewCreatorMutation, RegisterNewCreatorMutationVariables>;

/**
 * __useRegisterNewCreatorMutation__
 *
 * To run a mutation, you first call `useRegisterNewCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNewCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNewCreatorMutation, { data, loading, error }] = useRegisterNewCreatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterNewCreatorMutation(baseOptions?: Apollo.MutationHookOptions<RegisterNewCreatorMutation, RegisterNewCreatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterNewCreatorMutation, RegisterNewCreatorMutationVariables>(RegisterNewCreatorDocument, options);
      }
export type RegisterNewCreatorMutationHookResult = ReturnType<typeof useRegisterNewCreatorMutation>;
export type RegisterNewCreatorMutationResult = Apollo.MutationResult<RegisterNewCreatorMutation>;
export type RegisterNewCreatorMutationOptions = Apollo.BaseMutationOptions<RegisterNewCreatorMutation, RegisterNewCreatorMutationVariables>;
export const RegisterPhotoProductByBusinessUserDocument = gql`
    mutation RegisterPhotoProductByBusinessUser($creator_id: ID!, $input: RegisterPhotoProductInput!) {
  RegisterPhotoProductByBusinessUser(creator_id: $creator_id, input: $input)
}
    `;
export type RegisterPhotoProductByBusinessUserMutationFn = Apollo.MutationFunction<RegisterPhotoProductByBusinessUserMutation, RegisterPhotoProductByBusinessUserMutationVariables>;

/**
 * __useRegisterPhotoProductByBusinessUserMutation__
 *
 * To run a mutation, you first call `useRegisterPhotoProductByBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPhotoProductByBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPhotoProductByBusinessUserMutation, { data, loading, error }] = useRegisterPhotoProductByBusinessUserMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPhotoProductByBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPhotoProductByBusinessUserMutation, RegisterPhotoProductByBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPhotoProductByBusinessUserMutation, RegisterPhotoProductByBusinessUserMutationVariables>(RegisterPhotoProductByBusinessUserDocument, options);
      }
export type RegisterPhotoProductByBusinessUserMutationHookResult = ReturnType<typeof useRegisterPhotoProductByBusinessUserMutation>;
export type RegisterPhotoProductByBusinessUserMutationResult = Apollo.MutationResult<RegisterPhotoProductByBusinessUserMutation>;
export type RegisterPhotoProductByBusinessUserMutationOptions = Apollo.BaseMutationOptions<RegisterPhotoProductByBusinessUserMutation, RegisterPhotoProductByBusinessUserMutationVariables>;
export const ResendCreatorAccountRegistrationDocument = gql`
    mutation ResendCreatorAccountRegistration($creator_id: ID!) {
  ResendCreatorAccountRegistration(creator_id: $creator_id)
}
    `;
export type ResendCreatorAccountRegistrationMutationFn = Apollo.MutationFunction<ResendCreatorAccountRegistrationMutation, ResendCreatorAccountRegistrationMutationVariables>;

/**
 * __useResendCreatorAccountRegistrationMutation__
 *
 * To run a mutation, you first call `useResendCreatorAccountRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCreatorAccountRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCreatorAccountRegistrationMutation, { data, loading, error }] = useResendCreatorAccountRegistrationMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useResendCreatorAccountRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<ResendCreatorAccountRegistrationMutation, ResendCreatorAccountRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendCreatorAccountRegistrationMutation, ResendCreatorAccountRegistrationMutationVariables>(ResendCreatorAccountRegistrationDocument, options);
      }
export type ResendCreatorAccountRegistrationMutationHookResult = ReturnType<typeof useResendCreatorAccountRegistrationMutation>;
export type ResendCreatorAccountRegistrationMutationResult = Apollo.MutationResult<ResendCreatorAccountRegistrationMutation>;
export type ResendCreatorAccountRegistrationMutationOptions = Apollo.BaseMutationOptions<ResendCreatorAccountRegistrationMutation, ResendCreatorAccountRegistrationMutationVariables>;
export const ResendEmailForVerifyingUpdatedBusinessUserEmailInputDocument = gql`
    mutation ResendEmailForVerifyingUpdatedBusinessUserEmailInput($input: ResendEmailForVerifyingUpdatedBusinessUserEmailInput!) {
  ResendEmailForVerifyingUpdatedBusinessUserEmail(input: $input)
}
    `;
export type ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationFn = Apollo.MutationFunction<ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation, ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationVariables>;

/**
 * __useResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation__
 *
 * To run a mutation, you first call `useResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailForVerifyingUpdatedBusinessUserEmailInputMutation, { data, loading, error }] = useResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation, ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation, ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationVariables>(ResendEmailForVerifyingUpdatedBusinessUserEmailInputDocument, options);
      }
export type ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationHookResult = ReturnType<typeof useResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation>;
export type ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationResult = Apollo.MutationResult<ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation>;
export type ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationOptions = Apollo.BaseMutationOptions<ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutation, ResendEmailForVerifyingUpdatedBusinessUserEmailInputMutationVariables>;
export const ResendUserAccountRegistrationDocument = gql`
    mutation ResendUserAccountRegistration($user_id: ID!, $input: ResendUserAccountRegistrationInput!) {
  ResendUserAccountRegistration(user_id: $user_id, input: $input)
}
    `;
export type ResendUserAccountRegistrationMutationFn = Apollo.MutationFunction<ResendUserAccountRegistrationMutation, ResendUserAccountRegistrationMutationVariables>;

/**
 * __useResendUserAccountRegistrationMutation__
 *
 * To run a mutation, you first call `useResendUserAccountRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserAccountRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserAccountRegistrationMutation, { data, loading, error }] = useResendUserAccountRegistrationMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendUserAccountRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserAccountRegistrationMutation, ResendUserAccountRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserAccountRegistrationMutation, ResendUserAccountRegistrationMutationVariables>(ResendUserAccountRegistrationDocument, options);
      }
export type ResendUserAccountRegistrationMutationHookResult = ReturnType<typeof useResendUserAccountRegistrationMutation>;
export type ResendUserAccountRegistrationMutationResult = Apollo.MutationResult<ResendUserAccountRegistrationMutation>;
export type ResendUserAccountRegistrationMutationOptions = Apollo.BaseMutationOptions<ResendUserAccountRegistrationMutation, ResendUserAccountRegistrationMutationVariables>;
export const UnfavoriteCreatorDocument = gql`
    mutation UnfavoriteCreator($creator_id: ID!) {
  UnfavoriteCreator(creator_id: $creator_id)
}
    `;
export type UnfavoriteCreatorMutationFn = Apollo.MutationFunction<UnfavoriteCreatorMutation, UnfavoriteCreatorMutationVariables>;

/**
 * __useUnfavoriteCreatorMutation__
 *
 * To run a mutation, you first call `useUnfavoriteCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfavoriteCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfavoriteCreatorMutation, { data, loading, error }] = useUnfavoriteCreatorMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useUnfavoriteCreatorMutation(baseOptions?: Apollo.MutationHookOptions<UnfavoriteCreatorMutation, UnfavoriteCreatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfavoriteCreatorMutation, UnfavoriteCreatorMutationVariables>(UnfavoriteCreatorDocument, options);
      }
export type UnfavoriteCreatorMutationHookResult = ReturnType<typeof useUnfavoriteCreatorMutation>;
export type UnfavoriteCreatorMutationResult = Apollo.MutationResult<UnfavoriteCreatorMutation>;
export type UnfavoriteCreatorMutationOptions = Apollo.BaseMutationOptions<UnfavoriteCreatorMutation, UnfavoriteCreatorMutationVariables>;
export const UpdateBusinessUserAccountDocument = gql`
    mutation UpdateBusinessUserAccount($input: UpdateBusinessUserAccountInput!) {
  UpdateBusinessUserAccount(input: $input) {
    is_change_request_email
    change_request_email
  }
}
    `;
export type UpdateBusinessUserAccountMutationFn = Apollo.MutationFunction<UpdateBusinessUserAccountMutation, UpdateBusinessUserAccountMutationVariables>;

/**
 * __useUpdateBusinessUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUserAccountMutation, { data, loading, error }] = useUpdateBusinessUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessUserAccountMutation, UpdateBusinessUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessUserAccountMutation, UpdateBusinessUserAccountMutationVariables>(UpdateBusinessUserAccountDocument, options);
      }
export type UpdateBusinessUserAccountMutationHookResult = ReturnType<typeof useUpdateBusinessUserAccountMutation>;
export type UpdateBusinessUserAccountMutationResult = Apollo.MutationResult<UpdateBusinessUserAccountMutation>;
export type UpdateBusinessUserAccountMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUserAccountMutation, UpdateBusinessUserAccountMutationVariables>;
export const UpdateBusinessUserEmailByTokenDocument = gql`
    mutation UpdateBusinessUserEmailByToken($input: UpdateEmailByTokenInput!) {
  UpdateBusinessUserEmailByToken(input: $input) {
    id
    name
    email
    created_at
    updated_at
  }
}
    `;
export type UpdateBusinessUserEmailByTokenMutationFn = Apollo.MutationFunction<UpdateBusinessUserEmailByTokenMutation, UpdateBusinessUserEmailByTokenMutationVariables>;

/**
 * __useUpdateBusinessUserEmailByTokenMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUserEmailByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUserEmailByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUserEmailByTokenMutation, { data, loading, error }] = useUpdateBusinessUserEmailByTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessUserEmailByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessUserEmailByTokenMutation, UpdateBusinessUserEmailByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessUserEmailByTokenMutation, UpdateBusinessUserEmailByTokenMutationVariables>(UpdateBusinessUserEmailByTokenDocument, options);
      }
export type UpdateBusinessUserEmailByTokenMutationHookResult = ReturnType<typeof useUpdateBusinessUserEmailByTokenMutation>;
export type UpdateBusinessUserEmailByTokenMutationResult = Apollo.MutationResult<UpdateBusinessUserEmailByTokenMutation>;
export type UpdateBusinessUserEmailByTokenMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUserEmailByTokenMutation, UpdateBusinessUserEmailByTokenMutationVariables>;
export const UpdateCreatorAccountDocument = gql`
    mutation UpdateCreatorAccount($creator_id: ID!, $input: UpdateCreatorAccountInput!) {
  UpdateCreatorAccount(creator_id: $creator_id, input: $input) {
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
    }
    is_change_request_email
    change_request_email
  }
}
    `;
export type UpdateCreatorAccountMutationFn = Apollo.MutationFunction<UpdateCreatorAccountMutation, UpdateCreatorAccountMutationVariables>;

/**
 * __useUpdateCreatorAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorAccountMutation, { data, loading, error }] = useUpdateCreatorAccountMutation({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreatorAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorAccountMutation, UpdateCreatorAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorAccountMutation, UpdateCreatorAccountMutationVariables>(UpdateCreatorAccountDocument, options);
      }
export type UpdateCreatorAccountMutationHookResult = ReturnType<typeof useUpdateCreatorAccountMutation>;
export type UpdateCreatorAccountMutationResult = Apollo.MutationResult<UpdateCreatorAccountMutation>;
export type UpdateCreatorAccountMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorAccountMutation, UpdateCreatorAccountMutationVariables>;
export const UpdateCreatorAccountByTokenDocument = gql`
    mutation UpdateCreatorAccountByToken($input: UpdateCreatorAccountByTokenInput!) {
  UpdateCreatorAccountByToken(input: $input) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;
export type UpdateCreatorAccountByTokenMutationFn = Apollo.MutationFunction<UpdateCreatorAccountByTokenMutation, UpdateCreatorAccountByTokenMutationVariables>;

/**
 * __useUpdateCreatorAccountByTokenMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorAccountByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorAccountByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorAccountByTokenMutation, { data, loading, error }] = useUpdateCreatorAccountByTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreatorAccountByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorAccountByTokenMutation, UpdateCreatorAccountByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorAccountByTokenMutation, UpdateCreatorAccountByTokenMutationVariables>(UpdateCreatorAccountByTokenDocument, options);
      }
export type UpdateCreatorAccountByTokenMutationHookResult = ReturnType<typeof useUpdateCreatorAccountByTokenMutation>;
export type UpdateCreatorAccountByTokenMutationResult = Apollo.MutationResult<UpdateCreatorAccountByTokenMutation>;
export type UpdateCreatorAccountByTokenMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorAccountByTokenMutation, UpdateCreatorAccountByTokenMutationVariables>;
export const UpdateCreatorEmailByTokenDocument = gql`
    mutation UpdateCreatorEmailByToken($input: UpdateEmailByTokenInput!) {
  UpdateCreatorEmailByToken(input: $input) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    favorite_users_count
  }
}
    `;
export type UpdateCreatorEmailByTokenMutationFn = Apollo.MutationFunction<UpdateCreatorEmailByTokenMutation, UpdateCreatorEmailByTokenMutationVariables>;

/**
 * __useUpdateCreatorEmailByTokenMutation__
 *
 * To run a mutation, you first call `useUpdateCreatorEmailByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatorEmailByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatorEmailByTokenMutation, { data, loading, error }] = useUpdateCreatorEmailByTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreatorEmailByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatorEmailByTokenMutation, UpdateCreatorEmailByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatorEmailByTokenMutation, UpdateCreatorEmailByTokenMutationVariables>(UpdateCreatorEmailByTokenDocument, options);
      }
export type UpdateCreatorEmailByTokenMutationHookResult = ReturnType<typeof useUpdateCreatorEmailByTokenMutation>;
export type UpdateCreatorEmailByTokenMutationResult = Apollo.MutationResult<UpdateCreatorEmailByTokenMutation>;
export type UpdateCreatorEmailByTokenMutationOptions = Apollo.BaseMutationOptions<UpdateCreatorEmailByTokenMutation, UpdateCreatorEmailByTokenMutationVariables>;
export const UpdatePasswordBusinessUserDocument = gql`
    mutation UpdatePasswordBusinessUser($business_user_id: ID!, $input: UpdatePasswordInput!) {
  UpdatePasswordBusinessUser(business_user_id: $business_user_id, input: $input)
}
    `;
export type UpdatePasswordBusinessUserMutationFn = Apollo.MutationFunction<UpdatePasswordBusinessUserMutation, UpdatePasswordBusinessUserMutationVariables>;

/**
 * __useUpdatePasswordBusinessUserMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordBusinessUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordBusinessUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordBusinessUserMutation, { data, loading, error }] = useUpdatePasswordBusinessUserMutation({
 *   variables: {
 *      business_user_id: // value for 'business_user_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordBusinessUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordBusinessUserMutation, UpdatePasswordBusinessUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordBusinessUserMutation, UpdatePasswordBusinessUserMutationVariables>(UpdatePasswordBusinessUserDocument, options);
      }
export type UpdatePasswordBusinessUserMutationHookResult = ReturnType<typeof useUpdatePasswordBusinessUserMutation>;
export type UpdatePasswordBusinessUserMutationResult = Apollo.MutationResult<UpdatePasswordBusinessUserMutation>;
export type UpdatePasswordBusinessUserMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordBusinessUserMutation, UpdatePasswordBusinessUserMutationVariables>;
export const UpdateUserAccountDocument = gql`
    mutation UpdateUserAccount($input: UpdateUserAccountInput!) {
  UpdateUserAccount(input: $input) {
    is_change_request_email
    change_request_email
  }
}
    `;
export type UpdateUserAccountMutationFn = Apollo.MutationFunction<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;

/**
 * __useUpdateUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountMutation, { data, loading, error }] = useUpdateUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>(UpdateUserAccountDocument, options);
      }
export type UpdateUserAccountMutationHookResult = ReturnType<typeof useUpdateUserAccountMutation>;
export type UpdateUserAccountMutationResult = Apollo.MutationResult<UpdateUserAccountMutation>;
export type UpdateUserAccountMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;
export const UpdateUserEmailByTokenDocument = gql`
    mutation UpdateUserEmailByToken($input: UpdateEmailByTokenInput!) {
  UpdateUserEmailByToken(input: $input) {
    id
    status
    name
    email
    twitter_username
    created_at
    updated_at
  }
}
    `;
export type UpdateUserEmailByTokenMutationFn = Apollo.MutationFunction<UpdateUserEmailByTokenMutation, UpdateUserEmailByTokenMutationVariables>;

/**
 * __useUpdateUserEmailByTokenMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmailByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmailByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmailByTokenMutation, { data, loading, error }] = useUpdateUserEmailByTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserEmailByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserEmailByTokenMutation, UpdateUserEmailByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserEmailByTokenMutation, UpdateUserEmailByTokenMutationVariables>(UpdateUserEmailByTokenDocument, options);
      }
export type UpdateUserEmailByTokenMutationHookResult = ReturnType<typeof useUpdateUserEmailByTokenMutation>;
export type UpdateUserEmailByTokenMutationResult = Apollo.MutationResult<UpdateUserEmailByTokenMutation>;
export type UpdateUserEmailByTokenMutationOptions = Apollo.BaseMutationOptions<UpdateUserEmailByTokenMutation, UpdateUserEmailByTokenMutationVariables>;
export const UserPasswordResetDocument = gql`
    mutation UserPasswordReset($input: PasswordResetInput!) {
  UserPasswordReset(input: $input)
}
    `;
export type UserPasswordResetMutationFn = Apollo.MutationFunction<UserPasswordResetMutation, UserPasswordResetMutationVariables>;

/**
 * __useUserPasswordResetMutation__
 *
 * To run a mutation, you first call `useUserPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPasswordResetMutation, { data, loading, error }] = useUserPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<UserPasswordResetMutation, UserPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserPasswordResetMutation, UserPasswordResetMutationVariables>(UserPasswordResetDocument, options);
      }
export type UserPasswordResetMutationHookResult = ReturnType<typeof useUserPasswordResetMutation>;
export type UserPasswordResetMutationResult = Apollo.MutationResult<UserPasswordResetMutation>;
export type UserPasswordResetMutationOptions = Apollo.BaseMutationOptions<UserPasswordResetMutation, UserPasswordResetMutationVariables>;
export const UserPurchaseProductDocument = gql`
    mutation UserPurchaseProduct($product_id: ID!) {
  UserPurchaseProduct(product_id: $product_id) {
    order {
      id
      price
      paid_limit
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    paidy {
      payload {
        amount
        currency
        store_name
        buyer {
          email
        }
        buyer_data {
          user_id
          age
          order_count
          ltv
          last_order_amount
          last_order_at
        }
        order {
          items {
            id
            quantity
            title
            unit_price
          }
          order_ref
        }
      }
      payload_json
      public_key
    }
    robot_payment {
      credit_card_link
      store_id
      price
      tax
      shipping_fee
      job_type
      order_id
      email
      product_name
      product_id
    }
  }
}
    `;
export type UserPurchaseProductMutationFn = Apollo.MutationFunction<UserPurchaseProductMutation, UserPurchaseProductMutationVariables>;

/**
 * __useUserPurchaseProductMutation__
 *
 * To run a mutation, you first call `useUserPurchaseProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPurchaseProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPurchaseProductMutation, { data, loading, error }] = useUserPurchaseProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useUserPurchaseProductMutation(baseOptions?: Apollo.MutationHookOptions<UserPurchaseProductMutation, UserPurchaseProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserPurchaseProductMutation, UserPurchaseProductMutationVariables>(UserPurchaseProductDocument, options);
      }
export type UserPurchaseProductMutationHookResult = ReturnType<typeof useUserPurchaseProductMutation>;
export type UserPurchaseProductMutationResult = Apollo.MutationResult<UserPurchaseProductMutation>;
export type UserPurchaseProductMutationOptions = Apollo.BaseMutationOptions<UserPurchaseProductMutation, UserPurchaseProductMutationVariables>;
export const UserRegisterAccountDocument = gql`
    mutation UserRegisterAccount($input: UserRegisterAccountInput!) {
  UserRegisterAccount(input: $input) {
    id
    status
    name
    email
    twitter_username
    created_at
    updated_at
  }
}
    `;
export type UserRegisterAccountMutationFn = Apollo.MutationFunction<UserRegisterAccountMutation, UserRegisterAccountMutationVariables>;

/**
 * __useUserRegisterAccountMutation__
 *
 * To run a mutation, you first call `useUserRegisterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRegisterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRegisterAccountMutation, { data, loading, error }] = useUserRegisterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserRegisterAccountMutation(baseOptions?: Apollo.MutationHookOptions<UserRegisterAccountMutation, UserRegisterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRegisterAccountMutation, UserRegisterAccountMutationVariables>(UserRegisterAccountDocument, options);
      }
export type UserRegisterAccountMutationHookResult = ReturnType<typeof useUserRegisterAccountMutation>;
export type UserRegisterAccountMutationResult = Apollo.MutationResult<UserRegisterAccountMutation>;
export type UserRegisterAccountMutationOptions = Apollo.BaseMutationOptions<UserRegisterAccountMutation, UserRegisterAccountMutationVariables>;
export const UserRequestLiveTalkDocument = gql`
    mutation UserRequestLiveTalk($input: RequestLiveTalkInput!) {
  UserRequestLiveTalk(input: $input)
}
    `;
export type UserRequestLiveTalkMutationFn = Apollo.MutationFunction<UserRequestLiveTalkMutation, UserRequestLiveTalkMutationVariables>;

/**
 * __useUserRequestLiveTalkMutation__
 *
 * To run a mutation, you first call `useUserRequestLiveTalkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestLiveTalkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestLiveTalkMutation, { data, loading, error }] = useUserRequestLiveTalkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserRequestLiveTalkMutation(baseOptions?: Apollo.MutationHookOptions<UserRequestLiveTalkMutation, UserRequestLiveTalkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRequestLiveTalkMutation, UserRequestLiveTalkMutationVariables>(UserRequestLiveTalkDocument, options);
      }
export type UserRequestLiveTalkMutationHookResult = ReturnType<typeof useUserRequestLiveTalkMutation>;
export type UserRequestLiveTalkMutationResult = Apollo.MutationResult<UserRequestLiveTalkMutation>;
export type UserRequestLiveTalkMutationOptions = Apollo.BaseMutationOptions<UserRequestLiveTalkMutation, UserRequestLiveTalkMutationVariables>;
export const UserRequestMovieDocument = gql`
    mutation UserRequestMovie($input: RequestMovieInput!) {
  UserRequestMovie(input: $input)
}
    `;
export type UserRequestMovieMutationFn = Apollo.MutationFunction<UserRequestMovieMutation, UserRequestMovieMutationVariables>;

/**
 * __useUserRequestMovieMutation__
 *
 * To run a mutation, you first call `useUserRequestMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestMovieMutation, { data, loading, error }] = useUserRequestMovieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserRequestMovieMutation(baseOptions?: Apollo.MutationHookOptions<UserRequestMovieMutation, UserRequestMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRequestMovieMutation, UserRequestMovieMutationVariables>(UserRequestMovieDocument, options);
      }
export type UserRequestMovieMutationHookResult = ReturnType<typeof useUserRequestMovieMutation>;
export type UserRequestMovieMutationResult = Apollo.MutationResult<UserRequestMovieMutation>;
export type UserRequestMovieMutationOptions = Apollo.BaseMutationOptions<UserRequestMovieMutation, UserRequestMovieMutationVariables>;
export const UserRequestPhotoDocument = gql`
    mutation UserRequestPhoto($input: RequestPhotoInput!) {
  UserRequestPhoto(input: $input)
}
    `;
export type UserRequestPhotoMutationFn = Apollo.MutationFunction<UserRequestPhotoMutation, UserRequestPhotoMutationVariables>;

/**
 * __useUserRequestPhotoMutation__
 *
 * To run a mutation, you first call `useUserRequestPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestPhotoMutation, { data, loading, error }] = useUserRequestPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserRequestPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UserRequestPhotoMutation, UserRequestPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRequestPhotoMutation, UserRequestPhotoMutationVariables>(UserRequestPhotoDocument, options);
      }
export type UserRequestPhotoMutationHookResult = ReturnType<typeof useUserRequestPhotoMutation>;
export type UserRequestPhotoMutationResult = Apollo.MutationResult<UserRequestPhotoMutation>;
export type UserRequestPhotoMutationOptions = Apollo.BaseMutationOptions<UserRequestPhotoMutation, UserRequestPhotoMutationVariables>;
export const UserUpdatePasswordDocument = gql`
    mutation UserUpdatePassword($user_id: ID!, $input: UpdatePasswordInput!) {
  UserUpdatePassword(user_id: $user_id, input: $input)
}
    `;
export type UserUpdatePasswordMutationFn = Apollo.MutationFunction<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>;

/**
 * __useUserUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUserUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatePasswordMutation, { data, loading, error }] = useUserUpdatePasswordMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>(UserUpdatePasswordDocument, options);
      }
export type UserUpdatePasswordMutationHookResult = ReturnType<typeof useUserUpdatePasswordMutation>;
export type UserUpdatePasswordMutationResult = Apollo.MutationResult<UserUpdatePasswordMutation>;
export type UserUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>;
export const UserVerifyAccountDocument = gql`
    mutation UserVerifyAccount($user_id: ID!, $input: UserVerifyAccountInput!) {
  UserVerifyAccount(user_id: $user_id, input: $input) {
    token
    type
    ttl
  }
}
    `;
export type UserVerifyAccountMutationFn = Apollo.MutationFunction<UserVerifyAccountMutation, UserVerifyAccountMutationVariables>;

/**
 * __useUserVerifyAccountMutation__
 *
 * To run a mutation, you first call `useUserVerifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserVerifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userVerifyAccountMutation, { data, loading, error }] = useUserVerifyAccountMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserVerifyAccountMutation(baseOptions?: Apollo.MutationHookOptions<UserVerifyAccountMutation, UserVerifyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserVerifyAccountMutation, UserVerifyAccountMutationVariables>(UserVerifyAccountDocument, options);
      }
export type UserVerifyAccountMutationHookResult = ReturnType<typeof useUserVerifyAccountMutation>;
export type UserVerifyAccountMutationResult = Apollo.MutationResult<UserVerifyAccountMutation>;
export type UserVerifyAccountMutationOptions = Apollo.BaseMutationOptions<UserVerifyAccountMutation, UserVerifyAccountMutationVariables>;
export const ActiveCreatorDocument = gql`
    query ActiveCreator($id: ID!) {
  ActiveCreator(id: $id) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useActiveCreatorQuery__
 *
 * To run a query within a React component, call `useActiveCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCreatorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActiveCreatorQuery(baseOptions: Apollo.QueryHookOptions<ActiveCreatorQuery, ActiveCreatorQueryVariables> & ({ variables: ActiveCreatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveCreatorQuery, ActiveCreatorQueryVariables>(ActiveCreatorDocument, options);
      }
export function useActiveCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveCreatorQuery, ActiveCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveCreatorQuery, ActiveCreatorQueryVariables>(ActiveCreatorDocument, options);
        }
export function useActiveCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveCreatorQuery, ActiveCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveCreatorQuery, ActiveCreatorQueryVariables>(ActiveCreatorDocument, options);
        }
export type ActiveCreatorQueryHookResult = ReturnType<typeof useActiveCreatorQuery>;
export type ActiveCreatorLazyQueryHookResult = ReturnType<typeof useActiveCreatorLazyQuery>;
export type ActiveCreatorSuspenseQueryHookResult = ReturnType<typeof useActiveCreatorSuspenseQuery>;
export type ActiveCreatorQueryResult = Apollo.QueryResult<ActiveCreatorQuery, ActiveCreatorQueryVariables>;
export const ActiveCreatorsInAffiliationDocument = gql`
    query ActiveCreatorsInAffiliation($affiliation_id: ID) {
  ActiveCreatorsInAffiliation(affiliation_id: $affiliation_id) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useActiveCreatorsInAffiliationQuery__
 *
 * To run a query within a React component, call `useActiveCreatorsInAffiliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCreatorsInAffiliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCreatorsInAffiliationQuery({
 *   variables: {
 *      affiliation_id: // value for 'affiliation_id'
 *   },
 * });
 */
export function useActiveCreatorsInAffiliationQuery(baseOptions?: Apollo.QueryHookOptions<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>(ActiveCreatorsInAffiliationDocument, options);
      }
export function useActiveCreatorsInAffiliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>(ActiveCreatorsInAffiliationDocument, options);
        }
export function useActiveCreatorsInAffiliationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>(ActiveCreatorsInAffiliationDocument, options);
        }
export type ActiveCreatorsInAffiliationQueryHookResult = ReturnType<typeof useActiveCreatorsInAffiliationQuery>;
export type ActiveCreatorsInAffiliationLazyQueryHookResult = ReturnType<typeof useActiveCreatorsInAffiliationLazyQuery>;
export type ActiveCreatorsInAffiliationSuspenseQueryHookResult = ReturnType<typeof useActiveCreatorsInAffiliationSuspenseQuery>;
export type ActiveCreatorsInAffiliationQueryResult = Apollo.QueryResult<ActiveCreatorsInAffiliationQuery, ActiveCreatorsInAffiliationQueryVariables>;
export const ActiveCreatorsInBusinessDocument = gql`
    query ActiveCreatorsInBusiness {
  ActiveCreatorsInBusiness {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useActiveCreatorsInBusinessQuery__
 *
 * To run a query within a React component, call `useActiveCreatorsInBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCreatorsInBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCreatorsInBusinessQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveCreatorsInBusinessQuery(baseOptions?: Apollo.QueryHookOptions<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>(ActiveCreatorsInBusinessDocument, options);
      }
export function useActiveCreatorsInBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>(ActiveCreatorsInBusinessDocument, options);
        }
export function useActiveCreatorsInBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>(ActiveCreatorsInBusinessDocument, options);
        }
export type ActiveCreatorsInBusinessQueryHookResult = ReturnType<typeof useActiveCreatorsInBusinessQuery>;
export type ActiveCreatorsInBusinessLazyQueryHookResult = ReturnType<typeof useActiveCreatorsInBusinessLazyQuery>;
export type ActiveCreatorsInBusinessSuspenseQueryHookResult = ReturnType<typeof useActiveCreatorsInBusinessSuspenseQuery>;
export type ActiveCreatorsInBusinessQueryResult = Apollo.QueryResult<ActiveCreatorsInBusinessQuery, ActiveCreatorsInBusinessQueryVariables>;
export const AffiliationInBusinessDocument = gql`
    query AffiliationInBusiness($affiliation_id: ID) {
  AffiliationInBusiness(affiliation_id: $affiliation_id) {
    id
    name
    creators_count
    created_at
    updated_at
  }
}
    `;

/**
 * __useAffiliationInBusinessQuery__
 *
 * To run a query within a React component, call `useAffiliationInBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationInBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationInBusinessQuery({
 *   variables: {
 *      affiliation_id: // value for 'affiliation_id'
 *   },
 * });
 */
export function useAffiliationInBusinessQuery(baseOptions?: Apollo.QueryHookOptions<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>(AffiliationInBusinessDocument, options);
      }
export function useAffiliationInBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>(AffiliationInBusinessDocument, options);
        }
export function useAffiliationInBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>(AffiliationInBusinessDocument, options);
        }
export type AffiliationInBusinessQueryHookResult = ReturnType<typeof useAffiliationInBusinessQuery>;
export type AffiliationInBusinessLazyQueryHookResult = ReturnType<typeof useAffiliationInBusinessLazyQuery>;
export type AffiliationInBusinessSuspenseQueryHookResult = ReturnType<typeof useAffiliationInBusinessSuspenseQuery>;
export type AffiliationInBusinessQueryResult = Apollo.QueryResult<AffiliationInBusinessQuery, AffiliationInBusinessQueryVariables>;
export const AffiliationSaleThisMonthDocument = gql`
    query AffiliationSaleThisMonth($affiliation_id: ID!) {
  AffiliationSaleThisMonth(affiliation_id: $affiliation_id) {
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    sale_this_month {
      month
      count
      sales
      delivered_sales
    }
  }
}
    `;

/**
 * __useAffiliationSaleThisMonthQuery__
 *
 * To run a query within a React component, call `useAffiliationSaleThisMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationSaleThisMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationSaleThisMonthQuery({
 *   variables: {
 *      affiliation_id: // value for 'affiliation_id'
 *   },
 * });
 */
export function useAffiliationSaleThisMonthQuery(baseOptions: Apollo.QueryHookOptions<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables> & ({ variables: AffiliationSaleThisMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables>(AffiliationSaleThisMonthDocument, options);
      }
export function useAffiliationSaleThisMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables>(AffiliationSaleThisMonthDocument, options);
        }
export function useAffiliationSaleThisMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables>(AffiliationSaleThisMonthDocument, options);
        }
export type AffiliationSaleThisMonthQueryHookResult = ReturnType<typeof useAffiliationSaleThisMonthQuery>;
export type AffiliationSaleThisMonthLazyQueryHookResult = ReturnType<typeof useAffiliationSaleThisMonthLazyQuery>;
export type AffiliationSaleThisMonthSuspenseQueryHookResult = ReturnType<typeof useAffiliationSaleThisMonthSuspenseQuery>;
export type AffiliationSaleThisMonthQueryResult = Apollo.QueryResult<AffiliationSaleThisMonthQuery, AffiliationSaleThisMonthQueryVariables>;
export const AffiliationSalesPerMonthDocument = gql`
    query AffiliationSalesPerMonth($affiliation_id: ID) {
  AffiliationSalesPerMonth(affiliation_id: $affiliation_id) {
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    sales_per_month {
      month
      count
      sales
      delivered_sales
    }
  }
}
    `;

/**
 * __useAffiliationSalesPerMonthQuery__
 *
 * To run a query within a React component, call `useAffiliationSalesPerMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationSalesPerMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationSalesPerMonthQuery({
 *   variables: {
 *      affiliation_id: // value for 'affiliation_id'
 *   },
 * });
 */
export function useAffiliationSalesPerMonthQuery(baseOptions?: Apollo.QueryHookOptions<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>(AffiliationSalesPerMonthDocument, options);
      }
export function useAffiliationSalesPerMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>(AffiliationSalesPerMonthDocument, options);
        }
export function useAffiliationSalesPerMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>(AffiliationSalesPerMonthDocument, options);
        }
export type AffiliationSalesPerMonthQueryHookResult = ReturnType<typeof useAffiliationSalesPerMonthQuery>;
export type AffiliationSalesPerMonthLazyQueryHookResult = ReturnType<typeof useAffiliationSalesPerMonthLazyQuery>;
export type AffiliationSalesPerMonthSuspenseQueryHookResult = ReturnType<typeof useAffiliationSalesPerMonthSuspenseQuery>;
export type AffiliationSalesPerMonthQueryResult = Apollo.QueryResult<AffiliationSalesPerMonthQuery, AffiliationSalesPerMonthQueryVariables>;
export const AffiliationsInBusinessDocument = gql`
    query AffiliationsInBusiness {
  AffiliationsInBusiness {
    id
    name
    creators_count
    created_at
    updated_at
  }
}
    `;

/**
 * __useAffiliationsInBusinessQuery__
 *
 * To run a query within a React component, call `useAffiliationsInBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationsInBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationsInBusinessQuery({
 *   variables: {
 *   },
 * });
 */
export function useAffiliationsInBusinessQuery(baseOptions?: Apollo.QueryHookOptions<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>(AffiliationsInBusinessDocument, options);
      }
export function useAffiliationsInBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>(AffiliationsInBusinessDocument, options);
        }
export function useAffiliationsInBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>(AffiliationsInBusinessDocument, options);
        }
export type AffiliationsInBusinessQueryHookResult = ReturnType<typeof useAffiliationsInBusinessQuery>;
export type AffiliationsInBusinessLazyQueryHookResult = ReturnType<typeof useAffiliationsInBusinessLazyQuery>;
export type AffiliationsInBusinessSuspenseQueryHookResult = ReturnType<typeof useAffiliationsInBusinessSuspenseQuery>;
export type AffiliationsInBusinessQueryResult = Apollo.QueryResult<AffiliationsInBusinessQuery, AffiliationsInBusinessQueryVariables>;
export const BusinessCreateVideoChatRoomTokenDocument = gql`
    query BusinessCreateVideoChatRoomToken($product_id: ID!, $creator_id: ID!) {
  BusinessCreateVideoChatRoomToken(
    product_id: $product_id
    creator_id: $creator_id
  )
}
    `;

/**
 * __useBusinessCreateVideoChatRoomTokenQuery__
 *
 * To run a query within a React component, call `useBusinessCreateVideoChatRoomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessCreateVideoChatRoomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessCreateVideoChatRoomTokenQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useBusinessCreateVideoChatRoomTokenQuery(baseOptions: Apollo.QueryHookOptions<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables> & ({ variables: BusinessCreateVideoChatRoomTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables>(BusinessCreateVideoChatRoomTokenDocument, options);
      }
export function useBusinessCreateVideoChatRoomTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables>(BusinessCreateVideoChatRoomTokenDocument, options);
        }
export function useBusinessCreateVideoChatRoomTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables>(BusinessCreateVideoChatRoomTokenDocument, options);
        }
export type BusinessCreateVideoChatRoomTokenQueryHookResult = ReturnType<typeof useBusinessCreateVideoChatRoomTokenQuery>;
export type BusinessCreateVideoChatRoomTokenLazyQueryHookResult = ReturnType<typeof useBusinessCreateVideoChatRoomTokenLazyQuery>;
export type BusinessCreateVideoChatRoomTokenSuspenseQueryHookResult = ReturnType<typeof useBusinessCreateVideoChatRoomTokenSuspenseQuery>;
export type BusinessCreateVideoChatRoomTokenQueryResult = Apollo.QueryResult<BusinessCreateVideoChatRoomTokenQuery, BusinessCreateVideoChatRoomTokenQueryVariables>;
export const BusinessCreatorMypageDocument = gql`
    query BusinessCreatorMypage($id: ID!) {
  BusinessCreatorMypage(id: $id) {
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    sales {
      month
      count
      sales
      delivered_sales
    }
    published_products {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      movie_seconds
      created_at
      updated_at
      deleted_at
    }
    reserved_products {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      movie_seconds
      created_at
      updated_at
      deleted_at
    }
    disabled_products {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      movie_seconds
      created_at
      updated_at
      deleted_at
    }
  }
}
    `;

/**
 * __useBusinessCreatorMypageQuery__
 *
 * To run a query within a React component, call `useBusinessCreatorMypageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessCreatorMypageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessCreatorMypageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessCreatorMypageQuery(baseOptions: Apollo.QueryHookOptions<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables> & ({ variables: BusinessCreatorMypageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables>(BusinessCreatorMypageDocument, options);
      }
export function useBusinessCreatorMypageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables>(BusinessCreatorMypageDocument, options);
        }
export function useBusinessCreatorMypageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables>(BusinessCreatorMypageDocument, options);
        }
export type BusinessCreatorMypageQueryHookResult = ReturnType<typeof useBusinessCreatorMypageQuery>;
export type BusinessCreatorMypageLazyQueryHookResult = ReturnType<typeof useBusinessCreatorMypageLazyQuery>;
export type BusinessCreatorMypageSuspenseQueryHookResult = ReturnType<typeof useBusinessCreatorMypageSuspenseQuery>;
export type BusinessCreatorMypageQueryResult = Apollo.QueryResult<BusinessCreatorMypageQuery, BusinessCreatorMypageQueryVariables>;
export const BusinessOrderedProductDocument = gql`
    query BusinessOrderedProduct($ordered_product_id: ID!) {
  BusinessOrderedProduct(ordered_product_id: $ordered_product_id) {
    id
    status
    live_talk_status
    creator_id
    order_id
    product_id
    is_sent_reminder_delivery_1day_ago_mail
    is_sent_reminder_delivery_1hour_ago_mail
    is_sent_reminder_delivery_after_mail
    created_at
    updated_at
    delivered_at
    delivery_limit_date
    is_delivered
    is_processing
    is_undelivered
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    order {
      id
      delivered_at
      paid_at
      movie_seconds
      status
      user {
        id
        status
        name
        email
        twitter_username
        created_at
        updated_at
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    product {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    latest_delivered_product {
      id
      ordered_product_id
      delivered_product_url
      delivered_product_thumbnail_url
      delivered_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useBusinessOrderedProductQuery__
 *
 * To run a query within a React component, call `useBusinessOrderedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessOrderedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessOrderedProductQuery({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useBusinessOrderedProductQuery(baseOptions: Apollo.QueryHookOptions<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables> & ({ variables: BusinessOrderedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables>(BusinessOrderedProductDocument, options);
      }
export function useBusinessOrderedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables>(BusinessOrderedProductDocument, options);
        }
export function useBusinessOrderedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables>(BusinessOrderedProductDocument, options);
        }
export type BusinessOrderedProductQueryHookResult = ReturnType<typeof useBusinessOrderedProductQuery>;
export type BusinessOrderedProductLazyQueryHookResult = ReturnType<typeof useBusinessOrderedProductLazyQuery>;
export type BusinessOrderedProductSuspenseQueryHookResult = ReturnType<typeof useBusinessOrderedProductSuspenseQuery>;
export type BusinessOrderedProductQueryResult = Apollo.QueryResult<BusinessOrderedProductQuery, BusinessOrderedProductQueryVariables>;
export const BusinessProductDocument = gql`
    query BusinessProduct($product_id: ID!) {
  BusinessProduct(product_id: $product_id) {
    id
    name
    creator_id
    status
    price
    special_price
    stock
    remaining_stock
    sold_outed
    thumbnail_image
    released_at
    product_type
    product_type_name
    movie_seconds
    created_at
    updated_at
    deleted_at
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    is_movie
    is_photo
    is_live_talk
    live_talk {
      product_id
      started_at
      talk_minutes
    }
  }
}
    `;

/**
 * __useBusinessProductQuery__
 *
 * To run a query within a React component, call `useBusinessProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessProductQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useBusinessProductQuery(baseOptions: Apollo.QueryHookOptions<BusinessProductQuery, BusinessProductQueryVariables> & ({ variables: BusinessProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessProductQuery, BusinessProductQueryVariables>(BusinessProductDocument, options);
      }
export function useBusinessProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessProductQuery, BusinessProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessProductQuery, BusinessProductQueryVariables>(BusinessProductDocument, options);
        }
export function useBusinessProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessProductQuery, BusinessProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessProductQuery, BusinessProductQueryVariables>(BusinessProductDocument, options);
        }
export type BusinessProductQueryHookResult = ReturnType<typeof useBusinessProductQuery>;
export type BusinessProductLazyQueryHookResult = ReturnType<typeof useBusinessProductLazyQuery>;
export type BusinessProductSuspenseQueryHookResult = ReturnType<typeof useBusinessProductSuspenseQuery>;
export type BusinessProductQueryResult = Apollo.QueryResult<BusinessProductQuery, BusinessProductQueryVariables>;
export const BusinessSalesPerMonthDocument = gql`
    query BusinessSalesPerMonth {
  BusinessSalesPerMonth {
    sales_per_month {
      month
      count
      sales
      delivered_sales
    }
    total_sales
  }
}
    `;

/**
 * __useBusinessSalesPerMonthQuery__
 *
 * To run a query within a React component, call `useBusinessSalesPerMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessSalesPerMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessSalesPerMonthQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessSalesPerMonthQuery(baseOptions?: Apollo.QueryHookOptions<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>(BusinessSalesPerMonthDocument, options);
      }
export function useBusinessSalesPerMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>(BusinessSalesPerMonthDocument, options);
        }
export function useBusinessSalesPerMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>(BusinessSalesPerMonthDocument, options);
        }
export type BusinessSalesPerMonthQueryHookResult = ReturnType<typeof useBusinessSalesPerMonthQuery>;
export type BusinessSalesPerMonthLazyQueryHookResult = ReturnType<typeof useBusinessSalesPerMonthLazyQuery>;
export type BusinessSalesPerMonthSuspenseQueryHookResult = ReturnType<typeof useBusinessSalesPerMonthSuspenseQuery>;
export type BusinessSalesPerMonthQueryResult = Apollo.QueryResult<BusinessSalesPerMonthQuery, BusinessSalesPerMonthQueryVariables>;
export const BusinessSalesThisMonthDocument = gql`
    query BusinessSalesThisMonth {
  BusinessSalesThisMonth {
    month
    count
    sales
    delivered_sales
  }
}
    `;

/**
 * __useBusinessSalesThisMonthQuery__
 *
 * To run a query within a React component, call `useBusinessSalesThisMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessSalesThisMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessSalesThisMonthQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessSalesThisMonthQuery(baseOptions?: Apollo.QueryHookOptions<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>(BusinessSalesThisMonthDocument, options);
      }
export function useBusinessSalesThisMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>(BusinessSalesThisMonthDocument, options);
        }
export function useBusinessSalesThisMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>(BusinessSalesThisMonthDocument, options);
        }
export type BusinessSalesThisMonthQueryHookResult = ReturnType<typeof useBusinessSalesThisMonthQuery>;
export type BusinessSalesThisMonthLazyQueryHookResult = ReturnType<typeof useBusinessSalesThisMonthLazyQuery>;
export type BusinessSalesThisMonthSuspenseQueryHookResult = ReturnType<typeof useBusinessSalesThisMonthSuspenseQuery>;
export type BusinessSalesThisMonthQueryResult = Apollo.QueryResult<BusinessSalesThisMonthQuery, BusinessSalesThisMonthQueryVariables>;
export const BusinessUndeliveredOrderedProductsDocument = gql`
    query BusinessUndeliveredOrderedProducts($creator_id: ID!) {
  BusinessUndeliveredOrderedProducts(creator_id: $creator_id) {
    id
    status
    live_talk_status
    creator_id
    order_id
    product_id
    is_sent_reminder_delivery_1day_ago_mail
    is_sent_reminder_delivery_1hour_ago_mail
    is_sent_reminder_delivery_after_mail
    created_at
    updated_at
    delivered_at
    delivery_limit_date
    is_delivered
    is_processing
    is_undelivered
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    order {
      id
      delivered_at
      paid_at
      movie_seconds
      status
      user {
        id
        status
        name
        email
        twitter_username
        created_at
        updated_at
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    product {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    latest_delivered_product {
      id
      ordered_product_id
      delivered_product_url
      delivered_product_thumbnail_url
      delivered_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useBusinessUndeliveredOrderedProductsQuery__
 *
 * To run a query within a React component, call `useBusinessUndeliveredOrderedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUndeliveredOrderedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUndeliveredOrderedProductsQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useBusinessUndeliveredOrderedProductsQuery(baseOptions: Apollo.QueryHookOptions<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables> & ({ variables: BusinessUndeliveredOrderedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables>(BusinessUndeliveredOrderedProductsDocument, options);
      }
export function useBusinessUndeliveredOrderedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables>(BusinessUndeliveredOrderedProductsDocument, options);
        }
export function useBusinessUndeliveredOrderedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables>(BusinessUndeliveredOrderedProductsDocument, options);
        }
export type BusinessUndeliveredOrderedProductsQueryHookResult = ReturnType<typeof useBusinessUndeliveredOrderedProductsQuery>;
export type BusinessUndeliveredOrderedProductsLazyQueryHookResult = ReturnType<typeof useBusinessUndeliveredOrderedProductsLazyQuery>;
export type BusinessUndeliveredOrderedProductsSuspenseQueryHookResult = ReturnType<typeof useBusinessUndeliveredOrderedProductsSuspenseQuery>;
export type BusinessUndeliveredOrderedProductsQueryResult = Apollo.QueryResult<BusinessUndeliveredOrderedProductsQuery, BusinessUndeliveredOrderedProductsQueryVariables>;
export const UserCreateVideoChatRoomTokenDocument = gql`
    query UserCreateVideoChatRoomToken($product_id: ID!) {
  UserCreateVideoChatRoomToken(product_id: $product_id)
}
    `;

/**
 * __useUserCreateVideoChatRoomTokenQuery__
 *
 * To run a query within a React component, call `useUserCreateVideoChatRoomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreateVideoChatRoomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreateVideoChatRoomTokenQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useUserCreateVideoChatRoomTokenQuery(baseOptions: Apollo.QueryHookOptions<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables> & ({ variables: UserCreateVideoChatRoomTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables>(UserCreateVideoChatRoomTokenDocument, options);
      }
export function useUserCreateVideoChatRoomTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables>(UserCreateVideoChatRoomTokenDocument, options);
        }
export function useUserCreateVideoChatRoomTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables>(UserCreateVideoChatRoomTokenDocument, options);
        }
export type UserCreateVideoChatRoomTokenQueryHookResult = ReturnType<typeof useUserCreateVideoChatRoomTokenQuery>;
export type UserCreateVideoChatRoomTokenLazyQueryHookResult = ReturnType<typeof useUserCreateVideoChatRoomTokenLazyQuery>;
export type UserCreateVideoChatRoomTokenSuspenseQueryHookResult = ReturnType<typeof useUserCreateVideoChatRoomTokenSuspenseQuery>;
export type UserCreateVideoChatRoomTokenQueryResult = Apollo.QueryResult<UserCreateVideoChatRoomTokenQuery, UserCreateVideoChatRoomTokenQueryVariables>;
export const CreatorInBusinessDocument = gql`
    query CreatorInBusiness($id: ID!) {
  CreatorInBusiness(id: $id) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useCreatorInBusinessQuery__
 *
 * To run a query within a React component, call `useCreatorInBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorInBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorInBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreatorInBusinessQuery(baseOptions: Apollo.QueryHookOptions<CreatorInBusinessQuery, CreatorInBusinessQueryVariables> & ({ variables: CreatorInBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorInBusinessQuery, CreatorInBusinessQueryVariables>(CreatorInBusinessDocument, options);
      }
export function useCreatorInBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorInBusinessQuery, CreatorInBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorInBusinessQuery, CreatorInBusinessQueryVariables>(CreatorInBusinessDocument, options);
        }
export function useCreatorInBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorInBusinessQuery, CreatorInBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorInBusinessQuery, CreatorInBusinessQueryVariables>(CreatorInBusinessDocument, options);
        }
export type CreatorInBusinessQueryHookResult = ReturnType<typeof useCreatorInBusinessQuery>;
export type CreatorInBusinessLazyQueryHookResult = ReturnType<typeof useCreatorInBusinessLazyQuery>;
export type CreatorInBusinessSuspenseQueryHookResult = ReturnType<typeof useCreatorInBusinessSuspenseQuery>;
export type CreatorInBusinessQueryResult = Apollo.QueryResult<CreatorInBusinessQuery, CreatorInBusinessQueryVariables>;
export const CreatorMovieDeliveryProductUploadUrlDocument = gql`
    query CreatorMovieDeliveryProductUploadUrl($ordered_product_id: ID!) {
  CreatorMovieDeliveryProductUploadUrl(ordered_product_id: $ordered_product_id) {
    upload_url
    upload_file_path
  }
}
    `;

/**
 * __useCreatorMovieDeliveryProductUploadUrlQuery__
 *
 * To run a query within a React component, call `useCreatorMovieDeliveryProductUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorMovieDeliveryProductUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorMovieDeliveryProductUploadUrlQuery({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useCreatorMovieDeliveryProductUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables> & ({ variables: CreatorMovieDeliveryProductUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables>(CreatorMovieDeliveryProductUploadUrlDocument, options);
      }
export function useCreatorMovieDeliveryProductUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables>(CreatorMovieDeliveryProductUploadUrlDocument, options);
        }
export function useCreatorMovieDeliveryProductUploadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables>(CreatorMovieDeliveryProductUploadUrlDocument, options);
        }
export type CreatorMovieDeliveryProductUploadUrlQueryHookResult = ReturnType<typeof useCreatorMovieDeliveryProductUploadUrlQuery>;
export type CreatorMovieDeliveryProductUploadUrlLazyQueryHookResult = ReturnType<typeof useCreatorMovieDeliveryProductUploadUrlLazyQuery>;
export type CreatorMovieDeliveryProductUploadUrlSuspenseQueryHookResult = ReturnType<typeof useCreatorMovieDeliveryProductUploadUrlSuspenseQuery>;
export type CreatorMovieDeliveryProductUploadUrlQueryResult = Apollo.QueryResult<CreatorMovieDeliveryProductUploadUrlQuery, CreatorMovieDeliveryProductUploadUrlQueryVariables>;
export const CreatorOrderedProductDocument = gql`
    query CreatorOrderedProduct($ordered_product_id: ID!) {
  CreatorOrderedProduct(ordered_product_id: $ordered_product_id) {
    id
    status
    live_talk_status
    creator_id
    order_id
    product_id
    is_sent_reminder_delivery_1day_ago_mail
    is_sent_reminder_delivery_1hour_ago_mail
    is_sent_reminder_delivery_after_mail
    created_at
    updated_at
    delivered_at
    delivery_limit_date
    is_delivered
    is_processing
    is_undelivered
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    order {
      id
      delivered_at
      paid_at
      movie_seconds
      status
      user {
        id
        status
        name
        email
        twitter_username
        created_at
        updated_at
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    product {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    latest_delivered_product {
      id
      ordered_product_id
      delivered_product_url
      delivered_product_thumbnail_url
      delivered_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useCreatorOrderedProductQuery__
 *
 * To run a query within a React component, call `useCreatorOrderedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorOrderedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorOrderedProductQuery({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useCreatorOrderedProductQuery(baseOptions: Apollo.QueryHookOptions<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables> & ({ variables: CreatorOrderedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables>(CreatorOrderedProductDocument, options);
      }
export function useCreatorOrderedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables>(CreatorOrderedProductDocument, options);
        }
export function useCreatorOrderedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables>(CreatorOrderedProductDocument, options);
        }
export type CreatorOrderedProductQueryHookResult = ReturnType<typeof useCreatorOrderedProductQuery>;
export type CreatorOrderedProductLazyQueryHookResult = ReturnType<typeof useCreatorOrderedProductLazyQuery>;
export type CreatorOrderedProductSuspenseQueryHookResult = ReturnType<typeof useCreatorOrderedProductSuspenseQuery>;
export type CreatorOrderedProductQueryResult = Apollo.QueryResult<CreatorOrderedProductQuery, CreatorOrderedProductQueryVariables>;
export const CreatorProductDocument = gql`
    query CreatorProduct($product_id: ID!) {
  CreatorProduct(product_id: $product_id) {
    id
    name
    creator_id
    status
    price
    special_price
    stock
    remaining_stock
    sold_outed
    thumbnail_image
    released_at
    product_type
    product_type_name
    movie_seconds
    created_at
    updated_at
    deleted_at
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    is_movie
    is_photo
    is_live_talk
    live_talk {
      product_id
      started_at
      talk_minutes
    }
  }
}
    `;

/**
 * __useCreatorProductQuery__
 *
 * To run a query within a React component, call `useCreatorProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorProductQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useCreatorProductQuery(baseOptions: Apollo.QueryHookOptions<CreatorProductQuery, CreatorProductQueryVariables> & ({ variables: CreatorProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorProductQuery, CreatorProductQueryVariables>(CreatorProductDocument, options);
      }
export function useCreatorProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorProductQuery, CreatorProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorProductQuery, CreatorProductQueryVariables>(CreatorProductDocument, options);
        }
export function useCreatorProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorProductQuery, CreatorProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorProductQuery, CreatorProductQueryVariables>(CreatorProductDocument, options);
        }
export type CreatorProductQueryHookResult = ReturnType<typeof useCreatorProductQuery>;
export type CreatorProductLazyQueryHookResult = ReturnType<typeof useCreatorProductLazyQuery>;
export type CreatorProductSuspenseQueryHookResult = ReturnType<typeof useCreatorProductSuspenseQuery>;
export type CreatorProductQueryResult = Apollo.QueryResult<CreatorProductQuery, CreatorProductQueryVariables>;
export const CreatorPurchaseUserRankingDocument = gql`
    query CreatorPurchaseUserRanking {
  CreatorPurchaseUserRanking {
    user_id
    user_name
    twitter_username
    amount
    purchase_count
  }
}
    `;

/**
 * __useCreatorPurchaseUserRankingQuery__
 *
 * To run a query within a React component, call `useCreatorPurchaseUserRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorPurchaseUserRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorPurchaseUserRankingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreatorPurchaseUserRankingQuery(baseOptions?: Apollo.QueryHookOptions<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>(CreatorPurchaseUserRankingDocument, options);
      }
export function useCreatorPurchaseUserRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>(CreatorPurchaseUserRankingDocument, options);
        }
export function useCreatorPurchaseUserRankingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>(CreatorPurchaseUserRankingDocument, options);
        }
export type CreatorPurchaseUserRankingQueryHookResult = ReturnType<typeof useCreatorPurchaseUserRankingQuery>;
export type CreatorPurchaseUserRankingLazyQueryHookResult = ReturnType<typeof useCreatorPurchaseUserRankingLazyQuery>;
export type CreatorPurchaseUserRankingSuspenseQueryHookResult = ReturnType<typeof useCreatorPurchaseUserRankingSuspenseQuery>;
export type CreatorPurchaseUserRankingQueryResult = Apollo.QueryResult<CreatorPurchaseUserRankingQuery, CreatorPurchaseUserRankingQueryVariables>;
export const CreatorRankingOfDailySalesCountDocument = gql`
    query CreatorRankingOfDailySalesCount($input: CreatorRankingInput!) {
  CreatorRankingOfDailySalesCount(input: $input) {
    rank
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
  }
}
    `;

/**
 * __useCreatorRankingOfDailySalesCountQuery__
 *
 * To run a query within a React component, call `useCreatorRankingOfDailySalesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorRankingOfDailySalesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorRankingOfDailySalesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorRankingOfDailySalesCountQuery(baseOptions: Apollo.QueryHookOptions<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables> & ({ variables: CreatorRankingOfDailySalesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables>(CreatorRankingOfDailySalesCountDocument, options);
      }
export function useCreatorRankingOfDailySalesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables>(CreatorRankingOfDailySalesCountDocument, options);
        }
export function useCreatorRankingOfDailySalesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables>(CreatorRankingOfDailySalesCountDocument, options);
        }
export type CreatorRankingOfDailySalesCountQueryHookResult = ReturnType<typeof useCreatorRankingOfDailySalesCountQuery>;
export type CreatorRankingOfDailySalesCountLazyQueryHookResult = ReturnType<typeof useCreatorRankingOfDailySalesCountLazyQuery>;
export type CreatorRankingOfDailySalesCountSuspenseQueryHookResult = ReturnType<typeof useCreatorRankingOfDailySalesCountSuspenseQuery>;
export type CreatorRankingOfDailySalesCountQueryResult = Apollo.QueryResult<CreatorRankingOfDailySalesCountQuery, CreatorRankingOfDailySalesCountQueryVariables>;
export const CreatorRankingOfMonthlySalesCountDocument = gql`
    query CreatorRankingOfMonthlySalesCount($input: CreatorRankingInput!) {
  CreatorRankingOfMonthlySalesCount(input: $input) {
    rank
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
  }
}
    `;

/**
 * __useCreatorRankingOfMonthlySalesCountQuery__
 *
 * To run a query within a React component, call `useCreatorRankingOfMonthlySalesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorRankingOfMonthlySalesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorRankingOfMonthlySalesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorRankingOfMonthlySalesCountQuery(baseOptions: Apollo.QueryHookOptions<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables> & ({ variables: CreatorRankingOfMonthlySalesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables>(CreatorRankingOfMonthlySalesCountDocument, options);
      }
export function useCreatorRankingOfMonthlySalesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables>(CreatorRankingOfMonthlySalesCountDocument, options);
        }
export function useCreatorRankingOfMonthlySalesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables>(CreatorRankingOfMonthlySalesCountDocument, options);
        }
export type CreatorRankingOfMonthlySalesCountQueryHookResult = ReturnType<typeof useCreatorRankingOfMonthlySalesCountQuery>;
export type CreatorRankingOfMonthlySalesCountLazyQueryHookResult = ReturnType<typeof useCreatorRankingOfMonthlySalesCountLazyQuery>;
export type CreatorRankingOfMonthlySalesCountSuspenseQueryHookResult = ReturnType<typeof useCreatorRankingOfMonthlySalesCountSuspenseQuery>;
export type CreatorRankingOfMonthlySalesCountQueryResult = Apollo.QueryResult<CreatorRankingOfMonthlySalesCountQuery, CreatorRankingOfMonthlySalesCountQueryVariables>;
export const CreatorRankingOfWeeklySalesCountDocument = gql`
    query CreatorRankingOfWeeklySalesCount($input: CreatorRankingInput!) {
  CreatorRankingOfWeeklySalesCount(input: $input) {
    rank
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
  }
}
    `;

/**
 * __useCreatorRankingOfWeeklySalesCountQuery__
 *
 * To run a query within a React component, call `useCreatorRankingOfWeeklySalesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorRankingOfWeeklySalesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorRankingOfWeeklySalesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorRankingOfWeeklySalesCountQuery(baseOptions: Apollo.QueryHookOptions<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables> & ({ variables: CreatorRankingOfWeeklySalesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables>(CreatorRankingOfWeeklySalesCountDocument, options);
      }
export function useCreatorRankingOfWeeklySalesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables>(CreatorRankingOfWeeklySalesCountDocument, options);
        }
export function useCreatorRankingOfWeeklySalesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables>(CreatorRankingOfWeeklySalesCountDocument, options);
        }
export type CreatorRankingOfWeeklySalesCountQueryHookResult = ReturnType<typeof useCreatorRankingOfWeeklySalesCountQuery>;
export type CreatorRankingOfWeeklySalesCountLazyQueryHookResult = ReturnType<typeof useCreatorRankingOfWeeklySalesCountLazyQuery>;
export type CreatorRankingOfWeeklySalesCountSuspenseQueryHookResult = ReturnType<typeof useCreatorRankingOfWeeklySalesCountSuspenseQuery>;
export type CreatorRankingOfWeeklySalesCountQueryResult = Apollo.QueryResult<CreatorRankingOfWeeklySalesCountQuery, CreatorRankingOfWeeklySalesCountQueryVariables>;
export const CreatorSaleThisMonthDocument = gql`
    query CreatorSaleThisMonth($creator_id: ID!) {
  CreatorSaleThisMonth(creator_id: $creator_id) {
    month
    count
    sales
    delivered_sales
  }
}
    `;

/**
 * __useCreatorSaleThisMonthQuery__
 *
 * To run a query within a React component, call `useCreatorSaleThisMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorSaleThisMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorSaleThisMonthQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useCreatorSaleThisMonthQuery(baseOptions: Apollo.QueryHookOptions<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables> & ({ variables: CreatorSaleThisMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables>(CreatorSaleThisMonthDocument, options);
      }
export function useCreatorSaleThisMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables>(CreatorSaleThisMonthDocument, options);
        }
export function useCreatorSaleThisMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables>(CreatorSaleThisMonthDocument, options);
        }
export type CreatorSaleThisMonthQueryHookResult = ReturnType<typeof useCreatorSaleThisMonthQuery>;
export type CreatorSaleThisMonthLazyQueryHookResult = ReturnType<typeof useCreatorSaleThisMonthLazyQuery>;
export type CreatorSaleThisMonthSuspenseQueryHookResult = ReturnType<typeof useCreatorSaleThisMonthSuspenseQuery>;
export type CreatorSaleThisMonthQueryResult = Apollo.QueryResult<CreatorSaleThisMonthQuery, CreatorSaleThisMonthQueryVariables>;
export const CreatorSalesPerMonthDocument = gql`
    query CreatorSalesPerMonth($creator_id: ID!) {
  CreatorSalesPerMonth(creator_id: $creator_id) {
    sales_per_month {
      month
      count
      sales
      delivered_sales
    }
    total_sales
  }
}
    `;

/**
 * __useCreatorSalesPerMonthQuery__
 *
 * To run a query within a React component, call `useCreatorSalesPerMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorSalesPerMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorSalesPerMonthQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function useCreatorSalesPerMonthQuery(baseOptions: Apollo.QueryHookOptions<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables> & ({ variables: CreatorSalesPerMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables>(CreatorSalesPerMonthDocument, options);
      }
export function useCreatorSalesPerMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables>(CreatorSalesPerMonthDocument, options);
        }
export function useCreatorSalesPerMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables>(CreatorSalesPerMonthDocument, options);
        }
export type CreatorSalesPerMonthQueryHookResult = ReturnType<typeof useCreatorSalesPerMonthQuery>;
export type CreatorSalesPerMonthLazyQueryHookResult = ReturnType<typeof useCreatorSalesPerMonthLazyQuery>;
export type CreatorSalesPerMonthSuspenseQueryHookResult = ReturnType<typeof useCreatorSalesPerMonthSuspenseQuery>;
export type CreatorSalesPerMonthQueryResult = Apollo.QueryResult<CreatorSalesPerMonthQuery, CreatorSalesPerMonthQueryVariables>;
export const CreatorSalesPerMonthInYearDocument = gql`
    query CreatorSalesPerMonthInYear($input: CreatorSalesPerMonthInYearInput!) {
  CreatorSalesPerMonthInYear(input: $input) {
    month
    count
    sales
    delivered_sales
  }
}
    `;

/**
 * __useCreatorSalesPerMonthInYearQuery__
 *
 * To run a query within a React component, call `useCreatorSalesPerMonthInYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorSalesPerMonthInYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorSalesPerMonthInYearQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatorSalesPerMonthInYearQuery(baseOptions: Apollo.QueryHookOptions<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables> & ({ variables: CreatorSalesPerMonthInYearQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables>(CreatorSalesPerMonthInYearDocument, options);
      }
export function useCreatorSalesPerMonthInYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables>(CreatorSalesPerMonthInYearDocument, options);
        }
export function useCreatorSalesPerMonthInYearSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables>(CreatorSalesPerMonthInYearDocument, options);
        }
export type CreatorSalesPerMonthInYearQueryHookResult = ReturnType<typeof useCreatorSalesPerMonthInYearQuery>;
export type CreatorSalesPerMonthInYearLazyQueryHookResult = ReturnType<typeof useCreatorSalesPerMonthInYearLazyQuery>;
export type CreatorSalesPerMonthInYearSuspenseQueryHookResult = ReturnType<typeof useCreatorSalesPerMonthInYearSuspenseQuery>;
export type CreatorSalesPerMonthInYearQueryResult = Apollo.QueryResult<CreatorSalesPerMonthInYearQuery, CreatorSalesPerMonthInYearQueryVariables>;
export const CreatorUndeliveredOrderedProductsDocument = gql`
    query CreatorUndeliveredOrderedProducts {
  CreatorUndeliveredOrderedProducts {
    id
    status
    live_talk_status
    creator_id
    order_id
    product_id
    is_sent_reminder_delivery_1day_ago_mail
    is_sent_reminder_delivery_1hour_ago_mail
    is_sent_reminder_delivery_after_mail
    created_at
    updated_at
    delivered_at
    delivery_limit_date
    is_delivered
    is_processing
    is_undelivered
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    order {
      id
      delivered_at
      paid_at
      movie_seconds
      status
      user {
        id
        status
        name
        email
        twitter_username
        created_at
        updated_at
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    product {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    latest_delivered_product {
      id
      ordered_product_id
      delivered_product_url
      delivered_product_thumbnail_url
      delivered_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useCreatorUndeliveredOrderedProductsQuery__
 *
 * To run a query within a React component, call `useCreatorUndeliveredOrderedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorUndeliveredOrderedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorUndeliveredOrderedProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreatorUndeliveredOrderedProductsQuery(baseOptions?: Apollo.QueryHookOptions<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>(CreatorUndeliveredOrderedProductsDocument, options);
      }
export function useCreatorUndeliveredOrderedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>(CreatorUndeliveredOrderedProductsDocument, options);
        }
export function useCreatorUndeliveredOrderedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>(CreatorUndeliveredOrderedProductsDocument, options);
        }
export type CreatorUndeliveredOrderedProductsQueryHookResult = ReturnType<typeof useCreatorUndeliveredOrderedProductsQuery>;
export type CreatorUndeliveredOrderedProductsLazyQueryHookResult = ReturnType<typeof useCreatorUndeliveredOrderedProductsLazyQuery>;
export type CreatorUndeliveredOrderedProductsSuspenseQueryHookResult = ReturnType<typeof useCreatorUndeliveredOrderedProductsSuspenseQuery>;
export type CreatorUndeliveredOrderedProductsQueryResult = Apollo.QueryResult<CreatorUndeliveredOrderedProductsQuery, CreatorUndeliveredOrderedProductsQueryVariables>;
export const CreatorsInAffiliationDocument = gql`
    query CreatorsInAffiliation($affiliation_id: ID) {
  CreatorsInAffiliation(affiliation_id: $affiliation_id) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useCreatorsInAffiliationQuery__
 *
 * To run a query within a React component, call `useCreatorsInAffiliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorsInAffiliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorsInAffiliationQuery({
 *   variables: {
 *      affiliation_id: // value for 'affiliation_id'
 *   },
 * });
 */
export function useCreatorsInAffiliationQuery(baseOptions?: Apollo.QueryHookOptions<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>(CreatorsInAffiliationDocument, options);
      }
export function useCreatorsInAffiliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>(CreatorsInAffiliationDocument, options);
        }
export function useCreatorsInAffiliationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>(CreatorsInAffiliationDocument, options);
        }
export type CreatorsInAffiliationQueryHookResult = ReturnType<typeof useCreatorsInAffiliationQuery>;
export type CreatorsInAffiliationLazyQueryHookResult = ReturnType<typeof useCreatorsInAffiliationLazyQuery>;
export type CreatorsInAffiliationSuspenseQueryHookResult = ReturnType<typeof useCreatorsInAffiliationSuspenseQuery>;
export type CreatorsInAffiliationQueryResult = Apollo.QueryResult<CreatorsInAffiliationQuery, CreatorsInAffiliationQueryVariables>;
export const CurrentBusinessUserDocument = gql`
    query CurrentBusinessUser {
  CurrentBusinessUser {
    id
    name
    email
    created_at
    updated_at
  }
}
    `;

/**
 * __useCurrentBusinessUserQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBusinessUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>(CurrentBusinessUserDocument, options);
      }
export function useCurrentBusinessUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>(CurrentBusinessUserDocument, options);
        }
export function useCurrentBusinessUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>(CurrentBusinessUserDocument, options);
        }
export type CurrentBusinessUserQueryHookResult = ReturnType<typeof useCurrentBusinessUserQuery>;
export type CurrentBusinessUserLazyQueryHookResult = ReturnType<typeof useCurrentBusinessUserLazyQuery>;
export type CurrentBusinessUserSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessUserSuspenseQuery>;
export type CurrentBusinessUserQueryResult = Apollo.QueryResult<CurrentBusinessUserQuery, CurrentBusinessUserQueryVariables>;
export const CurrentCreatorDocument = gql`
    query CurrentCreator {
  CurrentCreator {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useCurrentCreatorQuery__
 *
 * To run a query within a React component, call `useCurrentCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCreatorQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentCreatorQuery(baseOptions?: Apollo.QueryHookOptions<CurrentCreatorQuery, CurrentCreatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentCreatorQuery, CurrentCreatorQueryVariables>(CurrentCreatorDocument, options);
      }
export function useCurrentCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentCreatorQuery, CurrentCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentCreatorQuery, CurrentCreatorQueryVariables>(CurrentCreatorDocument, options);
        }
export function useCurrentCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentCreatorQuery, CurrentCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentCreatorQuery, CurrentCreatorQueryVariables>(CurrentCreatorDocument, options);
        }
export type CurrentCreatorQueryHookResult = ReturnType<typeof useCurrentCreatorQuery>;
export type CurrentCreatorLazyQueryHookResult = ReturnType<typeof useCurrentCreatorLazyQuery>;
export type CurrentCreatorSuspenseQueryHookResult = ReturnType<typeof useCurrentCreatorSuspenseQuery>;
export type CurrentCreatorQueryResult = Apollo.QueryResult<CurrentCreatorQuery, CurrentCreatorQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  CurrentUser {
    id
    status
    name
    email
    twitter_username
    created_at
    updated_at
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GenerateTemporaryUrlForFilteredMonthlySalesDocument = gql`
    query GenerateTemporaryUrlForFilteredMonthlySales($input: GenerateTemporaryUrlForFilteredMonthlySalesInput!) {
  GenerateTemporaryUrlForFilteredMonthlySales(input: $input)
}
    `;

/**
 * __useGenerateTemporaryUrlForFilteredMonthlySalesQuery__
 *
 * To run a query within a React component, call `useGenerateTemporaryUrlForFilteredMonthlySalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTemporaryUrlForFilteredMonthlySalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTemporaryUrlForFilteredMonthlySalesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTemporaryUrlForFilteredMonthlySalesQuery(baseOptions: Apollo.QueryHookOptions<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables> & ({ variables: GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables>(GenerateTemporaryUrlForFilteredMonthlySalesDocument, options);
      }
export function useGenerateTemporaryUrlForFilteredMonthlySalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables>(GenerateTemporaryUrlForFilteredMonthlySalesDocument, options);
        }
export function useGenerateTemporaryUrlForFilteredMonthlySalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables>(GenerateTemporaryUrlForFilteredMonthlySalesDocument, options);
        }
export type GenerateTemporaryUrlForFilteredMonthlySalesQueryHookResult = ReturnType<typeof useGenerateTemporaryUrlForFilteredMonthlySalesQuery>;
export type GenerateTemporaryUrlForFilteredMonthlySalesLazyQueryHookResult = ReturnType<typeof useGenerateTemporaryUrlForFilteredMonthlySalesLazyQuery>;
export type GenerateTemporaryUrlForFilteredMonthlySalesSuspenseQueryHookResult = ReturnType<typeof useGenerateTemporaryUrlForFilteredMonthlySalesSuspenseQuery>;
export type GenerateTemporaryUrlForFilteredMonthlySalesQueryResult = Apollo.QueryResult<GenerateTemporaryUrlForFilteredMonthlySalesQuery, GenerateTemporaryUrlForFilteredMonthlySalesQueryVariables>;
export const GenerateTemporaryUrlForFilteredMonthlySalesByCreatorDocument = gql`
    query GenerateTemporaryUrlForFilteredMonthlySalesByCreator($input: GenerateTemporaryUrlForFilteredMonthlySalesByCreatorInput!) {
  GenerateTemporaryUrlForFilteredMonthlySalesByCreator(input: $input)
}
    `;

/**
 * __useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery__
 *
 * To run a query within a React component, call `useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery(baseOptions: Apollo.QueryHookOptions<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables> & ({ variables: GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables>(GenerateTemporaryUrlForFilteredMonthlySalesByCreatorDocument, options);
      }
export function useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables>(GenerateTemporaryUrlForFilteredMonthlySalesByCreatorDocument, options);
        }
export function useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables>(GenerateTemporaryUrlForFilteredMonthlySalesByCreatorDocument, options);
        }
export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryHookResult = ReturnType<typeof useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery>;
export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorLazyQueryHookResult = ReturnType<typeof useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorLazyQuery>;
export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorSuspenseQueryHookResult = ReturnType<typeof useGenerateTemporaryUrlForFilteredMonthlySalesByCreatorSuspenseQuery>;
export type GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryResult = Apollo.QueryResult<GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQuery, GenerateTemporaryUrlForFilteredMonthlySalesByCreatorQueryVariables>;
export const MovieDeliveryProductUploadUrlDocument = gql`
    query MovieDeliveryProductUploadUrl($ordered_product_id: ID!) {
  MovieDeliveryProductUploadUrl(ordered_product_id: $ordered_product_id) {
    upload_url
    upload_file_path
  }
}
    `;

/**
 * __useMovieDeliveryProductUploadUrlQuery__
 *
 * To run a query within a React component, call `useMovieDeliveryProductUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieDeliveryProductUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieDeliveryProductUploadUrlQuery({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useMovieDeliveryProductUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables> & ({ variables: MovieDeliveryProductUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables>(MovieDeliveryProductUploadUrlDocument, options);
      }
export function useMovieDeliveryProductUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables>(MovieDeliveryProductUploadUrlDocument, options);
        }
export function useMovieDeliveryProductUploadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables>(MovieDeliveryProductUploadUrlDocument, options);
        }
export type MovieDeliveryProductUploadUrlQueryHookResult = ReturnType<typeof useMovieDeliveryProductUploadUrlQuery>;
export type MovieDeliveryProductUploadUrlLazyQueryHookResult = ReturnType<typeof useMovieDeliveryProductUploadUrlLazyQuery>;
export type MovieDeliveryProductUploadUrlSuspenseQueryHookResult = ReturnType<typeof useMovieDeliveryProductUploadUrlSuspenseQuery>;
export type MovieDeliveryProductUploadUrlQueryResult = Apollo.QueryResult<MovieDeliveryProductUploadUrlQuery, MovieDeliveryProductUploadUrlQueryVariables>;
export const PagedActiveCreatorsDocument = gql`
    query PagedActiveCreators($input: ActiveCreatorsInput!, $first: Int!, $page: Int) {
  PagedActiveCreators(input: $input, first: $first, page: $page) {
    data {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __usePagedActiveCreatorsQuery__
 *
 * To run a query within a React component, call `usePagedActiveCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedActiveCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedActiveCreatorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedActiveCreatorsQuery(baseOptions: Apollo.QueryHookOptions<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables> & ({ variables: PagedActiveCreatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables>(PagedActiveCreatorsDocument, options);
      }
export function usePagedActiveCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables>(PagedActiveCreatorsDocument, options);
        }
export function usePagedActiveCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables>(PagedActiveCreatorsDocument, options);
        }
export type PagedActiveCreatorsQueryHookResult = ReturnType<typeof usePagedActiveCreatorsQuery>;
export type PagedActiveCreatorsLazyQueryHookResult = ReturnType<typeof usePagedActiveCreatorsLazyQuery>;
export type PagedActiveCreatorsSuspenseQueryHookResult = ReturnType<typeof usePagedActiveCreatorsSuspenseQuery>;
export type PagedActiveCreatorsQueryResult = Apollo.QueryResult<PagedActiveCreatorsQuery, PagedActiveCreatorsQueryVariables>;
export const PagedAffiliationsInBusinessDocument = gql`
    query PagedAffiliationsInBusiness($first: Int!, $page: Int) {
  PagedAffiliationsInBusiness(first: $first, page: $page) {
    data {
      id
      name
      creators_count
      created_at
      updated_at
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedAffiliationsInBusinessQuery__
 *
 * To run a query within a React component, call `usePagedAffiliationsInBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedAffiliationsInBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedAffiliationsInBusinessQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedAffiliationsInBusinessQuery(baseOptions: Apollo.QueryHookOptions<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables> & ({ variables: PagedAffiliationsInBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables>(PagedAffiliationsInBusinessDocument, options);
      }
export function usePagedAffiliationsInBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables>(PagedAffiliationsInBusinessDocument, options);
        }
export function usePagedAffiliationsInBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables>(PagedAffiliationsInBusinessDocument, options);
        }
export type PagedAffiliationsInBusinessQueryHookResult = ReturnType<typeof usePagedAffiliationsInBusinessQuery>;
export type PagedAffiliationsInBusinessLazyQueryHookResult = ReturnType<typeof usePagedAffiliationsInBusinessLazyQuery>;
export type PagedAffiliationsInBusinessSuspenseQueryHookResult = ReturnType<typeof usePagedAffiliationsInBusinessSuspenseQuery>;
export type PagedAffiliationsInBusinessQueryResult = Apollo.QueryResult<PagedAffiliationsInBusinessQuery, PagedAffiliationsInBusinessQueryVariables>;
export const PagedBusinessDeliveredOrderedProductPerUserDocument = gql`
    query PagedBusinessDeliveredOrderedProductPerUser($page: Int, $first: Int!, $user_id: ID!, $creator_id: ID!) {
  PagedBusinessDeliveredOrderedProductPerUser(
    first: $first
    page: $page
    user_id: $user_id
    creator_id: $creator_id
  ) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivered_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
      latest_delivered_product {
        id
        ordered_product_id
        delivered_product_url
        delivered_product_thumbnail_url
        delivered_at
        created_at
        updated_at
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessDeliveredOrderedProductPerUserQuery__
 *
 * To run a query within a React component, call `usePagedBusinessDeliveredOrderedProductPerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessDeliveredOrderedProductPerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessDeliveredOrderedProductPerUserQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      user_id: // value for 'user_id'
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function usePagedBusinessDeliveredOrderedProductPerUserQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables> & ({ variables: PagedBusinessDeliveredOrderedProductPerUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables>(PagedBusinessDeliveredOrderedProductPerUserDocument, options);
      }
export function usePagedBusinessDeliveredOrderedProductPerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables>(PagedBusinessDeliveredOrderedProductPerUserDocument, options);
        }
export function usePagedBusinessDeliveredOrderedProductPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables>(PagedBusinessDeliveredOrderedProductPerUserDocument, options);
        }
export type PagedBusinessDeliveredOrderedProductPerUserQueryHookResult = ReturnType<typeof usePagedBusinessDeliveredOrderedProductPerUserQuery>;
export type PagedBusinessDeliveredOrderedProductPerUserLazyQueryHookResult = ReturnType<typeof usePagedBusinessDeliveredOrderedProductPerUserLazyQuery>;
export type PagedBusinessDeliveredOrderedProductPerUserSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessDeliveredOrderedProductPerUserSuspenseQuery>;
export type PagedBusinessDeliveredOrderedProductPerUserQueryResult = Apollo.QueryResult<PagedBusinessDeliveredOrderedProductPerUserQuery, PagedBusinessDeliveredOrderedProductPerUserQueryVariables>;
export const PagedBusinessDeliveredOrderedProductsDocument = gql`
    query PagedBusinessDeliveredOrderedProducts($creator_id: ID!, $page: Int, $first: Int!) {
  PagedBusinessDeliveredOrderedProducts(
    creator_id: $creator_id
    first: $first
    page: $page
  ) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivered_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
      latest_delivered_product {
        id
        ordered_product_id
        delivered_product_url
        delivered_product_thumbnail_url
        delivered_at
        created_at
        updated_at
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessDeliveredOrderedProductsQuery__
 *
 * To run a query within a React component, call `usePagedBusinessDeliveredOrderedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessDeliveredOrderedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessDeliveredOrderedProductsQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedBusinessDeliveredOrderedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables> & ({ variables: PagedBusinessDeliveredOrderedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables>(PagedBusinessDeliveredOrderedProductsDocument, options);
      }
export function usePagedBusinessDeliveredOrderedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables>(PagedBusinessDeliveredOrderedProductsDocument, options);
        }
export function usePagedBusinessDeliveredOrderedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables>(PagedBusinessDeliveredOrderedProductsDocument, options);
        }
export type PagedBusinessDeliveredOrderedProductsQueryHookResult = ReturnType<typeof usePagedBusinessDeliveredOrderedProductsQuery>;
export type PagedBusinessDeliveredOrderedProductsLazyQueryHookResult = ReturnType<typeof usePagedBusinessDeliveredOrderedProductsLazyQuery>;
export type PagedBusinessDeliveredOrderedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessDeliveredOrderedProductsSuspenseQuery>;
export type PagedBusinessDeliveredOrderedProductsQueryResult = Apollo.QueryResult<PagedBusinessDeliveredOrderedProductsQuery, PagedBusinessDeliveredOrderedProductsQueryVariables>;
export const PagedBusinessDisabledProductsDocument = gql`
    query PagedBusinessDisabledProducts($creator_id: ID!, $page: Int, $first: Int!) {
  PagedBusinessDisabledProducts(
    creator_id: $creator_id
    first: $first
    page: $page
  ) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessDisabledProductsQuery__
 *
 * To run a query within a React component, call `usePagedBusinessDisabledProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessDisabledProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessDisabledProductsQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedBusinessDisabledProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables> & ({ variables: PagedBusinessDisabledProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables>(PagedBusinessDisabledProductsDocument, options);
      }
export function usePagedBusinessDisabledProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables>(PagedBusinessDisabledProductsDocument, options);
        }
export function usePagedBusinessDisabledProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables>(PagedBusinessDisabledProductsDocument, options);
        }
export type PagedBusinessDisabledProductsQueryHookResult = ReturnType<typeof usePagedBusinessDisabledProductsQuery>;
export type PagedBusinessDisabledProductsLazyQueryHookResult = ReturnType<typeof usePagedBusinessDisabledProductsLazyQuery>;
export type PagedBusinessDisabledProductsSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessDisabledProductsSuspenseQuery>;
export type PagedBusinessDisabledProductsQueryResult = Apollo.QueryResult<PagedBusinessDisabledProductsQuery, PagedBusinessDisabledProductsQueryVariables>;
export const PagedBusinessOrderedUsersDocument = gql`
    query PagedBusinessOrderedUsers($page: Int, $first: Int!, $sort: String, $creator_id: ID!) {
  PagedBusinessOrderedUsers(
    first: $first
    page: $page
    sort: $sort
    creator_id: $creator_id
  ) {
    data {
      user_id
      user_name
      last_paid_at
      number_of_purchases
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessOrderedUsersQuery__
 *
 * To run a query within a React component, call `usePagedBusinessOrderedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessOrderedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessOrderedUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function usePagedBusinessOrderedUsersQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables> & ({ variables: PagedBusinessOrderedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables>(PagedBusinessOrderedUsersDocument, options);
      }
export function usePagedBusinessOrderedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables>(PagedBusinessOrderedUsersDocument, options);
        }
export function usePagedBusinessOrderedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables>(PagedBusinessOrderedUsersDocument, options);
        }
export type PagedBusinessOrderedUsersQueryHookResult = ReturnType<typeof usePagedBusinessOrderedUsersQuery>;
export type PagedBusinessOrderedUsersLazyQueryHookResult = ReturnType<typeof usePagedBusinessOrderedUsersLazyQuery>;
export type PagedBusinessOrderedUsersSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessOrderedUsersSuspenseQuery>;
export type PagedBusinessOrderedUsersQueryResult = Apollo.QueryResult<PagedBusinessOrderedUsersQuery, PagedBusinessOrderedUsersQueryVariables>;
export const PagedBusinessPublishedProductsDocument = gql`
    query PagedBusinessPublishedProducts($creator_id: ID!, $exclude_product_id: ID, $page: Int, $first: Int!) {
  PagedBusinessPublishedProducts(
    creator_id: $creator_id
    exclude_product_id: $exclude_product_id
    first: $first
    page: $page
  ) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessPublishedProductsQuery__
 *
 * To run a query within a React component, call `usePagedBusinessPublishedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessPublishedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessPublishedProductsQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      exclude_product_id: // value for 'exclude_product_id'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedBusinessPublishedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables> & ({ variables: PagedBusinessPublishedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables>(PagedBusinessPublishedProductsDocument, options);
      }
export function usePagedBusinessPublishedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables>(PagedBusinessPublishedProductsDocument, options);
        }
export function usePagedBusinessPublishedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables>(PagedBusinessPublishedProductsDocument, options);
        }
export type PagedBusinessPublishedProductsQueryHookResult = ReturnType<typeof usePagedBusinessPublishedProductsQuery>;
export type PagedBusinessPublishedProductsLazyQueryHookResult = ReturnType<typeof usePagedBusinessPublishedProductsLazyQuery>;
export type PagedBusinessPublishedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessPublishedProductsSuspenseQuery>;
export type PagedBusinessPublishedProductsQueryResult = Apollo.QueryResult<PagedBusinessPublishedProductsQuery, PagedBusinessPublishedProductsQueryVariables>;
export const PagedBusinessReservedProductsDocument = gql`
    query PagedBusinessReservedProducts($creator_id: ID!, $first: Int!, $page: Int) {
  PagedBusinessReservedProducts(
    creator_id: $creator_id
    first: $first
    page: $page
  ) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessReservedProductsQuery__
 *
 * To run a query within a React component, call `usePagedBusinessReservedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessReservedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessReservedProductsQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedBusinessReservedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables> & ({ variables: PagedBusinessReservedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables>(PagedBusinessReservedProductsDocument, options);
      }
export function usePagedBusinessReservedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables>(PagedBusinessReservedProductsDocument, options);
        }
export function usePagedBusinessReservedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables>(PagedBusinessReservedProductsDocument, options);
        }
export type PagedBusinessReservedProductsQueryHookResult = ReturnType<typeof usePagedBusinessReservedProductsQuery>;
export type PagedBusinessReservedProductsLazyQueryHookResult = ReturnType<typeof usePagedBusinessReservedProductsLazyQuery>;
export type PagedBusinessReservedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessReservedProductsSuspenseQuery>;
export type PagedBusinessReservedProductsQueryResult = Apollo.QueryResult<PagedBusinessReservedProductsQuery, PagedBusinessReservedProductsQueryVariables>;
export const PagedBusinessUndeliveredOrderedProductPerUserDocument = gql`
    query PagedBusinessUndeliveredOrderedProductPerUser($page: Int, $first: Int!, $user_id: ID!, $creator_id: ID!) {
  PagedBusinessUndeliveredOrderedProductPerUser(
    first: $first
    page: $page
    user_id: $user_id
    creator_id: $creator_id
  ) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedBusinessUndeliveredOrderedProductPerUserQuery__
 *
 * To run a query within a React component, call `usePagedBusinessUndeliveredOrderedProductPerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedBusinessUndeliveredOrderedProductPerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedBusinessUndeliveredOrderedProductPerUserQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      user_id: // value for 'user_id'
 *      creator_id: // value for 'creator_id'
 *   },
 * });
 */
export function usePagedBusinessUndeliveredOrderedProductPerUserQuery(baseOptions: Apollo.QueryHookOptions<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables> & ({ variables: PagedBusinessUndeliveredOrderedProductPerUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables>(PagedBusinessUndeliveredOrderedProductPerUserDocument, options);
      }
export function usePagedBusinessUndeliveredOrderedProductPerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables>(PagedBusinessUndeliveredOrderedProductPerUserDocument, options);
        }
export function usePagedBusinessUndeliveredOrderedProductPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables>(PagedBusinessUndeliveredOrderedProductPerUserDocument, options);
        }
export type PagedBusinessUndeliveredOrderedProductPerUserQueryHookResult = ReturnType<typeof usePagedBusinessUndeliveredOrderedProductPerUserQuery>;
export type PagedBusinessUndeliveredOrderedProductPerUserLazyQueryHookResult = ReturnType<typeof usePagedBusinessUndeliveredOrderedProductPerUserLazyQuery>;
export type PagedBusinessUndeliveredOrderedProductPerUserSuspenseQueryHookResult = ReturnType<typeof usePagedBusinessUndeliveredOrderedProductPerUserSuspenseQuery>;
export type PagedBusinessUndeliveredOrderedProductPerUserQueryResult = Apollo.QueryResult<PagedBusinessUndeliveredOrderedProductPerUserQuery, PagedBusinessUndeliveredOrderedProductPerUserQueryVariables>;
export const PagedCreatorDeliveredOrderedProductPerUserDocument = gql`
    query PagedCreatorDeliveredOrderedProductPerUser($page: Int, $first: Int!, $user_id: ID!) {
  PagedCreatorDeliveredOrderedProductPerUser(
    first: $first
    page: $page
    user_id: $user_id
  ) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivered_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
      latest_delivered_product {
        id
        ordered_product_id
        delivered_product_url
        delivered_product_thumbnail_url
        delivered_at
        created_at
        updated_at
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorDeliveredOrderedProductPerUserQuery__
 *
 * To run a query within a React component, call `usePagedCreatorDeliveredOrderedProductPerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorDeliveredOrderedProductPerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorDeliveredOrderedProductPerUserQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function usePagedCreatorDeliveredOrderedProductPerUserQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables> & ({ variables: PagedCreatorDeliveredOrderedProductPerUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables>(PagedCreatorDeliveredOrderedProductPerUserDocument, options);
      }
export function usePagedCreatorDeliveredOrderedProductPerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables>(PagedCreatorDeliveredOrderedProductPerUserDocument, options);
        }
export function usePagedCreatorDeliveredOrderedProductPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables>(PagedCreatorDeliveredOrderedProductPerUserDocument, options);
        }
export type PagedCreatorDeliveredOrderedProductPerUserQueryHookResult = ReturnType<typeof usePagedCreatorDeliveredOrderedProductPerUserQuery>;
export type PagedCreatorDeliveredOrderedProductPerUserLazyQueryHookResult = ReturnType<typeof usePagedCreatorDeliveredOrderedProductPerUserLazyQuery>;
export type PagedCreatorDeliveredOrderedProductPerUserSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorDeliveredOrderedProductPerUserSuspenseQuery>;
export type PagedCreatorDeliveredOrderedProductPerUserQueryResult = Apollo.QueryResult<PagedCreatorDeliveredOrderedProductPerUserQuery, PagedCreatorDeliveredOrderedProductPerUserQueryVariables>;
export const PagedCreatorDeliveredOrderedProductsDocument = gql`
    query PagedCreatorDeliveredOrderedProducts($page: Int, $first: Int!) {
  PagedCreatorDeliveredOrderedProducts(first: $first, page: $page) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivered_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
      latest_delivered_product {
        id
        ordered_product_id
        delivered_product_url
        delivered_product_thumbnail_url
        delivered_at
        created_at
        updated_at
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorDeliveredOrderedProductsQuery__
 *
 * To run a query within a React component, call `usePagedCreatorDeliveredOrderedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorDeliveredOrderedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorDeliveredOrderedProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedCreatorDeliveredOrderedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables> & ({ variables: PagedCreatorDeliveredOrderedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables>(PagedCreatorDeliveredOrderedProductsDocument, options);
      }
export function usePagedCreatorDeliveredOrderedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables>(PagedCreatorDeliveredOrderedProductsDocument, options);
        }
export function usePagedCreatorDeliveredOrderedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables>(PagedCreatorDeliveredOrderedProductsDocument, options);
        }
export type PagedCreatorDeliveredOrderedProductsQueryHookResult = ReturnType<typeof usePagedCreatorDeliveredOrderedProductsQuery>;
export type PagedCreatorDeliveredOrderedProductsLazyQueryHookResult = ReturnType<typeof usePagedCreatorDeliveredOrderedProductsLazyQuery>;
export type PagedCreatorDeliveredOrderedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorDeliveredOrderedProductsSuspenseQuery>;
export type PagedCreatorDeliveredOrderedProductsQueryResult = Apollo.QueryResult<PagedCreatorDeliveredOrderedProductsQuery, PagedCreatorDeliveredOrderedProductsQueryVariables>;
export const PagedCreatorDisabledProductsDocument = gql`
    query PagedCreatorDisabledProducts($page: Int, $first: Int!) {
  PagedCreatorDisabledProducts(first: $first, page: $page) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorDisabledProductsQuery__
 *
 * To run a query within a React component, call `usePagedCreatorDisabledProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorDisabledProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorDisabledProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedCreatorDisabledProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables> & ({ variables: PagedCreatorDisabledProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables>(PagedCreatorDisabledProductsDocument, options);
      }
export function usePagedCreatorDisabledProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables>(PagedCreatorDisabledProductsDocument, options);
        }
export function usePagedCreatorDisabledProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables>(PagedCreatorDisabledProductsDocument, options);
        }
export type PagedCreatorDisabledProductsQueryHookResult = ReturnType<typeof usePagedCreatorDisabledProductsQuery>;
export type PagedCreatorDisabledProductsLazyQueryHookResult = ReturnType<typeof usePagedCreatorDisabledProductsLazyQuery>;
export type PagedCreatorDisabledProductsSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorDisabledProductsSuspenseQuery>;
export type PagedCreatorDisabledProductsQueryResult = Apollo.QueryResult<PagedCreatorDisabledProductsQuery, PagedCreatorDisabledProductsQueryVariables>;
export const PagedCreatorOrderedUsersDocument = gql`
    query PagedCreatorOrderedUsers($page: Int, $first: Int!, $sort: String) {
  PagedCreatorOrderedUsers(first: $first, page: $page, sort: $sort) {
    data {
      user_id
      user_name
      last_paid_at
      number_of_purchases
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorOrderedUsersQuery__
 *
 * To run a query within a React component, call `usePagedCreatorOrderedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorOrderedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorOrderedUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePagedCreatorOrderedUsersQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables> & ({ variables: PagedCreatorOrderedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables>(PagedCreatorOrderedUsersDocument, options);
      }
export function usePagedCreatorOrderedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables>(PagedCreatorOrderedUsersDocument, options);
        }
export function usePagedCreatorOrderedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables>(PagedCreatorOrderedUsersDocument, options);
        }
export type PagedCreatorOrderedUsersQueryHookResult = ReturnType<typeof usePagedCreatorOrderedUsersQuery>;
export type PagedCreatorOrderedUsersLazyQueryHookResult = ReturnType<typeof usePagedCreatorOrderedUsersLazyQuery>;
export type PagedCreatorOrderedUsersSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorOrderedUsersSuspenseQuery>;
export type PagedCreatorOrderedUsersQueryResult = Apollo.QueryResult<PagedCreatorOrderedUsersQuery, PagedCreatorOrderedUsersQueryVariables>;
export const PagedCreatorPublishedProductsDocument = gql`
    query PagedCreatorPublishedProducts($exclude_product_id: ID!, $page: Int, $first: Int!) {
  PagedCreatorPublishedProducts(
    exclude_product_id: $exclude_product_id
    first: $first
    page: $page
  ) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorPublishedProductsQuery__
 *
 * To run a query within a React component, call `usePagedCreatorPublishedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorPublishedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorPublishedProductsQuery({
 *   variables: {
 *      exclude_product_id: // value for 'exclude_product_id'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedCreatorPublishedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables> & ({ variables: PagedCreatorPublishedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables>(PagedCreatorPublishedProductsDocument, options);
      }
export function usePagedCreatorPublishedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables>(PagedCreatorPublishedProductsDocument, options);
        }
export function usePagedCreatorPublishedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables>(PagedCreatorPublishedProductsDocument, options);
        }
export type PagedCreatorPublishedProductsQueryHookResult = ReturnType<typeof usePagedCreatorPublishedProductsQuery>;
export type PagedCreatorPublishedProductsLazyQueryHookResult = ReturnType<typeof usePagedCreatorPublishedProductsLazyQuery>;
export type PagedCreatorPublishedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorPublishedProductsSuspenseQuery>;
export type PagedCreatorPublishedProductsQueryResult = Apollo.QueryResult<PagedCreatorPublishedProductsQuery, PagedCreatorPublishedProductsQueryVariables>;
export const PagedCreatorReservedProductsDocument = gql`
    query PagedCreatorReservedProducts($page: Int, $first: Int!) {
  PagedCreatorReservedProducts(first: $first, page: $page) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      created_at
      updated_at
      deleted_at
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorReservedProductsQuery__
 *
 * To run a query within a React component, call `usePagedCreatorReservedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorReservedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorReservedProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedCreatorReservedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables> & ({ variables: PagedCreatorReservedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables>(PagedCreatorReservedProductsDocument, options);
      }
export function usePagedCreatorReservedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables>(PagedCreatorReservedProductsDocument, options);
        }
export function usePagedCreatorReservedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables>(PagedCreatorReservedProductsDocument, options);
        }
export type PagedCreatorReservedProductsQueryHookResult = ReturnType<typeof usePagedCreatorReservedProductsQuery>;
export type PagedCreatorReservedProductsLazyQueryHookResult = ReturnType<typeof usePagedCreatorReservedProductsLazyQuery>;
export type PagedCreatorReservedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorReservedProductsSuspenseQuery>;
export type PagedCreatorReservedProductsQueryResult = Apollo.QueryResult<PagedCreatorReservedProductsQuery, PagedCreatorReservedProductsQueryVariables>;
export const PagedCreatorSalesPerMonthBreakdownDocument = gql`
    query PagedCreatorSalesPerMonthBreakdown($input: PagedCreatorSalesPerMonthBreakdownInput!, $first: Int!, $page: Int) {
  PagedCreatorSalesPerMonthBreakdown(input: $input, first: $first, page: $page) {
    data {
      delivered_at
      paid_at
      user_name
      product_name
      product_type
      product_type_name
      movie_seconds
      started_at
      talk_minutes
      order_id
      sales
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __usePagedCreatorSalesPerMonthBreakdownQuery__
 *
 * To run a query within a React component, call `usePagedCreatorSalesPerMonthBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorSalesPerMonthBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorSalesPerMonthBreakdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedCreatorSalesPerMonthBreakdownQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables> & ({ variables: PagedCreatorSalesPerMonthBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables>(PagedCreatorSalesPerMonthBreakdownDocument, options);
      }
export function usePagedCreatorSalesPerMonthBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables>(PagedCreatorSalesPerMonthBreakdownDocument, options);
        }
export function usePagedCreatorSalesPerMonthBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables>(PagedCreatorSalesPerMonthBreakdownDocument, options);
        }
export type PagedCreatorSalesPerMonthBreakdownQueryHookResult = ReturnType<typeof usePagedCreatorSalesPerMonthBreakdownQuery>;
export type PagedCreatorSalesPerMonthBreakdownLazyQueryHookResult = ReturnType<typeof usePagedCreatorSalesPerMonthBreakdownLazyQuery>;
export type PagedCreatorSalesPerMonthBreakdownSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorSalesPerMonthBreakdownSuspenseQuery>;
export type PagedCreatorSalesPerMonthBreakdownQueryResult = Apollo.QueryResult<PagedCreatorSalesPerMonthBreakdownQuery, PagedCreatorSalesPerMonthBreakdownQueryVariables>;
export const PagedCreatorUndeliveredOrderedProductPerUserDocument = gql`
    query PagedCreatorUndeliveredOrderedProductPerUser($page: Int, $first: Int!, $user_id: ID!) {
  PagedCreatorUndeliveredOrderedProductPerUser(
    first: $first
    page: $page
    user_id: $user_id
  ) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedCreatorUndeliveredOrderedProductPerUserQuery__
 *
 * To run a query within a React component, call `usePagedCreatorUndeliveredOrderedProductPerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorUndeliveredOrderedProductPerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorUndeliveredOrderedProductPerUserQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function usePagedCreatorUndeliveredOrderedProductPerUserQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables> & ({ variables: PagedCreatorUndeliveredOrderedProductPerUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables>(PagedCreatorUndeliveredOrderedProductPerUserDocument, options);
      }
export function usePagedCreatorUndeliveredOrderedProductPerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables>(PagedCreatorUndeliveredOrderedProductPerUserDocument, options);
        }
export function usePagedCreatorUndeliveredOrderedProductPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables>(PagedCreatorUndeliveredOrderedProductPerUserDocument, options);
        }
export type PagedCreatorUndeliveredOrderedProductPerUserQueryHookResult = ReturnType<typeof usePagedCreatorUndeliveredOrderedProductPerUserQuery>;
export type PagedCreatorUndeliveredOrderedProductPerUserLazyQueryHookResult = ReturnType<typeof usePagedCreatorUndeliveredOrderedProductPerUserLazyQuery>;
export type PagedCreatorUndeliveredOrderedProductPerUserSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorUndeliveredOrderedProductPerUserSuspenseQuery>;
export type PagedCreatorUndeliveredOrderedProductPerUserQueryResult = Apollo.QueryResult<PagedCreatorUndeliveredOrderedProductPerUserQuery, PagedCreatorUndeliveredOrderedProductPerUserQueryVariables>;
export const PagedCreatorsInBusinessDocument = gql`
    query PagedCreatorsInBusiness($first: Int!, $page: Int) {
  PagedCreatorsInBusiness(first: $first, page: $page) {
    data {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __usePagedCreatorsInBusinessQuery__
 *
 * To run a query within a React component, call `usePagedCreatorsInBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCreatorsInBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCreatorsInBusinessQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedCreatorsInBusinessQuery(baseOptions: Apollo.QueryHookOptions<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables> & ({ variables: PagedCreatorsInBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables>(PagedCreatorsInBusinessDocument, options);
      }
export function usePagedCreatorsInBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables>(PagedCreatorsInBusinessDocument, options);
        }
export function usePagedCreatorsInBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables>(PagedCreatorsInBusinessDocument, options);
        }
export type PagedCreatorsInBusinessQueryHookResult = ReturnType<typeof usePagedCreatorsInBusinessQuery>;
export type PagedCreatorsInBusinessLazyQueryHookResult = ReturnType<typeof usePagedCreatorsInBusinessLazyQuery>;
export type PagedCreatorsInBusinessSuspenseQueryHookResult = ReturnType<typeof usePagedCreatorsInBusinessSuspenseQuery>;
export type PagedCreatorsInBusinessQueryResult = Apollo.QueryResult<PagedCreatorsInBusinessQuery, PagedCreatorsInBusinessQueryVariables>;
export const PagedProductsOnSaleDocument = gql`
    query PagedProductsOnSale($first: Int!, $page: Int) {
  PagedProductsOnSale(first: $first, page: $page) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedProductsOnSaleQuery__
 *
 * To run a query within a React component, call `usePagedProductsOnSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedProductsOnSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedProductsOnSaleQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedProductsOnSaleQuery(baseOptions: Apollo.QueryHookOptions<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables> & ({ variables: PagedProductsOnSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables>(PagedProductsOnSaleDocument, options);
      }
export function usePagedProductsOnSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables>(PagedProductsOnSaleDocument, options);
        }
export function usePagedProductsOnSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables>(PagedProductsOnSaleDocument, options);
        }
export type PagedProductsOnSaleQueryHookResult = ReturnType<typeof usePagedProductsOnSaleQuery>;
export type PagedProductsOnSaleLazyQueryHookResult = ReturnType<typeof usePagedProductsOnSaleLazyQuery>;
export type PagedProductsOnSaleSuspenseQueryHookResult = ReturnType<typeof usePagedProductsOnSaleSuspenseQuery>;
export type PagedProductsOnSaleQueryResult = Apollo.QueryResult<PagedProductsOnSaleQuery, PagedProductsOnSaleQueryVariables>;
export const PagedPublishedProductsDocument = gql`
    query PagedPublishedProducts($creator_id: ID!, $exclude_product_id: ID, $page: Int, $first: Int!) {
  PagedPublishedProducts(
    creator_id: $creator_id
    exclude_product_id: $exclude_product_id
    first: $first
    page: $page
  ) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedPublishedProductsQuery__
 *
 * To run a query within a React component, call `usePagedPublishedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedPublishedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedPublishedProductsQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      exclude_product_id: // value for 'exclude_product_id'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedPublishedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables> & ({ variables: PagedPublishedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables>(PagedPublishedProductsDocument, options);
      }
export function usePagedPublishedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables>(PagedPublishedProductsDocument, options);
        }
export function usePagedPublishedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables>(PagedPublishedProductsDocument, options);
        }
export type PagedPublishedProductsQueryHookResult = ReturnType<typeof usePagedPublishedProductsQuery>;
export type PagedPublishedProductsLazyQueryHookResult = ReturnType<typeof usePagedPublishedProductsLazyQuery>;
export type PagedPublishedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedPublishedProductsSuspenseQuery>;
export type PagedPublishedProductsQueryResult = Apollo.QueryResult<PagedPublishedProductsQuery, PagedPublishedProductsQueryVariables>;
export const PagedSalesPerOrderDocument = gql`
    query PagedSalesPerOrder($has_all_affiliation: Boolean, $affiliation_id: ID, $creator_id: ID, $input: SalesInput!, $first: Int!, $page: Int) {
  PagedSalesPerOrder(
    has_all_affiliation: $has_all_affiliation
    affiliation_id: $affiliation_id
    creator_id: $creator_id
    input: $input
    first: $first
    page: $page
  ) {
    data {
      delivered_at
      paid_at
      user_name
      product_name
      creator_name
      product_type
      product_type_name
      movie_seconds
      started_at
      talk_minutes
      order_id
      sales
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __usePagedSalesPerOrderQuery__
 *
 * To run a query within a React component, call `usePagedSalesPerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedSalesPerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedSalesPerOrderQuery({
 *   variables: {
 *      has_all_affiliation: // value for 'has_all_affiliation'
 *      affiliation_id: // value for 'affiliation_id'
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedSalesPerOrderQuery(baseOptions: Apollo.QueryHookOptions<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables> & ({ variables: PagedSalesPerOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables>(PagedSalesPerOrderDocument, options);
      }
export function usePagedSalesPerOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables>(PagedSalesPerOrderDocument, options);
        }
export function usePagedSalesPerOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables>(PagedSalesPerOrderDocument, options);
        }
export type PagedSalesPerOrderQueryHookResult = ReturnType<typeof usePagedSalesPerOrderQuery>;
export type PagedSalesPerOrderLazyQueryHookResult = ReturnType<typeof usePagedSalesPerOrderLazyQuery>;
export type PagedSalesPerOrderSuspenseQueryHookResult = ReturnType<typeof usePagedSalesPerOrderSuspenseQuery>;
export type PagedSalesPerOrderQueryResult = Apollo.QueryResult<PagedSalesPerOrderQuery, PagedSalesPerOrderQueryVariables>;
export const PagedUserActiveCreatorsFavoritedDocument = gql`
    query PagedUserActiveCreatorsFavorited($first: Int!, $page: Int) {
  PagedUserActiveCreatorsFavorited(first: $first, page: $page) {
    data {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __usePagedUserActiveCreatorsFavoritedQuery__
 *
 * To run a query within a React component, call `usePagedUserActiveCreatorsFavoritedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedUserActiveCreatorsFavoritedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedUserActiveCreatorsFavoritedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePagedUserActiveCreatorsFavoritedQuery(baseOptions: Apollo.QueryHookOptions<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables> & ({ variables: PagedUserActiveCreatorsFavoritedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables>(PagedUserActiveCreatorsFavoritedDocument, options);
      }
export function usePagedUserActiveCreatorsFavoritedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables>(PagedUserActiveCreatorsFavoritedDocument, options);
        }
export function usePagedUserActiveCreatorsFavoritedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables>(PagedUserActiveCreatorsFavoritedDocument, options);
        }
export type PagedUserActiveCreatorsFavoritedQueryHookResult = ReturnType<typeof usePagedUserActiveCreatorsFavoritedQuery>;
export type PagedUserActiveCreatorsFavoritedLazyQueryHookResult = ReturnType<typeof usePagedUserActiveCreatorsFavoritedLazyQuery>;
export type PagedUserActiveCreatorsFavoritedSuspenseQueryHookResult = ReturnType<typeof usePagedUserActiveCreatorsFavoritedSuspenseQuery>;
export type PagedUserActiveCreatorsFavoritedQueryResult = Apollo.QueryResult<PagedUserActiveCreatorsFavoritedQuery, PagedUserActiveCreatorsFavoritedQueryVariables>;
export const PagedUserFavoritedCreatorLatestProductsDocument = gql`
    query PagedUserFavoritedCreatorLatestProducts($page: Int, $first: Int!) {
  PagedUserFavoritedCreatorLatestProducts(first: $first, page: $page) {
    data {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedUserFavoritedCreatorLatestProductsQuery__
 *
 * To run a query within a React component, call `usePagedUserFavoritedCreatorLatestProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedUserFavoritedCreatorLatestProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedUserFavoritedCreatorLatestProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedUserFavoritedCreatorLatestProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables> & ({ variables: PagedUserFavoritedCreatorLatestProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables>(PagedUserFavoritedCreatorLatestProductsDocument, options);
      }
export function usePagedUserFavoritedCreatorLatestProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables>(PagedUserFavoritedCreatorLatestProductsDocument, options);
        }
export function usePagedUserFavoritedCreatorLatestProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables>(PagedUserFavoritedCreatorLatestProductsDocument, options);
        }
export type PagedUserFavoritedCreatorLatestProductsQueryHookResult = ReturnType<typeof usePagedUserFavoritedCreatorLatestProductsQuery>;
export type PagedUserFavoritedCreatorLatestProductsLazyQueryHookResult = ReturnType<typeof usePagedUserFavoritedCreatorLatestProductsLazyQuery>;
export type PagedUserFavoritedCreatorLatestProductsSuspenseQueryHookResult = ReturnType<typeof usePagedUserFavoritedCreatorLatestProductsSuspenseQuery>;
export type PagedUserFavoritedCreatorLatestProductsQueryResult = Apollo.QueryResult<PagedUserFavoritedCreatorLatestProductsQuery, PagedUserFavoritedCreatorLatestProductsQueryVariables>;
export const PagedUserPurchasedProductsDocument = gql`
    query PagedUserPurchasedProducts($page: Int, $first: Int!) {
  PagedUserPurchasedProducts(first: $first, page: $page) {
    data {
      id
      status
      live_talk_status
      creator_id
      order_id
      product_id
      is_sent_reminder_delivery_1day_ago_mail
      is_sent_reminder_delivery_1hour_ago_mail
      is_sent_reminder_delivery_after_mail
      created_at
      updated_at
      delivery_limit_date
      is_delivered
      is_processing
      is_undelivered
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      order {
        id
        delivered_at
        paid_at
        movie_seconds
        status
        user {
          id
          status
          name
          email
          twitter_username
          created_at
          updated_at
        }
        product {
          id
          name
          creator_id
          status
          price
          special_price
          stock
          remaining_stock
          sold_outed
          thumbnail_image
          released_at
          product_type
          product_type_name
          movie_seconds
          created_at
          updated_at
          deleted_at
          creator {
            id
            business_id
            affiliation_id
            status
            icon_url
            name
            email
            profile
            twitter_username
            instagram_username
            youtube_channel_url
            kindle_author_url
            left_at
            created_at
            updated_at
            status_name
            is_favorite
            affiliation {
              id
              name
              creators_count
              created_at
              updated_at
            }
            favorite_users_count
          }
          is_movie
          is_photo
          is_live_talk
          live_talk {
            product_id
            started_at
            talk_minutes
          }
        }
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
      latest_delivered_product {
        id
        ordered_product_id
        delivered_product_url
        delivered_product_thumbnail_url
        delivered_at
        created_at
        updated_at
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __usePagedUserPurchasedProductsQuery__
 *
 * To run a query within a React component, call `usePagedUserPurchasedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedUserPurchasedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedUserPurchasedProductsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePagedUserPurchasedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables> & ({ variables: PagedUserPurchasedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables>(PagedUserPurchasedProductsDocument, options);
      }
export function usePagedUserPurchasedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables>(PagedUserPurchasedProductsDocument, options);
        }
export function usePagedUserPurchasedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables>(PagedUserPurchasedProductsDocument, options);
        }
export type PagedUserPurchasedProductsQueryHookResult = ReturnType<typeof usePagedUserPurchasedProductsQuery>;
export type PagedUserPurchasedProductsLazyQueryHookResult = ReturnType<typeof usePagedUserPurchasedProductsLazyQuery>;
export type PagedUserPurchasedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedUserPurchasedProductsSuspenseQuery>;
export type PagedUserPurchasedProductsQueryResult = Apollo.QueryResult<PagedUserPurchasedProductsQuery, PagedUserPurchasedProductsQueryVariables>;
export const PublishedProductDocument = gql`
    query PublishedProduct($product_id: ID!) {
  PublishedProduct(product_id: $product_id) {
    id
    name
    creator_id
    status
    price
    special_price
    stock
    remaining_stock
    sold_outed
    thumbnail_image
    released_at
    product_type
    product_type_name
    movie_seconds
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    is_movie
    is_photo
    is_live_talk
    live_talk {
      product_id
      started_at
      talk_minutes
    }
  }
}
    `;

/**
 * __usePublishedProductQuery__
 *
 * To run a query within a React component, call `usePublishedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedProductQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function usePublishedProductQuery(baseOptions: Apollo.QueryHookOptions<PublishedProductQuery, PublishedProductQueryVariables> & ({ variables: PublishedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedProductQuery, PublishedProductQueryVariables>(PublishedProductDocument, options);
      }
export function usePublishedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedProductQuery, PublishedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedProductQuery, PublishedProductQueryVariables>(PublishedProductDocument, options);
        }
export function usePublishedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedProductQuery, PublishedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedProductQuery, PublishedProductQueryVariables>(PublishedProductDocument, options);
        }
export type PublishedProductQueryHookResult = ReturnType<typeof usePublishedProductQuery>;
export type PublishedProductLazyQueryHookResult = ReturnType<typeof usePublishedProductLazyQuery>;
export type PublishedProductSuspenseQueryHookResult = ReturnType<typeof usePublishedProductSuspenseQuery>;
export type PublishedProductQueryResult = Apollo.QueryResult<PublishedProductQuery, PublishedProductQueryVariables>;
export const RecommendedCreatorsDocument = gql`
    query RecommendedCreators($input: RecommendedCreatorsInput!) {
  RecommendedCreators(input: $input) {
    id
    business_id
    affiliation_id
    status
    icon_url
    name
    email
    profile
    twitter_username
    instagram_username
    youtube_channel_url
    kindle_author_url
    left_at
    created_at
    updated_at
    status_name
    is_favorite
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
    favorite_users_count
  }
}
    `;

/**
 * __useRecommendedCreatorsQuery__
 *
 * To run a query within a React component, call `useRecommendedCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedCreatorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecommendedCreatorsQuery(baseOptions: Apollo.QueryHookOptions<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables> & ({ variables: RecommendedCreatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables>(RecommendedCreatorsDocument, options);
      }
export function useRecommendedCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables>(RecommendedCreatorsDocument, options);
        }
export function useRecommendedCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables>(RecommendedCreatorsDocument, options);
        }
export type RecommendedCreatorsQueryHookResult = ReturnType<typeof useRecommendedCreatorsQuery>;
export type RecommendedCreatorsLazyQueryHookResult = ReturnType<typeof useRecommendedCreatorsLazyQuery>;
export type RecommendedCreatorsSuspenseQueryHookResult = ReturnType<typeof useRecommendedCreatorsSuspenseQuery>;
export type RecommendedCreatorsQueryResult = Apollo.QueryResult<RecommendedCreatorsQuery, RecommendedCreatorsQueryVariables>;
export const RequestCreatorDocument = gql`
    query RequestCreator($creator_id: ID!, $input: RequestCreatorInput!) {
  RequestCreator(creator_id: $creator_id, input: $input) {
    id
    business_id
    affiliation_id
    status
    email
    status_name
    affiliation {
      id
      name
      creators_count
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useRequestCreatorQuery__
 *
 * To run a query within a React component, call `useRequestCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestCreatorQuery({
 *   variables: {
 *      creator_id: // value for 'creator_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCreatorQuery(baseOptions: Apollo.QueryHookOptions<RequestCreatorQuery, RequestCreatorQueryVariables> & ({ variables: RequestCreatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestCreatorQuery, RequestCreatorQueryVariables>(RequestCreatorDocument, options);
      }
export function useRequestCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestCreatorQuery, RequestCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestCreatorQuery, RequestCreatorQueryVariables>(RequestCreatorDocument, options);
        }
export function useRequestCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestCreatorQuery, RequestCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestCreatorQuery, RequestCreatorQueryVariables>(RequestCreatorDocument, options);
        }
export type RequestCreatorQueryHookResult = ReturnType<typeof useRequestCreatorQuery>;
export type RequestCreatorLazyQueryHookResult = ReturnType<typeof useRequestCreatorLazyQuery>;
export type RequestCreatorSuspenseQueryHookResult = ReturnType<typeof useRequestCreatorSuspenseQuery>;
export type RequestCreatorQueryResult = Apollo.QueryResult<RequestCreatorQuery, RequestCreatorQueryVariables>;
export const CreatorCreateVideoChatRoomTokenDocument = gql`
    query CreatorCreateVideoChatRoomToken($product_id: ID!) {
  CreatorCreateVideoChatRoomToken(product_id: $product_id)
}
    `;

/**
 * __useCreatorCreateVideoChatRoomTokenQuery__
 *
 * To run a query within a React component, call `useCreatorCreateVideoChatRoomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorCreateVideoChatRoomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorCreateVideoChatRoomTokenQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useCreatorCreateVideoChatRoomTokenQuery(baseOptions: Apollo.QueryHookOptions<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables> & ({ variables: CreatorCreateVideoChatRoomTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables>(CreatorCreateVideoChatRoomTokenDocument, options);
      }
export function useCreatorCreateVideoChatRoomTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables>(CreatorCreateVideoChatRoomTokenDocument, options);
        }
export function useCreatorCreateVideoChatRoomTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables>(CreatorCreateVideoChatRoomTokenDocument, options);
        }
export type CreatorCreateVideoChatRoomTokenQueryHookResult = ReturnType<typeof useCreatorCreateVideoChatRoomTokenQuery>;
export type CreatorCreateVideoChatRoomTokenLazyQueryHookResult = ReturnType<typeof useCreatorCreateVideoChatRoomTokenLazyQuery>;
export type CreatorCreateVideoChatRoomTokenSuspenseQueryHookResult = ReturnType<typeof useCreatorCreateVideoChatRoomTokenSuspenseQuery>;
export type CreatorCreateVideoChatRoomTokenQueryResult = Apollo.QueryResult<CreatorCreateVideoChatRoomTokenQuery, CreatorCreateVideoChatRoomTokenQueryVariables>;
export const UserPurchasedProductDocument = gql`
    query UserPurchasedProduct($ordered_product_id: ID!) {
  UserPurchasedProduct(ordered_product_id: $ordered_product_id) {
    id
    status
    live_talk_status
    creator_id
    order_id
    product_id
    is_sent_reminder_delivery_1day_ago_mail
    is_sent_reminder_delivery_1hour_ago_mail
    is_sent_reminder_delivery_after_mail
    created_at
    updated_at
    delivery_limit_date
    is_delivered
    is_processing
    is_undelivered
    creator {
      id
      business_id
      affiliation_id
      status
      icon_url
      name
      email
      profile
      twitter_username
      instagram_username
      youtube_channel_url
      kindle_author_url
      left_at
      created_at
      updated_at
      status_name
      is_favorite
      affiliation {
        id
        name
        creators_count
        created_at
        updated_at
      }
      favorite_users_count
    }
    order {
      id
      delivered_at
      paid_at
      movie_seconds
      status
      user {
        id
        status
        name
        email
        twitter_username
        created_at
        updated_at
      }
      product {
        id
        name
        creator_id
        status
        price
        special_price
        stock
        remaining_stock
        sold_outed
        thumbnail_image
        released_at
        product_type
        product_type_name
        movie_seconds
        created_at
        updated_at
        deleted_at
        creator {
          id
          business_id
          affiliation_id
          status
          icon_url
          name
          email
          profile
          twitter_username
          instagram_username
          youtube_channel_url
          kindle_author_url
          left_at
          created_at
          updated_at
          status_name
          is_favorite
          affiliation {
            id
            name
            creators_count
            created_at
            updated_at
          }
          favorite_users_count
        }
        is_movie
        is_photo
        is_live_talk
        live_talk {
          product_id
          started_at
          talk_minutes
        }
      }
    }
    product {
      id
      name
      creator_id
      status
      price
      special_price
      stock
      remaining_stock
      sold_outed
      thumbnail_image
      released_at
      product_type
      product_type_name
      movie_seconds
      creator {
        id
        business_id
        affiliation_id
        status
        icon_url
        name
        email
        profile
        twitter_username
        instagram_username
        youtube_channel_url
        kindle_author_url
        left_at
        created_at
        updated_at
        status_name
        is_favorite
        affiliation {
          id
          name
          creators_count
          created_at
          updated_at
        }
        favorite_users_count
      }
      is_movie
      is_photo
      is_live_talk
      live_talk {
        product_id
        started_at
        talk_minutes
      }
    }
    latest_delivered_product {
      id
      ordered_product_id
      delivered_product_url
      delivered_product_thumbnail_url
      temporary_download_url
      delivered_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useUserPurchasedProductQuery__
 *
 * To run a query within a React component, call `useUserPurchasedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPurchasedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPurchasedProductQuery({
 *   variables: {
 *      ordered_product_id: // value for 'ordered_product_id'
 *   },
 * });
 */
export function useUserPurchasedProductQuery(baseOptions: Apollo.QueryHookOptions<UserPurchasedProductQuery, UserPurchasedProductQueryVariables> & ({ variables: UserPurchasedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPurchasedProductQuery, UserPurchasedProductQueryVariables>(UserPurchasedProductDocument, options);
      }
export function useUserPurchasedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPurchasedProductQuery, UserPurchasedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPurchasedProductQuery, UserPurchasedProductQueryVariables>(UserPurchasedProductDocument, options);
        }
export function useUserPurchasedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPurchasedProductQuery, UserPurchasedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPurchasedProductQuery, UserPurchasedProductQueryVariables>(UserPurchasedProductDocument, options);
        }
export type UserPurchasedProductQueryHookResult = ReturnType<typeof useUserPurchasedProductQuery>;
export type UserPurchasedProductLazyQueryHookResult = ReturnType<typeof useUserPurchasedProductLazyQuery>;
export type UserPurchasedProductSuspenseQueryHookResult = ReturnType<typeof useUserPurchasedProductSuspenseQuery>;
export type UserPurchasedProductQueryResult = Apollo.QueryResult<UserPurchasedProductQuery, UserPurchasedProductQueryVariables>;
export const ValidateBusinessUserTokenDocument = gql`
    query ValidateBusinessUserToken {
  ValidateBusinessUserToken
}
    `;

/**
 * __useValidateBusinessUserTokenQuery__
 *
 * To run a query within a React component, call `useValidateBusinessUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBusinessUserTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBusinessUserTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateBusinessUserTokenQuery(baseOptions?: Apollo.QueryHookOptions<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>(ValidateBusinessUserTokenDocument, options);
      }
export function useValidateBusinessUserTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>(ValidateBusinessUserTokenDocument, options);
        }
export function useValidateBusinessUserTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>(ValidateBusinessUserTokenDocument, options);
        }
export type ValidateBusinessUserTokenQueryHookResult = ReturnType<typeof useValidateBusinessUserTokenQuery>;
export type ValidateBusinessUserTokenLazyQueryHookResult = ReturnType<typeof useValidateBusinessUserTokenLazyQuery>;
export type ValidateBusinessUserTokenSuspenseQueryHookResult = ReturnType<typeof useValidateBusinessUserTokenSuspenseQuery>;
export type ValidateBusinessUserTokenQueryResult = Apollo.QueryResult<ValidateBusinessUserTokenQuery, ValidateBusinessUserTokenQueryVariables>;
export const ValidateCreatorTokenDocument = gql`
    query ValidateCreatorToken {
  ValidateCreatorToken
}
    `;

/**
 * __useValidateCreatorTokenQuery__
 *
 * To run a query within a React component, call `useValidateCreatorTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCreatorTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCreatorTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateCreatorTokenQuery(baseOptions?: Apollo.QueryHookOptions<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>(ValidateCreatorTokenDocument, options);
      }
export function useValidateCreatorTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>(ValidateCreatorTokenDocument, options);
        }
export function useValidateCreatorTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>(ValidateCreatorTokenDocument, options);
        }
export type ValidateCreatorTokenQueryHookResult = ReturnType<typeof useValidateCreatorTokenQuery>;
export type ValidateCreatorTokenLazyQueryHookResult = ReturnType<typeof useValidateCreatorTokenLazyQuery>;
export type ValidateCreatorTokenSuspenseQueryHookResult = ReturnType<typeof useValidateCreatorTokenSuspenseQuery>;
export type ValidateCreatorTokenQueryResult = Apollo.QueryResult<ValidateCreatorTokenQuery, ValidateCreatorTokenQueryVariables>;
export const ValidateUserTokenDocument = gql`
    query ValidateUserToken {
  ValidateUserToken
}
    `;

/**
 * __useValidateUserTokenQuery__
 *
 * To run a query within a React component, call `useValidateUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateUserTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateUserTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateUserTokenQuery(baseOptions?: Apollo.QueryHookOptions<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>(ValidateUserTokenDocument, options);
      }
export function useValidateUserTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>(ValidateUserTokenDocument, options);
        }
export function useValidateUserTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>(ValidateUserTokenDocument, options);
        }
export type ValidateUserTokenQueryHookResult = ReturnType<typeof useValidateUserTokenQuery>;
export type ValidateUserTokenLazyQueryHookResult = ReturnType<typeof useValidateUserTokenLazyQuery>;
export type ValidateUserTokenSuspenseQueryHookResult = ReturnType<typeof useValidateUserTokenSuspenseQuery>;
export type ValidateUserTokenQueryResult = Apollo.QueryResult<ValidateUserTokenQuery, ValidateUserTokenQueryVariables>;